<template>
  <v-card flat class="pb-5">
    <v-toolbar v-show="dataLoaded">
      <!-- <h3 class="headline mb-0">Detalii</h3> -->
      <v-toolbar-title>Detalii</v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn icon flat color="blue-grey" @click="_cbResetAll" :ripple="false" :disabled="user.dummy">
        <v-icon>mdi-close</v-icon>
      </v-btn>

      <v-spacer></v-spacer>

      <!-- <v-scale-transition> -->
        <v-btn icon flat color="blue-grey" v-show="isEdited" @click="_cbUndoAll" :ripple="false" :disabled="user.dummy">
          <v-icon>mdi-undo</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
      <!-- </v-scale-transition> -->
      <!-- <v-scale-transition> -->
        <v-btn icon flat color="blue-grey" v-show="isEdited" @click="save" :ripple="false" :disabled="user.dummy">
          <v-icon>mdi-content-save</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
      <!-- </v-scale-transition> -->
      <!-- <v-spacer></v-spacer> -->
      <!-- <v-scale-transition> -->
        <!-- <v-progress-circular
          indeterminate
          size="18"
          width="2"
          color="blue-grey"
          v-show="loading">
        </v-progress-circular> -->
      <!-- </v-scale-transition> -->
      <v-btn icon flat color="blue-grey" @click.stop="_cbRefresh" :ripple="false">
        <v-icon>mdi-refresh</v-icon>
      </v-btn>
      <v-btn icon flat color="blue-grey" @click.stop="_cbOpenSettings" :ripple="false">
        <v-icon>mdi-settings</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card-text class="pa-1" v-if="entityObject" v-show="dataLoaded">
      <v-card class="mb-2" v-if="visibleFields.includes('info adresa')">
        <v-card-title class="accent--text title">Info adresa / poi</v-card-title>
        <v-divider color="accent"></v-divider>
        <v-card-text class="pa-1">
          <v-card class="mb-3">
            <v-system-bar window class="px-1">ID</v-system-bar>
            <v-card-text class="pa-1">
              <v-text-field
                :value="entityObject._id"
                hint="ID in baza de date, folosit doar de catre aplicatie"
                disabled
                persistent-hint
                solo flat>
              </v-text-field>
            </v-card-text>
          </v-card>

          <v-card class="mb-3">
            <v-system-bar window class="px-1">
              Eticheta &nbsp;
              <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('eticheta')" @click="undo('eticheta')" :ripple="false">
                <v-icon small>mdi-undo</v-icon>
              </v-btn>
            </v-system-bar>
            <v-card-text class="pa-1">
              <v-select
                :items="labels"
                hint="Folosita la gruparea simbolurilor / poi-urilor in calupuri. Editabil doar de catre admin."
                v-model="entityObject.eticheta"
                :item-text="etichetaText"
                item-value="label"
                :disabled="!user.admin"
                persistent-hint
                :menu-props="{transition: false}"
                solo flat>
              </v-select>
            </v-card-text>
          </v-card>
          <v-card class="mb-3">
            <v-system-bar window class="px-1">
              Zona &nbsp;
              <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('zona')" @click="undo('zona')" :ripple="false">
                <v-icon small>mdi-undo</v-icon>
              </v-btn>
            </v-system-bar>
            <v-card-text class="pa-1">
              <v-select
                :items="zones"
                hint="Folosita la gruparea simbolurilor / poi-urilor in zone. Editabil doar de catre admin."
                v-model="entityObject.zona"
                :item-text="zonaText"
                item-value="zona"
                :disabled="!user.admin"
                persistent-hint
                :menu-props="{transition: false}"
                solo flat>
              </v-select>
            </v-card-text>
          </v-card>

          <v-card class="mb-3">
            <v-system-bar window class="px-1">
              ID Scara &nbsp;
              <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('id_scara')" @click="undo('id_scara')" :ripple="false">
                <v-icon small>mdi-undo</v-icon>
              </v-btn>
            </v-system-bar>
            <v-card-text class="pa-1">
              <v-text-field
                @input="setField($event, 'id_scara')"
                :value="entityObject.id_scara"
                hint="ID in xlsx, folosit pentru a identifica in mod unic adresa / poi-ul. Editabil doar de catre admin."
                :disabled="!user.admin"
                persistent-hint
                append-icon="mdi-refresh"
                @click:append="refreshIdScara"
                validate-on-blur
                :rules="[val => !!val || 'Camp obligatoriu!']"
                solo flat>
              </v-text-field>
            </v-card-text>
          </v-card>

          <v-card class="mb-3">
            <v-system-bar window class="px-1">
              Adresa &nbsp;
              <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('adresa')" @click="undo('adresa')" :ripple="false">
                <v-icon small>mdi-undo</v-icon>
              </v-btn>
            </v-system-bar>
            <v-card-text class="pa-1">
              <v-text-field
                @input="setField($event, 'adresa')"
                :value="entityObject.adresa"
                hint="Adresa asociata poi-ului. Editabil de catre admin sau de catre user-ul care a adaugat poi-ul."
                :disabled="!user.admin && entityObject.addedBy !== user.username"
                persistent-hint
                validate-on-blur
                :rules="[val => !!val || 'Camp obligatoriu!']"
                solo flat>
              </v-text-field>
            </v-card-text>
          </v-card>

          <v-card class="mb-3">
            <v-system-bar window class="px-1">
              <v-icon small color="error" style="margin-right: 0" @click="resetField('observatii_adresa')">mdi-close</v-icon>

              Observatii adresa &nbsp;
              <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('observatii_adresa')" @click="undo('observatii_adresa')" :ripple="false">
                <v-icon small>mdi-undo</v-icon>
              </v-btn>
            </v-system-bar>
            <v-card-text class="pa-1">
              <v-textarea
                @input="setField($event, 'observatii_adresa')"
                :value="entityObject.observatii_adresa"
                auto-grow
                :rows="1"
                hide-details
                hint="Observatii la adresa."
                persistent-hint
                solo flat
                :disabled="user.dummy">
              </v-textarea>
            </v-card-text>
          </v-card>

          <!-- <v-card class="mb-3">
            <v-system-bar window class="px-1">
              <v-icon small color="error" style="margin-right: 0" @click="resetField('observatii')">mdi-close</v-icon>

              Observatii &nbsp;
              <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('observatii')" @click="undo('observatii')" :ripple="false">
                <v-icon small>mdi-undo</v-icon>
              </v-btn>
            </v-system-bar>
            <v-card-text class="pa-1">
              <v-textarea
                @input="setField($event, 'observatii')"
                :value="entityObject.observatii"
                auto-grow
                :rows="1"
                hide-details
                hint="Observatii generale."
                persistent-hint
                solo flat>
              </v-textarea>
            </v-card-text>
          </v-card> -->

          <v-card class="mb-3">
            <v-system-bar window class="px-1">
              <v-icon small color="error" style="margin-right: 0" @click="resetField('done')">mdi-close</v-icon>
              Done &nbsp;
              <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('done')" @click="undo('done')" :ripple="false">
                <v-icon small>mdi-undo</v-icon>
              </v-btn>
            </v-system-bar>
            <v-card-text class="pa-1">
              <v-radio-group
                row
                v-model="entityObject.done"
                hint="S-a incheiat procesarea acestei adrese / acestui poi?"
                persistent-hint
                :disabled="user.dummy">
                <v-radio label="Da" :value="true" :ripple="false"></v-radio>
                <v-radio label="Nu" :value="false" :ripple="false"></v-radio>
              </v-radio-group>
            </v-card-text>
          </v-card>

          <v-card class="mb-3">
            <v-system-bar window class="px-1">
              Centru geometric &nbsp;
              <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('centru_geometric')" @click="undo('centru_geometric')" :ripple="false">
                <v-icon small>mdi-undo</v-icon>
              </v-btn>
            </v-system-bar>
            <v-card-text class="pa-1">
              <div style="width: 100%; height: 40vh">
                <GmapMap
                  :center="entityObject.centru_geometric"
                  :zoom="zoom"
                  :map-type-id="mapType"
                  :style="{ width: options.width, height: options.height }"
                  ref="map"
                  @zoom_changed="zoomChanged"
                  @maptypeid_changed="mapTypeChanged">

                  <GmapMarker
                    :position="entityObject.centru_geometric"
                    :draggable="!user.dummy"
                    @dragend="_cbDragEnd" />

                </GmapMap>
              </div>
            </v-card-text>
          </v-card>
        </v-card-text>
      </v-card>

      <v-card class="mb-2" v-if="visibleFields.includes('info scara blocului')">
        <v-card-title class="accent--text title">Info scara blocului</v-card-title>
        <v-divider color="accent"></v-divider>
        <v-card-text class="pa-1">
          <!-- <v-card class="mb-3">
            <v-system-bar window class="px-1">
              <v-icon small color="error" style="margin-right: 0" @click="resetField('comert_servicii', 'info_scara_blocului')">mdi-close</v-icon>

              Comert servicii &nbsp;
              <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('comert_servicii', 'info_scara_blocului')" @click="undo('comert_servicii', 'info_scara_blocului')" :ripple="false">
                <v-icon small>mdi-undo</v-icon>
              </v-btn>
            </v-system-bar>
            <v-card-text class="pa-1">
              <v-radio-group
                row
                v-model="entityObject.info_scara_blocului.comert_servicii"
                hint="Exista spatii pentru comert/servicii?"
                persistent-hint
                :disabled="user.dummy">
                <v-radio label="Da" value="Da" :ripple="false"></v-radio>
                <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
              </v-radio-group>
            </v-card-text>
          </v-card> -->

          <!-- <v-card class="mb-3">
            <v-system-bar window class="px-1">
              <v-icon small color="error" style="margin-right: 0" @click="resetField('etaj_tehnic_vizibil', 'info_scara_blocului')">mdi-close</v-icon>

              Etaj tehnic vizibil &nbsp;
              <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('etaj_tehnic_vizibil', 'info_scara_blocului')" @click="undo('etaj_tehnic_vizibil', 'info_scara_blocului')" :ripple="false">
                <v-icon small>mdi-undo</v-icon>
              </v-btn>
            </v-system-bar>
            <v-card-text class="pa-1">
              <v-radio-group
                row
                v-model="entityObject.info_scara_blocului.etaj_tehnic_vizibil"
                hint="Etajul tehnic este vizibil?"
                persistent-hint
                :disabled="user.dummy">
                <v-radio label="Da" value="Da" :ripple="false"></v-radio>
                <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
              </v-radio-group>
            </v-card-text>
          </v-card> -->

          <!-- <v-card class="mb-3">
            <v-system-bar window class="px-1">
              <v-icon small color="error" style="margin-right: 0" @click="resetField('nr_apartamente_pe_scara', 'info_scara_blocului')">mdi-close</v-icon>

              Nr apartamenete pe scara &nbsp;
              <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('nr_apartamente_pe_scara', 'info_scara_blocului')" @click="undo('nr_apartamente_pe_scara', 'info_scara_blocului')" :ripple="false">
                <v-icon small>mdi-undo</v-icon>
              </v-btn>
            </v-system-bar>
            <v-card-text class="pa-1">
              <v-text-field
                @input="setField($event, 'nr_apartamente_pe_scara', 'info_scara_blocului', null, true)"
                :value="entityObject.info_scara_blocului.nr_apartamente_pe_scara"
                hint="Numar apartamente pe scara."
                type="number"
                @wheel="onWheel"
                persistent-hint
                :min="1"
                :max="150"
                validate-on-blur
                :rules="[val => val !== null || 'Camp obligatoriu!', val => (val >=1 && val <= 150) || 'Valoarea introdusa nu se incadreaza in intervalul [1, 150].']"
                solo flat
                :disabled="user.dummy">
              </v-text-field>
            </v-card-text>
          </v-card> -->

          <!-- <v-card class="mb-3">
            <v-system-bar window class="px-1">
              <v-icon small color="error" style="margin-right: 0" @click="resetField('nr_niveluri_comert_servicii', 'info_scara_blocului')">mdi-close</v-icon>

              Niveluri comert &nbsp;
              <v-btn :disabled="entityObject.info_scara_blocului.comert_servicii === 'Nu'" small flat icon v-if="isFieldEdited('nr_niveluri_comert_servicii', 'info_scara_blocului')" @click="undo('nr_niveluri_comert_servicii', 'info_scara_blocului')" :ripple="false">
                <v-icon small>mdi-undo</v-icon>
              </v-btn>
            </v-system-bar>
            <v-card-text class="pa-1">
              <v-radio-group
                row
                v-model="entityObject.info_scara_blocului.nr_niveluri_comert_servicii"
                hint="Nr niveluri comert/servicii."
                persistent-hint
                :disabled="entityObject.info_scara_blocului.comert_servicii === 'Nu' || user.dummy">
                <v-radio label="1" :value="1" :ripple="false"></v-radio>
                <v-radio label="2" :value="2" :ripple="false"></v-radio>
                <v-radio label="3" :value="3" :ripple="false"></v-radio>
              </v-radio-group>
            </v-card-text>
          </v-card> -->

          <!-- <v-card class="mb-3">
            <v-system-bar window class="px-1">
              <v-icon small color="error" style="margin-right: 0" @click="resetField('nr_niveluri_vizibile', 'info_scara_blocului')">mdi-close</v-icon>

              Nr niveluri vizibile &nbsp;
              <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('nr_niveluri_vizibile', 'info_scara_blocului')" @click="undo('nr_niveluri_vizibile', 'info_scara_blocului')" :ripple="false">
                <v-icon small>mdi-undo</v-icon>
              </v-btn>
            </v-system-bar>
            <v-card-text class="pa-1">
              <v-text-field
                @input="setField($event, 'nr_niveluri_vizibile', 'info_scara_blocului', null, true)"
                :value="entityObject.info_scara_blocului.nr_niveluri_vizibile"
                hint="Nr niveluri vizibile."
                persistent-hint
                type="number"
                @wheel="onWheel"
                :min="3"
                :max="18"
                validate-on-blur
                :rules="[val => ![null, ''].includes(val) || 'Camp obligatoriu!', val => (val >= 3 && val <= 18) || 'Valoarea introdusa nu se incadreaza in intervalul [3, 18].']"
                solo flat
                :disabled="user.dummy">
              </v-text-field>
            </v-card-text>
          </v-card> -->

          <!-- <v-card class="mb-3">
            <v-system-bar window class="px-1">
              <v-icon small color="error" style="margin-right: 0" @click="resetField('reabilitat', 'info_scara_blocului')">mdi-close</v-icon>

              Reabilitat &nbsp;
              <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('reabilitat', 'info_scara_blocului')" @click="undo('reabilitat', 'info_scara_blocului')" :ripple="false">
                <v-icon small>mdi-undo</v-icon>
              </v-btn>
            </v-system-bar>
            <v-card-text class="pa-1">
              <v-radio-group
                row
                v-model="entityObject.info_scara_blocului.reabilitat"
                hint="Reabilitat?"
                persistent-hint
                :disabled="user.dummy">
                <v-radio label="Da" value="Da" :ripple="false"></v-radio>
                <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
              </v-radio-group>
            </v-card-text>
          </v-card> -->

          <!-- <v-card class="mb-3">
            <v-system-bar window class="px-1">
              Regim inaltime &nbsp;
            </v-system-bar>
            <v-card-text class="pa-1">
              <v-text-field
                :value="entityObject.info_scara_blocului.regim_inaltime"
                hint="Regim inaltime. Camp calculat automat pe baza datelor de mai sus."
                persistent-hint
                disabled
                readonly
                class="mb-3"
                solo flat>
              </v-text-field>
            </v-card-text>
          </v-card> -->

          <v-card class="mb-3">
            <form ref="formscara">
              <input type="file" ref="fileinputscara" accept="image/*" multiple @change="filesAdded($event, 'scara')" style="display: none">
            </form>
            <v-system-bar window class="px-1">
              Poze scara &nbsp;
              <div style="display: inline-flex; flex-grow: 1; flex-wrap: wrap; align-items: center">
                <template>
                  <v-icon class="ml-1" color="primary" title="Poze incarcate">mdi-camera</v-icon>
                  {{noOfEntityPhotos}}
                </template>
                <template>
                  <v-btn class="ma-0 ml-1 pa-0" icon flat @click.stop.prevent style="min-width: 0" :ripple="false">
                    <v-icon :color="entityFilesInQueue ? 'primary' : 'blue-grey'" class="mr-1" title="Poze in asteptare">mdi-cloud-upload</v-icon>
                    {{ entityFilesInQueue }}
                  </v-btn>

                  <v-spacer></v-spacer>
                  <v-btn small class="ma-0" icon flat @click.stop.prevent="_cbAddPhoto('scara')" v-if="user && !user.dummy" color="primary" :ripple="false">
                    <v-icon class="mr-0">mdi-plus-circle</v-icon>
                  </v-btn>

                  <!-- mark bad photos -->
                  <v-btn small class="ma-0" icon flat @click.stop.prevent="_cbToggleBadMode" v-if="!user.dummy" :ripple="false">
                    <v-icon :color="badEnabled ? 'warning' : 'blue-grey'" class="mr-0">mdi-alert</v-icon>
                  </v-btn>
                  <v-btn small class="ma-0" icon flat @click.stop.prevent="_cbConfirmBad" v-show="badEnabled && toBad.length" :ripple="false">
                    <v-icon color="warning" class="mr-0">mdi-check-circle</v-icon>
                  </v-btn>

                  <!-- delete photos -->
                  <v-btn small class="ma-0" icon flat @click.stop.prevent="_cbToggleDeleteMode" v-if="!user.dummy" :ripple="false">
                    <v-icon :color="deleteEnabled ? 'error' : 'blue-grey'" class="mr-0">mdi-delete-circle</v-icon>
                  </v-btn>
                  <v-btn small class="ma-0" icon flat @click.stop.prevent="_cbConfirmDelete" v-show="deleteEnabled && toDelete.length" :ripple="false">
                    <v-icon color="error" class="mr-0">mdi-check-circle</v-icon>
                  </v-btn>
                  <span v-show="deleteEnabled && toDelete.length">
                    {{toDelete.length}}
                  </span>

                </template>
              </div>
            </v-system-bar>
            <v-card-text class="pa-1">
              <template v-if="noOfEntityPhotos">
                <viewer v-if="!deleteEnabled && !badEnabled" :options="{url: 'data-src', backdrop: 'static'}">
                  <template>
                    <v-layout align-center justify-flex-start wrap>
                      <div style="display: flex; flex-wrap: wrap">
                        <template v-for="(photo, pIndex) in scaraPhotos">
                          <div style="display: flex; flex-direction: column; align-items: center; width: 64px" :key="photo + pIndex">
                            <v-avatar
                              size="48"
                              class="ma-1 viewerPhoto"
                              style="box-sizing: border-box">
                              <img
                                :src="serverURL + photo.replace('photos', 'thumbs')"
                                :data-src="serverURL + photo"
                                class="pa-1">
                            </v-avatar>
                            <div style="display: flex; justify-content: space-around; width: 100%">
                              <a :href="serverURL + photo + '?buster=' + new Date().getTime()" download target="_blank" style="text-decoration: none" title="Descarca poza">
                                <v-icon small>mdi-download</v-icon>
                              </a>
                              <v-icon small color="warning" v-if="photo.includes('_badphoto')">mdi-alert</v-icon>
                              <a :href="serverURL + photo + '?buster=' + new Date().getTime()" target="_blank" style="text-decoration: none" title="Deschide poza intr-un tab nou">
                                <v-icon small>mdi-eye</v-icon>
                              </a>
                            </div>
                          </div>
                        </template>
                      </div>
                    </v-layout>
                  </template>
                </viewer>
                <v-layout v-if="deleteEnabled" align-center justify-flex-start wrap>
                  <!-- <v-scale-transition group> -->
                  <template v-for="(photo, pIndex) in scaraPhotos">
                    <div style="display: flex; flex-direction: column; align-items: center; width: 64px" :key="photo + pIndex">
                      <v-avatar
                        size="48"
                        class="ma-1"
                        :class="{ 'deletePhoto': toDelete.includes(photo), 'normalPhoto': !toDelete.includes(photo) }"
                        style="box-sizing: border-box"
                        @click="selectPhoto(photo)">
                        <img
                          :src="serverURL + photo.replace('photos', 'thumbs')"
                          :data-src="serverURL + photo"
                          class="pa-1">
                      </v-avatar>
                      <v-icon small color="warning" v-if="photo.includes('_badphoto')">mdi-alert</v-icon>
                    </div>
                  </template>
                  <!-- </v-scale-transition> -->
                </v-layout>
                <v-layout v-if="badEnabled" align-center justify-flex-start wrap>
                  <!-- <v-scale-transition group> -->
                  <template v-for="(photo, pIndex) in scaraPhotos">
                    <div style="display: flex; flex-direction: column; align-items: center; width: 64px" :key="photo + pIndex">
                      <v-avatar
                        size="48"
                        class="ma-1"
                        :class="{ 'badPhoto': toBad.includes(photo), 'normalPhoto': !toBad.includes(photo) }"
                        style="box-sizing: border-box"
                        @click="selectBadPhoto(photo)">
                        <img
                          :src="serverURL + photo.replace('photos', 'thumbs')"
                          :data-src="serverURL + photo"
                          class="pa-1">
                      </v-avatar>
                      <v-icon small color="warning" v-if="photo.includes('_badphoto')">mdi-alert</v-icon>
                    </div>
                  </template>
                  <!-- </v-scale-transition> -->
                </v-layout>
              </template>
              <template v-else>
                Nu exista poze pentru scara.
              </template>
            </v-card-text>
          </v-card>

          <!-- <v-card class="mb-3">
            <form ref="pdfformscara">
              <input type="file" ref="pdffileinputscara" accept="application/pdf" multiple @change="pdfsAdded($event, 'scara')" style="display: none">
            </form>
            <v-system-bar window class="px-1">
              PDF-uri scara &nbsp;
              <div style="display: inline-flex; flex-grow: 1; flex-wrap: wrap; align-items: center">
                <template>
                  <v-icon class="ml-1" color="primary" title="Pdf-uri incarcate">mdi-file-pdf</v-icon>
                  {{noOfEntityPdfs}}
                </template>
                <template>
                  <v-btn class="ma-0 ml-1 pa-0" icon flat @click.stop.prevent style="min-width: 0" :ripple="false">
                    <v-icon :color="entityPdfsInQueue ? 'primary' : 'blue-grey'" class="mr-1" title="Pdf-uri in asteptare">mdi-cloud-upload</v-icon>
                    {{ entityPdfsInQueue }}
                  </v-btn>

                  <v-spacer></v-spacer>
                  <v-btn class="ma-0" icon flat @click.stop.prevent="_cbAddPdf('scara')" v-if="user && user.admin" color="primary" :ripple="false">
                    <v-icon>mdi-plus-circle</v-icon>
                  </v-btn>

                  <v-btn class="ma-0" icon flat @click.stop.prevent="_cbToggleDeletePdfsMode" v-if="user.admin" :ripple="false">
                    <v-icon :color="deletePdfsEnabled ? 'error' : 'blue-grey'">mdi-delete-circle</v-icon>
                  </v-btn>
                  <v-btn class="ma-0" icon flat @click.stop.prevent="_cbConfirmDeletePdfs" v-show="deletePdfsEnabled && toDeletePdfs.length" :ripple="false">
                    <v-icon color="error">mdi-check-circle</v-icon>
                  </v-btn>
                  <span v-show="deletePdfsEnabled && toDeletePdfs.length">
                    {{toDeletePdfs.length}}
                  </span>

                </template>
              </div>
            </v-system-bar>
            <v-card-text class="pa-1">
              <template v-if="noOfEntityPdfs">
                <template v-if="!deletePdfsEnabled">
                  <v-layout align-center justify-flex-start wrap>
                    <div style="display: flex; flex-wrap: wrap">
                      <template v-for="(pdf, pIndex) in scaraPdfs">
                        <div style="display: flex; flex-direction: column; align-items: center; width: 64px" :key="pdf + pIndex">
                          <v-avatar
                            color="primary"
                            size="48"
                            class="ma-1"
                            style="box-sizing: border-box">
                            <v-icon class="pa-1">mdi-file-pdf</v-icon>
                          </v-avatar>
                          <span class="text-no-wrap text-truncate" style="width: 64px; text-align: center" :title="pdf">{{ pdf.replace('/pdfs/', '') }}</span>
                          <div style="display: flex; justify-content: space-around; width: 100%">
                            <a :href="serverURL + pdf + '?buster=' + new Date().getTime()" download target="_blank" style="text-decoration: none" title="Descarca pdf">
                              <v-icon small>mdi-download</v-icon>
                            </a>
                            <a @click.stop="viewPdf(pdf, serverURL + pdf + '?buster=' + new Date().getTime())" style="text-decoration: none" title="Deschide pdf">
                              <v-icon small>mdi-eye</v-icon>
                            </a>
                          </div>
                        </div>
                      </template>
                    </div>
                  </v-layout>
                </template>
                <template v-else>
                  <v-layout align-center justify-flex-start wrap>
                    <div style="display: flex; flex-wrap: wrap">
                      <template v-for="(pdf, pIndex) in scaraPdfs">
                        <div style="display: flex; flex-direction: column; align-items: center; width: 64px" :key="pdf + pIndex">
                          <v-avatar
                            :color="toDeletePdfs.includes(pdf) ? 'error' : ''"
                            size="48"
                            :key="pdf + pIndex"
                            class="ma-1"
                            :class="{ 'deletePdf': toDeletePdfs.includes(pdf), 'normalPdf': !toDeletePdfs.includes(pdf) }"
                            style="box-sizing: border-box"
                            @click="selectPdf(pdf)">
                            <v-icon class="pa-1">
                              mdi-file-pdf
                            </v-icon>
                          </v-avatar>
                          <span :key="pdf + pIndex + 'pdf'" class="text-no-wrap text-truncate" style="width: 64px; text-align: center" :title="pdf">{{ pdf.replace('/pdfs/', '') }}</span>
                        </div>
                      </template>
                    </div>
                  </v-layout>
                </template>
              </template>
              <template>
                Nu exista pdf-uri.
              </template>
            </v-card-text>
          </v-card> -->
        </v-card-text>
      </v-card>

      <v-card class="mb-2" v-if="visibleFields.includes('perete exterior')">
        <v-card-title class="accent--text title" style="justify-content: space-between">
          Perete exterior
          <v-icon :color="entityObject.perete_exterior.disabled ? 'grey' : 'primary'" @click="_cbToggleSectionDisabled('perete_exterior')">
            {{ entityObject.perete_exterior.disabled ? 'mdi-toggle-switch-off-outline' : 'mdi-toggle-switch' }}
          </v-icon>
        </v-card-title>
        <v-divider color="accent"></v-divider>

        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('grosime_izolatie', 'perete_exterior')">mdi-close</v-icon>

            Grosime izolatie &nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('grosime_izolatie', 'perete_exterior')" @click="undo('grosime_izolatie', 'perete_exterior')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-text-field
              @input="setField($event, 'grosime_izolatie', 'perete_exterior', null, true)"
              :value="entityObject.perete_exterior.grosime_izolatie"
              hint="Grosime izolatie."
              type="number"
              @wheel="onWheel"
              persistent-hint
              :min="0"
              :max="150"
              validate-on-blur
              :rules="[val => val !== null || 'Camp obligatoriu!', val => (val >=0 && val <= 150) || 'Valoarea introdusa nu se incadreaza in intervalul [0, 150].']"
              solo flat
              suffix="cm"
              :disabled="user.dummy || entityObject.perete_exterior.disabled">
            </v-text-field>
          </v-card-text>
        </v-card>
        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('grosime_izolatie_poza', 'perete_exterior')">mdi-close</v-icon>

            Poza grosime izolatie&nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('grosime_izolatie_poza', 'perete_exterior')" @click="undo('grosime_izolatie_poza', 'perete_exterior')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.perete_exterior.grosime_izolatie_poza"
              hint="Poza grosime izolatie?"
              persistent-hint
              :disabled="user.dummy || entityObject.perete_exterior.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>
        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('grosime_izolatie_nereguli', 'perete_exterior')">mdi-close</v-icon>

            Nereguli grosime izolatie &nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('grosime_izolatie_nereguli', 'perete_exterior')" @click="undo('grosime_izolatie_nereguli', 'perete_exterior')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.perete_exterior.grosime_izolatie_nereguli"
              hint="Nereguli grosime izolatie?"
              persistent-hint
              :disabled="user.dummy || entityObject.perete_exterior.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>

        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('tencuiala_cazuta', 'perete_exterior')">mdi-close</v-icon>

            Tencuiala cazuta&nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('tencuiala_cazuta', 'perete_exterior')" @click="undo('tencuiala_cazuta', 'perete_exterior')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.perete_exterior.tencuiala_cazuta"
              hint="Tencuiala cazuta?"
              persistent-hint
              :disabled="user.dummy || entityObject.perete_exterior.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>
        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('tencuiala_cazuta_poza', 'perete_exterior')">mdi-close</v-icon>

            Poza tencuiala cazuta&nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('tencuiala_cazuta_poza', 'perete_exterior')" @click="undo('tencuiala_cazuta_poza', 'perete_exterior')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.perete_exterior.tencuiala_cazuta_poza"
              hint="Poza tencuiala cazuta?"
              persistent-hint
              :disabled="user.dummy || entityObject.perete_exterior.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>
        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('tencuiala_cazuta_nereguli', 'perete_exterior')">mdi-close</v-icon>

            Nereguli tencuiala cazuta &nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('tencuiala_cazuta_nereguli', 'perete_exterior')" @click="undo('tencuiala_cazuta_nereguli', 'perete_exterior')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.perete_exterior.tencuiala_cazuta_nereguli"
              hint="Nereguli tencuiala cazuta?"
              persistent-hint
              :disabled="user.dummy || entityObject.perete_exterior.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>

        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('infiltratii', 'perete_exterior')">mdi-close</v-icon>

            Infiltratii&nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('infiltratii', 'perete_exterior')" @click="undo('infiltratii', 'perete_exterior')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.perete_exterior.infiltratii"
              hint="infiltratii?"
              persistent-hint
              :disabled="user.dummy || entityObject.perete_exterior.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>
        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('infiltratii_poza', 'perete_exterior')">mdi-close</v-icon>

            Poza infiltratii&nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('infiltratii_poza', 'perete_exterior')" @click="undo('infiltratii_poza', 'perete_exterior')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.perete_exterior.infiltratii_poza"
              hint="Poza infiltratii?"
              persistent-hint
              :disabled="user.dummy || entityObject.perete_exterior.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>
        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('infiltratii_nereguli', 'perete_exterior')">mdi-close</v-icon>

            Nereguli infiltratii &nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('infiltratii_nereguli', 'perete_exterior')" @click="undo('infiltratii_nereguli', 'perete_exterior')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.perete_exterior.infiltratii_nereguli"
              hint="Nereguli infiltratii?"
              persistent-hint
              :disabled="user.dummy || entityObject.perete_exterior.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>

        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('rost_dilatatie', 'perete_exterior')">mdi-close</v-icon>

            Rost dilatatie&nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('rost_dilatatie', 'perete_exterior')" @click="undo('rost_dilatatie', 'perete_exterior')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.perete_exterior.rost_dilatatie"
              hint="Rost dilatatie?"
              persistent-hint
              :disabled="user.dummy || entityObject.perete_exterior.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>
        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('rost_dilatatie_poza', 'perete_exterior')">mdi-close</v-icon>

            Poza rost dilatatie&nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('rost_dilatatie_poza', 'perete_exterior')" @click="undo('rost_dilatatie_poza', 'perete_exterior')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.perete_exterior.rost_dilatatie_poza"
              hint="Poza rost dilatatie?"
              persistent-hint
              :disabled="user.dummy || entityObject.perete_exterior.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>
        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('rost_dilatatie_nereguli', 'perete_exterior')">mdi-close</v-icon>

            Nereguli rost dilatatie &nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('rost_dilatatie_nereguli', 'perete_exterior')" @click="undo('rost_dilatatie_nereguli', 'perete_exterior')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.perete_exterior.rost_dilatatie_nereguli"
              hint="Nereguli rost dilatatie?"
              persistent-hint
              :disabled="user.dummy || entityObject.perete_exterior.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>

        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('interfon_montat_la_fata_iz', 'perete_exterior')">mdi-close</v-icon>

            Interfon montat la fata iz.&nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('interfon_montat_la_fata_iz', 'perete_exterior')" @click="undo('interfon_montat_la_fata_iz', 'perete_exterior')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.perete_exterior.interfon_montat_la_fata_iz"
              hint="interfon montat la fata iz.?"
              persistent-hint
              :disabled="user.dummy || entityObject.perete_exterior.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>
        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('interfon_montat_la_fata_iz_poza', 'perete_exterior')">mdi-close</v-icon>

            Poza interfon montat la fata iz.&nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('interfon_montat_la_fata_iz_poza', 'perete_exterior')" @click="undo('interfon_montat_la_fata_iz_poza', 'perete_exterior')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.perete_exterior.interfon_montat_la_fata_iz_poza"
              hint="Poza interfon montat la fata iz.?"
              persistent-hint
              :disabled="user.dummy || entityObject.perete_exterior.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>
        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('interfon_montat_la_fata_iz_nereguli', 'perete_exterior')">mdi-close</v-icon>

            Nereguli interfon montat la fata iz. &nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('interfon_montat_la_fata_iz_nereguli', 'perete_exterior')" @click="undo('interfon_montat_la_fata_iz_nereguli', 'perete_exterior')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.perete_exterior.interfon_montat_la_fata_iz_nereguli"
              hint="Nereguli interfon montat la fata iz.?"
              persistent-hint
              :disabled="user.dummy || entityObject.perete_exterior.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>

        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('splituri_in_ext_izolatiei', 'perete_exterior')">mdi-close</v-icon>

            Splituri in ext. izolatiei&nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('splituri_in_ext_izolatiei', 'perete_exterior')" @click="undo('splituri_in_ext_izolatiei', 'perete_exterior')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.perete_exterior.splituri_in_ext_izolatiei"
              hint="splituri in ext. izolatiei?"
              persistent-hint
              :disabled="user.dummy || entityObject.perete_exterior.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>
        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('splituri_in_ext_izolatiei_poza', 'perete_exterior')">mdi-close</v-icon>

            Poza splituri in ext. izolatiei&nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('splituri_in_ext_izolatiei_poza', 'perete_exterior')" @click="undo('splituri_in_ext_izolatiei_poza', 'perete_exterior')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.perete_exterior.splituri_in_ext_izolatiei_poza"
              hint="Poza splituri in ext. izolatiei?"
              persistent-hint
              :disabled="user.dummy || entityObject.perete_exterior.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>
        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('splituri_in_ext_izolatiei_nereguli', 'perete_exterior')">mdi-close</v-icon>

            Nereguli splituri in ext. izolatiei &nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('splituri_in_ext_izolatiei_nereguli', 'perete_exterior')" @click="undo('splituri_in_ext_izolatiei_nereguli', 'perete_exterior')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.perete_exterior.splituri_in_ext_izolatiei_nereguli"
              hint="Nereguli splituri in ext. izolatiei?"
              persistent-hint
              :disabled="user.dummy || entityObject.perete_exterior.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>

        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('observatii', 'perete_exterior')">mdi-close</v-icon>

            Observatii  &nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('observatii', 'perete_exterior')" @click="undo('observatii', 'perete_exterior')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-textarea
              @input="setField($event, 'observatii', 'perete_exterior', null, false)"
              :value="entityObject.perete_exterior.observatii"
              auto-grow
              :rows="1"
              hide-details
              hint="Observatii"
              persistent-hint
              solo flat
              :disabled="user.dummy || entityObject.perete_exterior.disabled">
            </v-textarea>
          </v-card-text>
        </v-card>

        <v-card class="mb-3">
          <form ref="formpereteexterior">
            <input type="file" ref="fileinputpereteexterior" accept="image/*" multiple @change="filesAdded($event, 'pereteexterior')" style="display: none">
          </form>
          <v-system-bar window class="px-1">
            Poze perete exterior &nbsp;
            <div style="display: inline-flex; flex-grow: 1; flex-wrap: wrap; align-items: center">
              <template>
                <v-icon class="ml-1" color="primary" title="Poze incarcate">mdi-camera</v-icon>
                {{noOfPereteexteriorPhotos}}
              </template>
              <template>
                <v-btn class="ma-0 ml-1 pa-0" icon flat @click.stop.prevent style="min-width: 0" :ripple="false">
                  <v-icon :color="pereteexteriorFilesInQueue ? 'primary' : 'blue-grey'" class="mr-1" title="Poze in asteptare">mdi-cloud-upload</v-icon>
                  {{ pereteexteriorFilesInQueue }}
                </v-btn>

                <v-spacer></v-spacer>
                <v-btn small class="ma-0" icon flat @click.stop.prevent="_cbAddPhoto('pereteexterior')" v-if="user && !user.dummy" color="primary" :ripple="false">
                  <v-icon class="mr-0">mdi-plus-circle</v-icon>
                </v-btn>

                <!-- mark bad photos -->
                <v-btn small class="ma-0" icon flat @click.stop.prevent="_cbToggleBadMode" v-if="!user.dummy" :ripple="false">
                  <v-icon :color="badEnabled ? 'warning' : 'blue-grey'" class="mr-0">mdi-alert</v-icon>
                </v-btn>
                <v-btn small class="ma-0" icon flat @click.stop.prevent="_cbConfirmBad" v-show="badEnabled && toBad.length" :ripple="false">
                  <v-icon color="warning" class="mr-0">mdi-check-circle</v-icon>
                </v-btn>

                <!-- delete photos -->
                <v-btn small class="ma-0" icon flat @click.stop.prevent="_cbToggleDeleteMode" v-if="!user.dummy" :ripple="false">
                  <v-icon :color="deleteEnabled ? 'error' : 'blue-grey'" class="mr-0">mdi-delete-circle</v-icon>
                </v-btn>
                <v-btn small class="ma-0" icon flat @click.stop.prevent="_cbConfirmDelete" v-show="deleteEnabled && toDelete.length" :ripple="false">
                  <v-icon color="error" class="mr-0">mdi-check-circle</v-icon>
                </v-btn>
                <span v-show="deleteEnabled && toDelete.length">
                  {{toDelete.length}}
                </span>

              </template>
            </div>
          </v-system-bar>
          <v-card-text class="pa-1">
            <template v-if="noOfPereteexteriorPhotos">
              <viewer v-if="!deleteEnabled && !badEnabled" :options="{url: 'data-src', backdrop: 'static'}">
                <template>
                  <v-layout align-center justify-flex-start wrap>
                    <div style="display: flex; flex-wrap: wrap">
                      <template v-for="(photo, pIndex) in pereteexteriorPhotos">
                        <div style="display: flex; flex-direction: column; align-items: center; width: 64px" :key="photo + pIndex">
                          <v-avatar
                            size="48"
                            class="ma-1 viewerPhoto"
                            style="box-sizing: border-box">
                            <img
                              :src="serverURL + photo.replace('photos', 'thumbs')"
                              :data-src="serverURL + photo"
                              class="pa-1">
                          </v-avatar>
                          <div style="display: flex; justify-content: space-around; width: 100%">
                            <a :href="serverURL + photo + '?buster=' + new Date().getTime()" download target="_blank" style="text-decoration: none" title="Descarca poza">
                              <v-icon small>mdi-download</v-icon>
                            </a>
                            <v-icon small color="warning" v-if="photo.includes('_badphoto')">mdi-alert</v-icon>
                            <a :href="serverURL + photo + '?buster=' + new Date().getTime()" target="_blank" style="text-decoration: none" title="Deschide poza intr-un tab nou">
                              <v-icon small>mdi-eye</v-icon>
                            </a>
                          </div>
                        </div>
                      </template>
                    </div>
                  </v-layout>
                </template>
              </viewer>
              <v-layout v-if="deleteEnabled" align-center justify-flex-start wrap>
                <!-- <v-scale-transition group> -->
                <template v-for="(photo, pIndex) in pereteexteriorPhotos">
                  <div style="display: flex; flex-direction: column; align-items: center; width: 64px" :key="photo + pIndex">
                    <v-avatar
                      size="48"
                      class="ma-1"
                      :class="{ 'deletePhoto': toDelete.includes(photo), 'normalPhoto': !toDelete.includes(photo) }"
                      style="box-sizing: border-box"
                      @click="selectPhoto(photo)">
                      <img
                        :src="serverURL + photo.replace('photos', 'thumbs')"
                        :data-src="serverURL + photo"
                        class="pa-1">
                    </v-avatar>
                    <v-icon small color="warning" v-if="photo.includes('_badphoto')">mdi-alert</v-icon>
                  </div>
                </template>
                <!-- </v-scale-transition> -->
              </v-layout>
              <v-layout v-if="badEnabled" align-center justify-flex-start wrap>
                <!-- <v-scale-transition group> -->
                <template v-for="(photo, pIndex) in pereteexteriorPhotos">
                  <div style="display: flex; flex-direction: column; align-items: center; width: 64px" :key="photo + pIndex">
                    <v-avatar
                      size="48"
                      class="ma-1"
                      :class="{ 'badPhoto': toBad.includes(photo), 'normalPhoto': !toBad.includes(photo) }"
                      style="box-sizing: border-box"
                      @click="selectBadPhoto(photo)">
                      <img
                        :src="serverURL + photo.replace('photos', 'thumbs')"
                        :data-src="serverURL + photo"
                        class="pa-1">
                    </v-avatar>
                    <v-icon small color="warning" v-if="photo.includes('_badphoto')">mdi-alert</v-icon>
                  </div>
                </template>
                <!-- </v-scale-transition> -->
              </v-layout>
            </template>
            <template v-else>
              Nu exista poze pentru peretele exterior.
            </template>
          </v-card-text>
        </v-card>
      </v-card>

      <v-card class="mb-2" v-if="visibleFields.includes('tamplarie')">
        <v-card-title class="accent--text title" style="justify-content: space-between">
          Tamplarie
          <v-icon :color="entityObject.tamplarie.disabled ? 'grey' : 'primary'" @click="_cbToggleSectionDisabled('tamplarie')">
            {{ entityObject.tamplarie.disabled ? 'mdi-toggle-switch-off-outline' : 'mdi-toggle-switch' }}
          </v-icon>
        </v-card-title>
        <v-divider color="accent"></v-divider>

        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('pvc', 'tamplarie')">mdi-close</v-icon>

            PVC&nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('pvc', 'tamplarie')" @click="undo('pvc', 'tamplarie')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.tamplarie.pvc"
              hint="PVC?"
              persistent-hint
              :disabled="user.dummy || entityObject.tamplarie.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>
        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('pvc_poza', 'tamplarie')">mdi-close</v-icon>

            Poza PVC&nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('pvc_poza', 'tamplarie')" @click="undo('pvc_poza', 'tamplarie')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.tamplarie.pvc_poza"
              hint="Poza PVC?"
              persistent-hint
              :disabled="user.dummy || entityObject.tamplarie.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>
        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('pvc_nereguli', 'tamplarie')">mdi-close</v-icon>

            Nereguli PVC &nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('pvc_nereguli', 'tamplarie')" @click="undo('pvc_nereguli', 'tamplarie')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.tamplarie.pvc_nereguli"
              hint="Nereguli PVC?"
              persistent-hint
              :disabled="user.dummy || entityObject.tamplarie.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>

        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('grile', 'tamplarie')">mdi-close</v-icon>

            Grile&nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('grile', 'tamplarie')" @click="undo('grile', 'tamplarie')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.tamplarie.grile"
              hint="Grile?"
              persistent-hint
              :disabled="user.dummy || entityObject.tamplarie.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>
        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('grile_poza', 'tamplarie')">mdi-close</v-icon>

            Poza grile&nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('grile_poza', 'tamplarie')" @click="undo('grile_poza', 'tamplarie')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.tamplarie.grile_poza"
              hint="Poza grile?"
              persistent-hint
              :disabled="user.dummy || entityObject.tamplarie.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>
        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('grile_nereguli', 'tamplarie')">mdi-close</v-icon>

            Nereguli grile &nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('grile_nereguli', 'tamplarie')" @click="undo('grile_nereguli', 'tamplarie')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.tamplarie.grile_nereguli"
              hint="Nereguli grile?"
              persistent-hint
              :disabled="user.dummy || entityObject.tamplarie.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>

        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('glafuri_exterioare', 'tamplarie')">mdi-close</v-icon>

            Glafuri exterioare&nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('glafuri_exterioare', 'tamplarie')" @click="undo('glafuri_exterioare', 'tamplarie')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.tamplarie.glafuri_exterioare"
              hint="Glafuri exterioare?"
              persistent-hint
              :disabled="user.dummy || entityObject.tamplarie.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>
        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('glafuri_exterioare_poza', 'tamplarie')">mdi-close</v-icon>

            Poza glafuri exterioare&nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('glafuri_exterioare_poza', 'tamplarie')" @click="undo('glafuri_exterioare_poza', 'tamplarie')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.tamplarie.glafuri_exterioare_poza"
              hint="Poza glafuri exterioare?"
              persistent-hint
              :disabled="user.dummy || entityObject.tamplarie.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>
        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('glafuri_exterioare_nereguli', 'tamplarie')">mdi-close</v-icon>

            Nereguli glafuri exterioare &nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('glafuri_exterioare_nereguli', 'tamplarie')" @click="undo('glafuri_exterioare_nereguli', 'tamplarie')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.tamplarie.glafuri_exterioare_nereguli"
              hint="Nereguli glafuri exterioare?"
              persistent-hint
              :disabled="user.dummy || entityObject.tamplarie.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>

        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('grila_casa_scarii', 'tamplarie')">mdi-close</v-icon>

            Grila casa scarii&nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('grila_casa_scarii', 'tamplarie')" @click="undo('grila_casa_scarii', 'tamplarie')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.tamplarie.grila_casa_scarii"
              hint="Grila casa scarii?"
              persistent-hint
              :disabled="user.dummy || entityObject.tamplarie.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>
        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('grila_casa_scarii_poza', 'tamplarie')">mdi-close</v-icon>

            Poza grila casa scarii&nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('grila_casa_scarii_poza', 'tamplarie')" @click="undo('grila_casa_scarii_poza', 'tamplarie')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.tamplarie.grila_casa_scarii_poza"
              hint="Poza grila casa scarii?"
              persistent-hint
              :disabled="user.dummy || entityObject.tamplarie.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>
        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('grila_casa_scarii_nereguli', 'tamplarie')">mdi-close</v-icon>

            Nereguli grila casa scarii &nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('grila_casa_scarii_nereguli', 'tamplarie')" @click="undo('grila_casa_scarii_nereguli', 'tamplarie')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.tamplarie.grila_casa_scarii_nereguli"
              hint="Nereguli grila casa scarii?"
              persistent-hint
              :disabled="user.dummy || entityObject.tamplarie.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>

        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('folie_producator_indepartata', 'tamplarie')">mdi-close</v-icon>

            Folie producator indepartata&nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('folie_producator_indepartata', 'tamplarie')" @click="undo('folie_producator_indepartata', 'tamplarie')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.tamplarie.folie_producator_indepartata"
              hint="Folie producator indepartata?"
              persistent-hint
              :disabled="user.dummy || entityObject.tamplarie.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>
        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('folie_producator_indepartata_poza', 'tamplarie')">mdi-close</v-icon>

            Poza folie producator indepartata&nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('folie_producator_indepartata_poza', 'tamplarie')" @click="undo('folie_producator_indepartata_poza', 'tamplarie')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.tamplarie.folie_producator_indepartata_poza"
              hint="Poza folie producator indepartata?"
              persistent-hint
              :disabled="user.dummy || entityObject.tamplarie.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>
        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('folie_producator_indepartata_nereguli', 'tamplarie')">mdi-close</v-icon>

            Nereguli folie producator indepartata &nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('folie_producator_indepartata_nereguli', 'tamplarie')" @click="undo('folie_producator_indepartata_nereguli', 'tamplarie')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.tamplarie.folie_producator_indepartata_nereguli"
              hint="Nereguli folie producator indepartata?"
              persistent-hint
              :disabled="user.dummy || entityObject.tamplarie.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>

        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('inchidere_balcoane', 'tamplarie')">mdi-close</v-icon>

            Inchidere balcoane&nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('inchidere_balcoane', 'tamplarie')" @click="undo('inchidere_balcoane', 'tamplarie')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.tamplarie.inchidere_balcoane"
              hint="Inchidere balcoane?"
              persistent-hint
              :disabled="user.dummy || entityObject.tamplarie.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>
        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('inchidere_balcoane_poza', 'tamplarie')">mdi-close</v-icon>

            Poza inchidere balcoane&nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('inchidere_balcoane_poza', 'tamplarie')" @click="undo('inchidere_balcoane_poza', 'tamplarie')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.tamplarie.inchidere_balcoane_poza"
              hint="Poza inchidere balcoane?"
              persistent-hint
              :disabled="user.dummy || entityObject.tamplarie.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>
        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('inchidere_balcoane_nereguli', 'tamplarie')">mdi-close</v-icon>

            Nereguli inchidere balcoane &nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('inchidere_balcoane_nereguli', 'tamplarie')" @click="undo('inchidere_balcoane_nereguli', 'tamplarie')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.tamplarie.inchidere_balcoane_nereguli"
              hint="Nereguli inchidere balcoane?"
              persistent-hint
              :disabled="user.dummy || entityObject.tamplarie.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>

        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('termoizolare_parapet_balc', 'tamplarie')">mdi-close</v-icon>

            Termoizolare parapet balc&nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('termoizolare_parapet_balc', 'tamplarie')" @click="undo('termoizolare_parapet_balc', 'tamplarie')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.tamplarie.termoizolare_parapet_balc"
              hint="Termoizolare parapet balc?"
              persistent-hint
              :disabled="user.dummy || entityObject.tamplarie.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>
        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('termoizolare_parapet_balc_poza', 'tamplarie')">mdi-close</v-icon>

            Poza termoizolare parapet balc&nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('termoizolare_parapet_balc_poza', 'tamplarie')" @click="undo('termoizolare_parapet_balc_poza', 'tamplarie')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.tamplarie.termoizolare_parapet_balc_poza"
              hint="Poza termoizolare parapet balc?"
              persistent-hint
              :disabled="user.dummy || entityObject.tamplarie.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>
        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('termoizolare_parapet_balc_nereguli', 'tamplarie')">mdi-close</v-icon>

            Nereguli termoizolare parapet balc &nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('termoizolare_parapet_balc_nereguli', 'tamplarie')" @click="undo('termoizolare_parapet_balc_nereguli', 'tamplarie')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.tamplarie.termoizolare_parapet_balc_nereguli"
              hint="Nereguli termoizolare parapet balc?"
              persistent-hint
              :disabled="user.dummy || entityObject.tamplarie.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>

        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('placa_acoperire_balcon_ue', 'tamplarie')">mdi-close</v-icon>

            Placa acoperire balcon ue&nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('placa_acoperire_balcon_ue', 'tamplarie')" @click="undo('placa_acoperire_balcon_ue', 'tamplarie')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.tamplarie.placa_acoperire_balcon_ue"
              hint="Placa acoperire balcon ue?"
              persistent-hint
              :disabled="user.dummy || entityObject.tamplarie.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>
        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('placa_acoperire_balcon_ue_poza', 'tamplarie')">mdi-close</v-icon>

            Poza placa acoperire balcon ue&nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('placa_acoperire_balcon_ue_poza', 'tamplarie')" @click="undo('placa_acoperire_balcon_ue_poza', 'tamplarie')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.tamplarie.placa_acoperire_balcon_ue_poza"
              hint="Poza placa acoperire balcon ue?"
              persistent-hint
              :disabled="user.dummy || entityObject.tamplarie.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>
        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('placa_acoperire_balcon_ue_nereguli', 'tamplarie')">mdi-close</v-icon>

            Nereguli placa acoperire balcon ue &nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('placa_acoperire_balcon_ue_nereguli', 'tamplarie')" @click="undo('placa_acoperire_balcon_ue_nereguli', 'tamplarie')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.tamplarie.placa_acoperire_balcon_ue_nereguli"
              hint="Nereguli placa acoperire balcon ue?"
              persistent-hint
              :disabled="user.dummy || entityObject.tamplarie.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>

        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('observatii', 'tamplarie')">mdi-close</v-icon>

            Observatii  &nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('observatii', 'tamplarie')" @click="undo('observatii', 'tamplarie')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-textarea
              @input="setField($event, 'observatii', 'tamplarie', null, false)"
              :value="entityObject.tamplarie.observatii"
              auto-grow
              :rows="1"
              hide-details
              hint="Observatii"
              persistent-hint
              solo flat
              :disabled="user.dummy || entityObject.tamplarie.disabled">
            </v-textarea>
          </v-card-text>
        </v-card>

        <v-card class="mb-3">
          <form ref="formtamplarie">
            <input type="file" ref="fileinputtamplarie" accept="image/*" multiple @change="filesAdded($event, 'tamplarie')" style="display: none">
          </form>
          <v-system-bar window class="px-1">
            Poze tamplarie &nbsp;
            <div style="display: inline-flex; flex-grow: 1; flex-wrap: wrap; align-items: center">
              <template>
                <v-icon class="ml-1" color="primary" title="Poze incarcate">mdi-camera</v-icon>
                {{noOfTamplariePhotos}}
              </template>
              <template>
                <v-btn class="ma-0 ml-1 pa-0" icon flat @click.stop.prevent style="min-width: 0" :ripple="false">
                  <v-icon :color="tamplarieFilesInQueue ? 'primary' : 'blue-grey'" class="mr-1" title="Poze in asteptare">mdi-cloud-upload</v-icon>
                  {{ tamplarieFilesInQueue }}
                </v-btn>

                <v-spacer></v-spacer>
                <v-btn small class="ma-0" icon flat @click.stop.prevent="_cbAddPhoto('tamplarie')" v-if="user && !user.dummy" color="primary" :ripple="false">
                  <v-icon class="mr-0">mdi-plus-circle</v-icon>
                </v-btn>

                <!-- mark bad photos -->
                <v-btn small class="ma-0" icon flat @click.stop.prevent="_cbToggleBadMode" v-if="!user.dummy" :ripple="false">
                  <v-icon :color="badEnabled ? 'warning' : 'blue-grey'" class="mr-0">mdi-alert</v-icon>
                </v-btn>
                <v-btn small class="ma-0" icon flat @click.stop.prevent="_cbConfirmBad" v-show="badEnabled && toBad.length" :ripple="false">
                  <v-icon color="warning" class="mr-0">mdi-check-circle</v-icon>
                </v-btn>

                <!-- delete photos -->
                <v-btn small class="ma-0" icon flat @click.stop.prevent="_cbToggleDeleteMode" v-if="!user.dummy" :ripple="false">
                  <v-icon :color="deleteEnabled ? 'error' : 'blue-grey'" class="mr-0">mdi-delete-circle</v-icon>
                </v-btn>
                <v-btn small class="ma-0" icon flat @click.stop.prevent="_cbConfirmDelete" v-show="deleteEnabled && toDelete.length" :ripple="false">
                  <v-icon color="error" class="mr-0">mdi-check-circle</v-icon>
                </v-btn>
                <span v-show="deleteEnabled && toDelete.length">
                  {{toDelete.length}}
                </span>

              </template>
            </div>
          </v-system-bar>
          <v-card-text class="pa-1">
            <template v-if="noOfTamplariePhotos">
              <viewer v-if="!deleteEnabled && !badEnabled" :options="{url: 'data-src', backdrop: 'static'}">
                <template>
                  <v-layout align-center justify-flex-start wrap>
                    <div style="display: flex; flex-wrap: wrap">
                      <template v-for="(photo, pIndex) in tamplariePhotos">
                        <div style="display: flex; flex-direction: column; align-items: center; width: 64px" :key="photo + pIndex">
                          <v-avatar
                            size="48"
                            class="ma-1 viewerPhoto"
                            style="box-sizing: border-box">
                            <img
                              :src="serverURL + photo.replace('photos', 'thumbs')"
                              :data-src="serverURL + photo"
                              class="pa-1">
                          </v-avatar>
                          <div style="display: flex; justify-content: space-around; width: 100%">
                            <a :href="serverURL + photo + '?buster=' + new Date().getTime()" download target="_blank" style="text-decoration: none" title="Descarca poza">
                              <v-icon small>mdi-download</v-icon>
                            </a>
                            <v-icon small color="warning" v-if="photo.includes('_badphoto')">mdi-alert</v-icon>
                            <a :href="serverURL + photo + '?buster=' + new Date().getTime()" target="_blank" style="text-decoration: none" title="Deschide poza intr-un tab nou">
                              <v-icon small>mdi-eye</v-icon>
                            </a>
                          </div>
                        </div>
                      </template>
                    </div>
                  </v-layout>
                </template>
              </viewer>
              <v-layout v-if="deleteEnabled" align-center justify-flex-start wrap>
                <!-- <v-scale-transition group> -->
                <template v-for="(photo, pIndex) in tamplariePhotos">
                  <div style="display: flex; flex-direction: column; align-items: center; width: 64px" :key="photo + pIndex">
                    <v-avatar
                      size="48"
                      class="ma-1"
                      :class="{ 'deletePhoto': toDelete.includes(photo), 'normalPhoto': !toDelete.includes(photo) }"
                      style="box-sizing: border-box"
                      @click="selectPhoto(photo)">
                      <img
                        :src="serverURL + photo.replace('photos', 'thumbs')"
                        :data-src="serverURL + photo"
                        class="pa-1">
                    </v-avatar>
                    <v-icon small color="warning" v-if="photo.includes('_badphoto')">mdi-alert</v-icon>
                  </div>
                </template>
                <!-- </v-scale-transition> -->
              </v-layout>
              <v-layout v-if="badEnabled" align-center justify-flex-start wrap>
                <!-- <v-scale-transition group> -->
                <template v-for="(photo, pIndex) in tamplariePhotos">
                  <div style="display: flex; flex-direction: column; align-items: center; width: 64px" :key="photo + pIndex">
                    <v-avatar
                      size="48"
                      class="ma-1"
                      :class="{ 'badPhoto': toBad.includes(photo), 'normalPhoto': !toBad.includes(photo) }"
                      style="box-sizing: border-box"
                      @click="selectBadPhoto(photo)">
                      <img
                        :src="serverURL + photo.replace('photos', 'thumbs')"
                        :data-src="serverURL + photo"
                        class="pa-1">
                    </v-avatar>
                    <v-icon small color="warning" v-if="photo.includes('_badphoto')">mdi-alert</v-icon>
                  </div>
                </template>
                <!-- </v-scale-transition> -->
              </v-layout>
            </template>
            <template v-else>
              Nu exista poze pentru tamplarie.
            </template>
          </v-card-text>
        </v-card>
      </v-card>

      <v-card class="mb-2" v-if="visibleFields.includes('soclu')">
        <v-card-title class="accent--text title" style="justify-content: space-between">
          Soclu
          <v-icon :color="entityObject.soclu.disabled ? 'grey' : 'primary'" @click="_cbToggleSectionDisabled('soclu')">
            {{ entityObject.soclu.disabled ? 'mdi-toggle-switch-off-outline' : 'mdi-toggle-switch' }}
          </v-icon>
        </v-card-title>
        <v-divider color="accent"></v-divider>

        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('grosime_izolatie', 'soclu')">mdi-close</v-icon>

            Grosime izolatie &nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('grosime_izolatie', 'soclu')" @click="undo('grosime_izolatie', 'soclu')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-text-field
              @input="setField($event, 'grosime_izolatie', 'soclu', null, true)"
              :value="entityObject.soclu.grosime_izolatie"
              hint="Grosime izolatie."
              type="number"
              @wheel="onWheel"
              persistent-hint
              :min="0"
              :max="150"
              validate-on-blur
              :rules="[val => val !== null || 'Camp obligatoriu!', val => (val >=0 && val <= 150) || 'Valoarea introdusa nu se incadreaza in intervalul [0, 150].']"
              solo flat
              suffix="cm"
              :disabled="user.dummy || entityObject.soclu.disabled">
            </v-text-field>
          </v-card-text>
        </v-card>
        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('grosime_izolatie_poza', 'soclu')">mdi-close</v-icon>

            Poza grosime izolatie&nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('grosime_izolatie_poza', 'soclu')" @click="undo('grosime_izolatie_poza', 'soclu')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.soclu.grosime_izolatie_poza"
              hint="Poza grosime izolatie?"
              persistent-hint
              :disabled="user.dummy || entityObject.soclu.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>
        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('grosime_izolatie_nereguli', 'soclu')">mdi-close</v-icon>

            Nereguli grosime izolatie &nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('grosime_izolatie_nereguli', 'soclu')" @click="undo('grosime_izolatie_nereguli', 'soclu')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.soclu.grosime_izolatie_nereguli"
              hint="Nereguli grosime izolatie?"
              persistent-hint
              :disabled="user.dummy || entityObject.soclu.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>

        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('imbinare_trotuar', 'soclu')">mdi-close</v-icon>

            Imbinare trotuar&nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('imbinare_trotuar', 'soclu')" @click="undo('imbinare_trotuar', 'soclu')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.soclu.imbinare_trotuar"
              hint="Imbinare trotuar?"
              persistent-hint
              :disabled="user.dummy || entityObject.soclu.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>
        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('imbinare_trotuar_poza', 'soclu')">mdi-close</v-icon>

            Poza imbinare trotuar&nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('imbinare_trotuar_poza', 'soclu')" @click="undo('imbinare_trotuar_poza', 'soclu')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.soclu.imbinare_trotuar_poza"
              hint="Poza imbinare trotuar?"
              persistent-hint
              :disabled="user.dummy || entityObject.soclu.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>
        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('imbinare_trotuar_nereguli', 'soclu')">mdi-close</v-icon>

            Nereguli imbinare trotuar &nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('imbinare_trotuar_nereguli', 'soclu')" @click="undo('imbinare_trotuar_nereguli', 'soclu')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.soclu.imbinare_trotuar_nereguli"
              hint="Nereguli imbinare trotuar?"
              persistent-hint
              :disabled="user.dummy || entityObject.soclu.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>

        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('grile_aerisire_subsol', 'soclu')">mdi-close</v-icon>

            Grile aerisire subsol&nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('grile_aerisire_subsol', 'soclu')" @click="undo('grile_aerisire_subsol', 'soclu')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.soclu.grile_aerisire_subsol"
              hint="Grile aerisire subsol?"
              persistent-hint
              :disabled="user.dummy || entityObject.soclu.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>
        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('grile_aerisire_subsol_poza', 'soclu')">mdi-close</v-icon>

            Poza grile aerisire subsol&nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('grile_aerisire_subsol_poza', 'soclu')" @click="undo('grile_aerisire_subsol_poza', 'soclu')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.soclu.grile_aerisire_subsol_poza"
              hint="Poza grile aerisire subsol?"
              persistent-hint
              :disabled="user.dummy || entityObject.soclu.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>
        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('grile_aerisire_subsol_nereguli', 'soclu')">mdi-close</v-icon>

            Nereguli grile aerisire subsol &nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('grile_aerisire_subsol_nereguli', 'soclu')" @click="undo('grile_aerisire_subsol_nereguli', 'soclu')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.soclu.grile_aerisire_subsol_nereguli"
              hint="Nereguli grile aerisire subsol?"
              persistent-hint
              :disabled="user.dummy || entityObject.soclu.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>

        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('profil_lacrimar', 'soclu')">mdi-close</v-icon>

            Profil lacrimar&nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('profil_lacrimar', 'soclu')" @click="undo('profil_lacrimar', 'soclu')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.soclu.profil_lacrimar"
              hint="Profil lacrimar?"
              persistent-hint
              :disabled="user.dummy || entityObject.soclu.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>
        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('profil_lacrimar_poza', 'soclu')">mdi-close</v-icon>

            Poza profil lacrimar&nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('profil_lacrimar_poza', 'soclu')" @click="undo('profil_lacrimar_poza', 'soclu')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.soclu.profil_lacrimar_poza"
              hint="Poza profil lacrimar?"
              persistent-hint
              :disabled="user.dummy || entityObject.soclu.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>
        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('profil_lacrimar_nereguli', 'soclu')">mdi-close</v-icon>

            Nereguli profil lacrimar &nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('profil_lacrimar_nereguli', 'soclu')" @click="undo('profil_lacrimar_nereguli', 'soclu')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.soclu.profil_lacrimar_nereguli"
              hint="Nereguli profil lacrimar?"
              persistent-hint
              :disabled="user.dummy || entityObject.soclu.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>

        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('observatii', 'soclu')">mdi-close</v-icon>

            Observatii  &nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('observatii', 'soclu')" @click="undo('observatii', 'soclu')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-textarea
              @input="setField($event, 'observatii', 'soclu', null, false)"
              :value="entityObject.soclu.observatii"
              auto-grow
              :rows="1"
              hide-details
              hint="Observatii"
              persistent-hint
              solo flat
              :disabled="user.dummy || entityObject.soclu.disabled">
            </v-textarea>
          </v-card-text>
        </v-card>

        <v-card class="mb-3">
          <form ref="formsoclu">
            <input type="file" ref="fileinputsoclu" accept="image/*" multiple @change="filesAdded($event, 'soclu')" style="display: none">
          </form>
          <v-system-bar window class="px-1">
            Poze soclu &nbsp;
            <div style="display: inline-flex; flex-grow: 1; flex-wrap: wrap; align-items: center">
              <template>
                <v-icon class="ml-1" color="primary" title="Poze incarcate">mdi-camera</v-icon>
                {{noOfSocluPhotos}}
              </template>
              <template>
                <v-btn class="ma-0 ml-1 pa-0" icon flat @click.stop.prevent style="min-width: 0" :ripple="false">
                  <v-icon :color="socluFilesInQueue ? 'primary' : 'blue-grey'" class="mr-1" title="Poze in asteptare">mdi-cloud-upload</v-icon>
                  {{ socluFilesInQueue }}
                </v-btn>

                <v-spacer></v-spacer>
                <v-btn small class="ma-0" icon flat @click.stop.prevent="_cbAddPhoto('soclu')" v-if="user && !user.dummy" color="primary" :ripple="false">
                  <v-icon class="mr-0">mdi-plus-circle</v-icon>
                </v-btn>

                <!-- mark bad photos -->
                <v-btn small class="ma-0" icon flat @click.stop.prevent="_cbToggleBadMode" v-if="!user.dummy" :ripple="false">
                  <v-icon :color="badEnabled ? 'warning' : 'blue-grey'" class="mr-0">mdi-alert</v-icon>
                </v-btn>
                <v-btn small class="ma-0" icon flat @click.stop.prevent="_cbConfirmBad" v-show="badEnabled && toBad.length" :ripple="false">
                  <v-icon color="warning" class="mr-0">mdi-check-circle</v-icon>
                </v-btn>

                <!-- delete photos -->
                <v-btn small class="ma-0" icon flat @click.stop.prevent="_cbToggleDeleteMode" v-if="!user.dummy" :ripple="false">
                  <v-icon :color="deleteEnabled ? 'error' : 'blue-grey'" class="mr-0">mdi-delete-circle</v-icon>
                </v-btn>
                <v-btn small class="ma-0" icon flat @click.stop.prevent="_cbConfirmDelete" v-show="deleteEnabled && toDelete.length" :ripple="false">
                  <v-icon color="error" class="mr-0">mdi-check-circle</v-icon>
                </v-btn>
                <span v-show="deleteEnabled && toDelete.length">
                  {{toDelete.length}}
                </span>
              </template>
            </div>
          </v-system-bar>
          <v-card-text class="pa-1">
            <template v-if="noOfSocluPhotos">
              <viewer v-if="!deleteEnabled && !badEnabled" :options="{url: 'data-src', backdrop: 'static'}">
                <template>
                  <v-layout align-center justify-flex-start wrap>
                    <div style="display: flex; flex-wrap: wrap">
                      <template v-for="(photo, pIndex) in socluPhotos">
                        <div style="display: flex; flex-direction: column; align-items: center; width: 64px" :key="photo + pIndex">
                          <v-avatar
                            size="48"
                            class="ma-1 viewerPhoto"
                            style="box-sizing: border-box">
                            <img
                              :src="serverURL + photo.replace('photos', 'thumbs')"
                              :data-src="serverURL + photo"
                              class="pa-1">
                          </v-avatar>
                          <div style="display: flex; justify-content: space-around; width: 100%">
                            <a :href="serverURL + photo + '?buster=' + new Date().getTime()" download target="_blank" style="text-decoration: none" title="Descarca poza">
                              <v-icon small>mdi-download</v-icon>
                            </a>
                            <v-icon small color="warning" v-if="photo.includes('_badphoto')">mdi-alert</v-icon>
                            <a :href="serverURL + photo + '?buster=' + new Date().getTime()" target="_blank" style="text-decoration: none" title="Deschide poza intr-un tab nou">
                              <v-icon small>mdi-eye</v-icon>
                            </a>
                          </div>
                        </div>
                      </template>
                    </div>
                  </v-layout>
                </template>
              </viewer>
              <v-layout v-if="deleteEnabled" align-center justify-flex-start wrap>
                <!-- <v-scale-transition group> -->
                <template v-for="(photo, pIndex) in socluPhotos">
                  <div style="display: flex; flex-direction: column; align-items: center; width: 64px" :key="photo + pIndex">
                    <v-avatar
                      size="48"
                      class="ma-1"
                      :class="{ 'deletePhoto': toDelete.includes(photo), 'normalPhoto': !toDelete.includes(photo) }"
                      style="box-sizing: border-box"
                      @click="selectPhoto(photo)">
                      <img
                        :src="serverURL + photo.replace('photos', 'thumbs')"
                        :data-src="serverURL + photo"
                        class="pa-1">
                    </v-avatar>
                    <v-icon small color="warning" v-if="photo.includes('_badphoto')">mdi-alert</v-icon>
                  </div>
                </template>
                <!-- </v-scale-transition> -->
              </v-layout>
              <v-layout v-if="badEnabled" align-center justify-flex-start wrap>
                <!-- <v-scale-transition group> -->
                <template v-for="(photo, pIndex) in socluPhotos">
                  <div style="display: flex; flex-direction: column; align-items: center; width: 64px" :key="photo + pIndex">
                    <v-avatar
                      size="48"
                      class="ma-1"
                      :class="{ 'badPhoto': toBad.includes(photo), 'normalPhoto': !toBad.includes(photo) }"
                      style="box-sizing: border-box"
                      @click="selectBadPhoto(photo)">
                      <img
                        :src="serverURL + photo.replace('photos', 'thumbs')"
                        :data-src="serverURL + photo"
                        class="pa-1">
                    </v-avatar>
                    <v-icon small color="warning" v-if="photo.includes('_badphoto')">mdi-alert</v-icon>
                  </div>
                </template>
                <!-- </v-scale-transition> -->
              </v-layout>
            </template>
            <template v-else>
              Nu exista poze pentru soclu.
            </template>
          </v-card-text>
        </v-card>
      </v-card>

      <v-card class="mb-2" v-if="visibleFields.includes('terasa')">
        <v-card-title class="accent--text title" style="justify-content: space-between">
          Terasa
          <v-icon :color="entityObject.terasa.disabled ? 'grey' : 'primary'" @click="_cbToggleSectionDisabled('terasa')">
            {{ entityObject.terasa.disabled ? 'mdi-toggle-switch-off-outline' : 'mdi-toggle-switch' }}
          </v-icon>
        </v-card-title>
        <v-divider color="accent"></v-divider>

        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('balustrada_protectie', 'terasa')">mdi-close</v-icon>

            Balustrada protectie&nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('balustrada_protectie', 'terasa')" @click="undo('balustrada_protectie', 'terasa')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.terasa.balustrada_protectie"
              hint="Balustrada protectie?"
              persistent-hint
              :disabled="user.dummy || entityObject.terasa.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>
        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('balustrada_protectie_poza', 'terasa')">mdi-close</v-icon>

            Poza balustrada protectie&nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('balustrada_protectie_poza', 'terasa')" @click="undo('balustrada_protectie_poza', 'terasa')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.terasa.balustrada_protectie_poza"
              hint="Poza balustrada protectie?"
              persistent-hint
              :disabled="user.dummy || entityObject.terasa.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>
        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('balustrada_protectie_nereguli', 'terasa')">mdi-close</v-icon>

            Nereguli balustrada protectie &nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('balustrada_protectie_nereguli', 'terasa')" @click="undo('balustrada_protectie_nereguli', 'terasa')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.terasa.balustrada_protectie_nereguli"
              hint="Nereguli balustrada protectie?"
              persistent-hint
              :disabled="user.dummy || entityObject.terasa.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>

        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('parafrunzare', 'terasa')">mdi-close</v-icon>

            Parafrunzare&nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('parafrunzare', 'terasa')" @click="undo('parafrunzare', 'terasa')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.terasa.parafrunzare"
              hint="Parafrunzare?"
              persistent-hint
              :disabled="user.dummy || entityObject.terasa.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>
        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('parafrunzare_poza', 'terasa')">mdi-close</v-icon>

            Poza parafrunzare&nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('parafrunzare_poza', 'terasa')" @click="undo('parafrunzare_poza', 'terasa')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.terasa.parafrunzare_poza"
              hint="Poza parafrunzare?"
              persistent-hint
              :disabled="user.dummy || entityObject.terasa.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>
        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('parafrunzare_nereguli', 'terasa')">mdi-close</v-icon>

            Nereguli parafrunzare &nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('parafrunzare_nereguli', 'terasa')" @click="undo('parafrunzare_nereguli', 'terasa')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.terasa.parafrunzare_nereguli"
              hint="Nereguli parafrunzare?"
              persistent-hint
              :disabled="user.dummy || entityObject.terasa.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>

        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('coloane_ventilatie_capace', 'terasa')">mdi-close</v-icon>

            Coloane ventilatie capace&nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('coloane_ventilatie_capace', 'terasa')" @click="undo('coloane_ventilatie_capace', 'terasa')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.terasa.coloane_ventilatie_capace"
              hint="Coloane ventilatie capace?"
              persistent-hint
              :disabled="user.dummy || entityObject.terasa.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>
        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('coloane_ventilatie_capace_poza', 'terasa')">mdi-close</v-icon>

            Poza coloane ventilatie capace&nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('coloane_ventilatie_capace_poza', 'terasa')" @click="undo('coloane_ventilatie_capace_poza', 'terasa')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.terasa.coloane_ventilatie_capace_poza"
              hint="Poza coloane ventilatie capace?"
              persistent-hint
              :disabled="user.dummy || entityObject.terasa.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>
        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('coloane_ventilatie_capace_nereguli', 'terasa')">mdi-close</v-icon>

            Nereguli coloane ventilatie capace &nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('coloane_ventilatie_capace_nereguli', 'terasa')" @click="undo('coloane_ventilatie_capace_nereguli', 'terasa')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.terasa.coloane_ventilatie_capace_nereguli"
              hint="Nereguli coloane ventilatie capace?"
              persistent-hint
              :disabled="user.dummy || entityObject.terasa.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>

        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('inaltare_coloane_ventilatie', 'terasa')">mdi-close</v-icon>

            Inaltare coloane ventilatie&nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('inaltare_coloane_ventilatie', 'terasa')" @click="undo('inaltare_coloane_ventilatie', 'terasa')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.terasa.inaltare_coloane_ventilatie"
              hint="Inaltare coloane ventilatie?"
              persistent-hint
              :disabled="user.dummy || entityObject.terasa.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>
        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('inaltare_coloane_ventilatie_poza', 'terasa')">mdi-close</v-icon>

            Poza inaltare coloane ventilatie&nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('inaltare_coloane_ventilatie_poza', 'terasa')" @click="undo('inaltare_coloane_ventilatie_poza', 'terasa')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.terasa.inaltare_coloane_ventilatie_poza"
              hint="Poza inaltare coloane ventilatie?"
              persistent-hint
              :disabled="user.dummy || entityObject.terasa.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>
        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('inaltare_coloane_ventilatie_nereguli', 'terasa')">mdi-close</v-icon>

            Nereguli inaltare coloane ventilatie &nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('inaltare_coloane_ventilatie_nereguli', 'terasa')" @click="undo('inaltare_coloane_ventilatie_nereguli', 'terasa')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.terasa.inaltare_coloane_ventilatie_nereguli"
              hint="Nereguli inaltare coloane ventilatie?"
              persistent-hint
              :disabled="user.dummy || entityObject.terasa.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>

        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('aeratoare', 'terasa')">mdi-close</v-icon>

            Aeratoare&nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('aeratoare', 'terasa')" @click="undo('aeratoare', 'terasa')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.terasa.aeratoare"
              hint="Aeratoare?"
              persistent-hint
              :disabled="user.dummy || entityObject.terasa.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>
        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('aeratoare_poza', 'terasa')">mdi-close</v-icon>

            Poza aeratoare&nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('aeratoare_poza', 'terasa')" @click="undo('aeratoare_poza', 'terasa')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.terasa.aeratoare_poza"
              hint="Poza aeratoare?"
              persistent-hint
              :disabled="user.dummy || entityObject.terasa.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>
        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('aeratoare_nereguli', 'terasa')">mdi-close</v-icon>

            Nereguli aeratoare &nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('aeratoare_nereguli', 'terasa')" @click="undo('aeratoare_nereguli', 'terasa')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.terasa.aeratoare_nereguli"
              hint="Nereguli aeratoare?"
              persistent-hint
              :disabled="user.dummy || entityObject.terasa.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>

        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('acumulare_apa', 'terasa')">mdi-close</v-icon>

            Acumulare apa&nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('acumulare_apa', 'terasa')" @click="undo('acumulare_apa', 'terasa')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.terasa.acumulare_apa"
              hint="Acumulare apa?"
              persistent-hint
              :disabled="user.dummy || entityObject.terasa.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>
        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('acumulare_apa_poza', 'terasa')">mdi-close</v-icon>

            Poza acumulare apa&nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('acumulare_apa_poza', 'terasa')" @click="undo('acumulare_apa_poza', 'terasa')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.terasa.acumulare_apa_poza"
              hint="Poza acumulare apa?"
              persistent-hint
              :disabled="user.dummy || entityObject.terasa.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>
        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('acumulare_apa_nereguli', 'terasa')">mdi-close</v-icon>

            Nereguli acumulare apa &nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('acumulare_apa_nereguli', 'terasa')" @click="undo('acumulare_apa_nereguli', 'terasa')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.terasa.acumulare_apa_nereguli"
              hint="Nereguli acumulare apa?"
              persistent-hint
              :disabled="user.dummy || entityObject.terasa.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>

        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('strat_carton_bitum_dezlipit', 'terasa')">mdi-close</v-icon>

            Strat carton bitum dezlipit&nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('strat_carton_bitum_dezlipit', 'terasa')" @click="undo('strat_carton_bitum_dezlipit', 'terasa')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.terasa.strat_carton_bitum_dezlipit"
              hint="Strat carton bitum dezlipit?"
              persistent-hint
              :disabled="user.dummy || entityObject.terasa.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>
        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('strat_carton_bitum_dezlipit_poza', 'terasa')">mdi-close</v-icon>

            Poza strat carton bitum dezlipit&nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('strat_carton_bitum_dezlipit_poza', 'terasa')" @click="undo('strat_carton_bitum_dezlipit_poza', 'terasa')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.terasa.strat_carton_bitum_dezlipit_poza"
              hint="Poza strat carton bitum dezlipit?"
              persistent-hint
              :disabled="user.dummy || entityObject.terasa.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>
        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('strat_carton_bitum_dezlipit_nereguli', 'terasa')">mdi-close</v-icon>

            Nereguli strat carton bitum dezlipit &nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('strat_carton_bitum_dezlipit_nereguli', 'terasa')" @click="undo('strat_carton_bitum_dezlipit_nereguli', 'terasa')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.terasa.strat_carton_bitum_dezlipit_nereguli"
              hint="Nereguli strat carton bitum dezlipit?"
              persistent-hint
              :disabled="user.dummy || entityObject.terasa.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>

        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('usa_acces_terasa_pvc', 'terasa')">mdi-close</v-icon>

            Usa acces terasa pvc &nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('usa_acces_terasa_pvc', 'terasa')" @click="undo('usa_acces_terasa_pvc', 'terasa')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.terasa.usa_acces_terasa_pvc"
              hint="Usa acces terasa pvc?"
              persistent-hint
              :disabled="user.dummy || entityObject.terasa.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>
        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('usa_acces_terasa_pvc_poza', 'terasa')">mdi-close</v-icon>

            Poza usa acces terasa pvc&nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('usa_acces_terasa_pvc_poza', 'terasa')" @click="undo('usa_acces_terasa_pvc_poza', 'terasa')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.terasa.usa_acces_terasa_pvc_poza"
              hint="Poza usa acces terasa pvc?"
              persistent-hint
              :disabled="user.dummy || entityObject.terasa.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>
        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('usa_acces_terasa_pvc_nereguli', 'terasa')">mdi-close</v-icon>

            Nereguli usa acces terasa pvc &nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('usa_acces_terasa_pvc_nereguli', 'terasa')" @click="undo('usa_acces_terasa_pvc_nereguli', 'terasa')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.terasa.usa_acces_terasa_pvc_nereguli"
              hint="Nereguli usa acces terasa pvc?"
              persistent-hint
              :disabled="user.dummy || entityObject.terasa.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>

        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('chepeng_terasa_pvc', 'terasa')">mdi-close</v-icon>

            Chepeng terasa pvc &nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('chepeng_terasa_pvc', 'terasa')" @click="undo('chepeng_terasa_pvc', 'terasa')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.terasa.chepeng_terasa_pvc"
              hint="Chepeng terasa pvc?"
              persistent-hint
              :disabled="user.dummy || entityObject.terasa.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>
        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('chepeng_terasa_pvc_poza', 'terasa')">mdi-close</v-icon>

            Poza chepeng terasa pvc&nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('chepeng_terasa_pvc_poza', 'terasa')" @click="undo('chepeng_terasa_pvc_poza', 'terasa')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.terasa.chepeng_terasa_pvc_poza"
              hint="Poza chepeng terasa pvc?"
              persistent-hint
              :disabled="user.dummy || entityObject.terasa.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>
        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('chepeng_terasa_pvc_nereguli', 'terasa')">mdi-close</v-icon>

            Nereguli chepeng terasa pvc &nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('chepeng_terasa_pvc_nereguli', 'terasa')" @click="undo('chepeng_terasa_pvc_nereguli', 'terasa')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.terasa.chepeng_terasa_pvc_nereguli"
              hint="Nereguli chepeng terasa pvc?"
              persistent-hint
              :disabled="user.dummy || entityObject.terasa.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>

        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('jgheab_montat_corect', 'terasa')">mdi-close</v-icon>

            Jgheab montat corect &nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('jgheab_montat_corect', 'terasa')" @click="undo('jgheab_montat_corect', 'terasa')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.terasa.jgheab_montat_corect"
              hint="Jgheab montat corect?"
              persistent-hint
              :disabled="user.dummy || entityObject.terasa.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>
        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('jgheab_montat_corect_poza', 'terasa')">mdi-close</v-icon>

            Poza jgheab montat corect&nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('jgheab_montat_corect_poza', 'terasa')" @click="undo('jgheab_montat_corect_poza', 'terasa')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.terasa.jgheab_montat_corect_poza"
              hint="Poza jgheab montat corect?"
              persistent-hint
              :disabled="user.dummy || entityObject.terasa.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>
        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('jgheab_montat_corect_nereguli', 'terasa')">mdi-close</v-icon>

            Nereguli jgheab montat corect &nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('jgheab_montat_corect_nereguli', 'terasa')" @click="undo('jgheab_montat_corect_nereguli', 'terasa')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.terasa.jgheab_montat_corect_nereguli"
              hint="Nereguli jgheab montat corect?"
              persistent-hint
              :disabled="user.dummy || entityObject.terasa.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>

        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('sort_tabla_atic', 'terasa')">mdi-close</v-icon>

            Sort tabla atic &nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('sort_tabla_atic', 'terasa')" @click="undo('sort_tabla_atic', 'terasa')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.terasa.sort_tabla_atic"
              hint="Sort tabla atic?"
              persistent-hint
              :disabled="user.dummy || entityObject.terasa.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>
        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('sort_tabla_atic_poza', 'terasa')">mdi-close</v-icon>

            Poza sort tabla atic&nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('sort_tabla_atic_poza', 'terasa')" @click="undo('sort_tabla_atic_poza', 'terasa')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.terasa.sort_tabla_atic_poza"
              hint="Poza sort tabla atic?"
              persistent-hint
              :disabled="user.dummy || entityObject.terasa.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>
        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('sort_tabla_atic_nereguli', 'terasa')">mdi-close</v-icon>

            Nereguli sort tabla atic &nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('sort_tabla_atic_nereguli', 'terasa')" @click="undo('sort_tabla_atic_nereguli', 'terasa')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.terasa.sort_tabla_atic_nereguli"
              hint="Nereguli sort tabla atic?"
              persistent-hint
              :disabled="user.dummy || entityObject.terasa.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>

        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('imbinare_carton_bit_perete', 'terasa')">mdi-close</v-icon>

            Imbinare carton bit perete &nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('imbinare_carton_bit_perete', 'terasa')" @click="undo('imbinare_carton_bit_perete', 'terasa')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.terasa.imbinare_carton_bit_perete"
              hint="Imbinare carton bit perete?"
              persistent-hint
              :disabled="user.dummy || entityObject.terasa.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>
        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('imbinare_carton_bit_perete_poza', 'terasa')">mdi-close</v-icon>

            Poza imbinare carton bit perete&nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('imbinare_carton_bit_perete_poza', 'terasa')" @click="undo('imbinare_carton_bit_perete_poza', 'terasa')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.terasa.imbinare_carton_bit_perete_poza"
              hint="Poza imbinare carton bit perete?"
              persistent-hint
              :disabled="user.dummy || entityObject.terasa.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>
        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('imbinare_carton_bit_perete_nereguli', 'terasa')">mdi-close</v-icon>

            Nereguli imbinare carton bit perete &nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('imbinare_carton_bit_perete_nereguli', 'terasa')" @click="undo('imbinare_carton_bit_perete_nereguli', 'terasa')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.terasa.imbinare_carton_bit_perete_nereguli"
              hint="Nereguli imbinare carton bit perete?"
              persistent-hint
              :disabled="user.dummy || entityObject.terasa.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>

        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('rosturi_intre_tronsoane', 'terasa')">mdi-close</v-icon>

            Rosturi intre tronsoane &nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('rosturi_intre_tronsoane', 'terasa')" @click="undo('rosturi_intre_tronsoane', 'terasa')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.terasa.rosturi_intre_tronsoane"
              hint="Rosturi intre tronsoane?"
              persistent-hint
              :disabled="user.dummy || entityObject.terasa.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>
        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('rosturi_intre_tronsoane_poza', 'terasa')">mdi-close</v-icon>

            Poza rosturi intre tronsoane&nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('rosturi_intre_tronsoane_poza', 'terasa')" @click="undo('rosturi_intre_tronsoane_poza', 'terasa')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.terasa.rosturi_intre_tronsoane_poza"
              hint="Poza rosturi intre tronsoane?"
              persistent-hint
              :disabled="user.dummy || entityObject.terasa.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>
        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('rosturi_intre_tronsoane_nereguli', 'terasa')">mdi-close</v-icon>

            Nereguli rosturi intre tronsoane &nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('rosturi_intre_tronsoane_nereguli', 'terasa')" @click="undo('rosturi_intre_tronsoane_nereguli', 'terasa')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.terasa.rosturi_intre_tronsoane_nereguli"
              hint="Nereguli rosturi intre tronsoane?"
              persistent-hint
              :disabled="user.dummy || entityObject.terasa.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>

        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('observatii', 'terasa')">mdi-close</v-icon>

            Observatii  &nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('observatii', 'terasa')" @click="undo('observatii', 'terasa')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-textarea
              @input="setField($event, 'observatii', 'terasa', null, false)"
              :value="entityObject.terasa.observatii"
              auto-grow
              :rows="1"
              hide-details
              hint="Observatii"
              persistent-hint
              solo flat
              :disabled="user.dummy || entityObject.terasa.disabled">
            </v-textarea>
          </v-card-text>
        </v-card>

        <v-card class="mb-3">
          <form ref="formterasa">
            <input type="file" ref="fileinputterasa" accept="image/*" multiple @change="filesAdded($event, 'terasa')" style="display: none">
          </form>
          <v-system-bar window class="px-1">
            Poze terasa &nbsp;
            <div style="display: inline-flex; flex-grow: 1; flex-wrap: wrap; align-items: center">
              <template>
                <v-icon class="ml-1" color="primary" title="Poze incarcate">mdi-camera</v-icon>
                {{noOfTerasaPhotos}}
              </template>
              <template>
                <v-btn class="ma-0 ml-1 pa-0" icon flat @click.stop.prevent style="min-width: 0" :ripple="false">
                  <v-icon :color="terasaFilesInQueue ? 'primary' : 'blue-grey'" class="mr-1" title="Poze in asteptare">mdi-cloud-upload</v-icon>
                  {{ terasaFilesInQueue }}
                </v-btn>

                <v-spacer></v-spacer>
                <v-btn small class="ma-0" icon flat @click.stop.prevent="_cbAddPhoto('terasa')" v-if="user && !user.dummy" color="primary" :ripple="false">
                  <v-icon class="mr-0">mdi-plus-circle</v-icon>
                </v-btn>

                <!-- mark bad photos -->
                <v-btn small class="ma-0" icon flat @click.stop.prevent="_cbToggleBadMode" v-if="!user.dummy" :ripple="false">
                  <v-icon :color="badEnabled ? 'warning' : 'blue-grey'" class="mr-0">mdi-alert</v-icon>
                </v-btn>
                <v-btn small class="ma-0" icon flat @click.stop.prevent="_cbConfirmBad" v-show="badEnabled && toBad.length" :ripple="false">
                  <v-icon color="warning" class="mr-0">mdi-check-circle</v-icon>
                </v-btn>

                <!-- delete photos -->
                <v-btn small class="ma-0" icon flat @click.stop.prevent="_cbToggleDeleteMode" v-if="!user.dummy" :ripple="false">
                  <v-icon :color="deleteEnabled ? 'error' : 'blue-grey'" class="mr-0">mdi-delete-circle</v-icon>
                </v-btn>
                <v-btn small class="ma-0" icon flat @click.stop.prevent="_cbConfirmDelete" v-show="deleteEnabled && toDelete.length" :ripple="false">
                  <v-icon color="error" class="mr-0">mdi-check-circle</v-icon>
                </v-btn>
                <span v-show="deleteEnabled && toDelete.length">
                  {{toDelete.length}}
                </span>

              </template>
            </div>
          </v-system-bar>
          <v-card-text class="pa-1">
            <template v-if="noOfTerasaPhotos">
              <viewer v-if="!deleteEnabled && !badEnabled" :options="{url: 'data-src', backdrop: 'static'}">
                <template>
                  <v-layout align-center justify-flex-start wrap>
                    <div style="display: flex; flex-wrap: wrap">
                      <template v-for="(photo, pIndex) in terasaPhotos">
                        <div style="display: flex; flex-direction: column; align-items: center; width: 64px" :key="photo + pIndex">
                          <v-avatar
                            size="48"
                            class="ma-1 viewerPhoto"
                            style="box-sizing: border-box">
                            <img
                              :src="serverURL + photo.replace('photos', 'thumbs')"
                              :data-src="serverURL + photo"
                              class="pa-1">
                          </v-avatar>
                          <div style="display: flex; justify-content: space-around; width: 100%">
                            <a :href="serverURL + photo + '?buster=' + new Date().getTime()" download target="_blank" style="text-decoration: none" title="Descarca poza">
                              <v-icon small>mdi-download</v-icon>
                            </a>
                            <v-icon small color="warning" v-if="photo.includes('_badphoto')">mdi-alert</v-icon>
                            <a :href="serverURL + photo + '?buster=' + new Date().getTime()" target="_blank" style="text-decoration: none" title="Deschide poza intr-un tab nou">
                              <v-icon small>mdi-eye</v-icon>
                            </a>
                          </div>
                        </div>
                      </template>
                    </div>
                  </v-layout>
                </template>
              </viewer>
              <v-layout v-if="deleteEnabled" align-center justify-flex-start wrap>
                <!-- <v-scale-transition group> -->
                <template v-for="(photo, pIndex) in terasaPhotos">
                  <div style="display: flex; flex-direction: column; align-items: center; width: 64px" :key="photo + pIndex">
                    <v-avatar
                      size="48"
                      class="ma-1"
                      :class="{ 'deletePhoto': toDelete.includes(photo), 'normalPhoto': !toDelete.includes(photo) }"
                      style="box-sizing: border-box"
                      @click="selectPhoto(photo)">
                      <img
                        :src="serverURL + photo.replace('photos', 'thumbs')"
                        :data-src="serverURL + photo"
                        class="pa-1">
                    </v-avatar>
                    <v-icon small color="warning" v-if="photo.includes('_badphoto')">mdi-alert</v-icon>
                  </div>
                </template>
                <!-- </v-scale-transition> -->
              </v-layout>
              <v-layout v-if="badEnabled" align-center justify-flex-start wrap>
                <!-- <v-scale-transition group> -->
                <template v-for="(photo, pIndex) in terasaPhotos">
                  <div style="display: flex; flex-direction: column; align-items: center; width: 64px" :key="photo + pIndex">
                    <v-avatar
                      size="48"
                      class="ma-1"
                      :class="{ 'badPhoto': toBad.includes(photo), 'normalPhoto': !toBad.includes(photo) }"
                      style="box-sizing: border-box"
                      @click="selectBadPhoto(photo)">
                      <img
                        :src="serverURL + photo.replace('photos', 'thumbs')"
                        :data-src="serverURL + photo"
                        class="pa-1">
                    </v-avatar>
                    <v-icon small color="warning" v-if="photo.includes('_badphoto')">mdi-alert</v-icon>
                  </div>
                </template>
                <!-- </v-scale-transition> -->
              </v-layout>
            </template>
            <template v-else>
              Nu exista poze pentru terasa.
            </template>
          </v-card-text>
        </v-card>
      </v-card>

      <v-card class="mb-2" v-if="visibleFields.includes('planseu sub pod')">
        <v-card-title class="accent--text title" style="justify-content: space-between">
          Planseu sub pod
          <v-icon :color="entityObject.planseu_sub_pod.disabled ? 'grey' : 'primary'" @click="_cbToggleSectionDisabled('planseu_sub_pod')">
            {{ entityObject.planseu_sub_pod.disabled ? 'mdi-toggle-switch-off-outline' : 'mdi-toggle-switch' }}
          </v-icon>
        </v-card-title>
        <v-divider color="accent"></v-divider>

        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('grosime_izolatie', 'planseu_sub_pod')">mdi-close</v-icon>

            Grosime izolatie &nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('grosime_izolatie', 'planseu_sub_pod')" @click="undo('grosime_izolatie', 'planseu_sub_pod')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-text-field
              @input="setField($event, 'grosime_izolatie', 'planseu_sub_pod', null, true)"
              :value="entityObject.planseu_sub_pod.grosime_izolatie"
              hint="Grosime izolatie."
              type="number"
              @wheel="onWheel"
              persistent-hint
              :min="0"
              :max="150"
              validate-on-blur
              :rules="[val => val !== null || 'Camp obligatoriu!', val => (val >=0 && val <= 150) || 'Valoarea introdusa nu se incadreaza in intervalul [0, 150].']"
              solo flat
              suffix="cm"
              :disabled="user.dummy || entityObject.planseu_sub_pod.disabled">
            </v-text-field>
          </v-card-text>
        </v-card>
        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('grosime_izolatie_poza', 'planseu_sub_pod')">mdi-close</v-icon>

            Poza grosime izolatie&nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('grosime_izolatie_poza', 'planseu_sub_pod')" @click="undo('grosime_izolatie_poza', 'planseu_sub_pod')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.planseu_sub_pod.grosime_izolatie_poza"
              hint="Poza grosime izolatie?"
              persistent-hint
              :disabled="user.dummy || entityObject.planseu_sub_pod.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>
        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('grosime_izolatie_nereguli', 'planseu_sub_pod')">mdi-close</v-icon>

            Nereguli grosime izolatie &nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('grosime_izolatie_nereguli', 'planseu_sub_pod')" @click="undo('grosime_izolatie_nereguli', 'planseu_sub_pod')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.planseu_sub_pod.grosime_izolatie_nereguli"
              hint="Nereguli grosime izolatie?"
              persistent-hint
              :disabled="user.dummy || entityObject.planseu_sub_pod.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>

        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('stare_acoperis_poza', 'planseu_sub_pod')">mdi-close</v-icon>

            Poza stare acoperis&nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('stare_acoperis_poza', 'planseu_sub_pod')" @click="undo('stare_acoperis_poza', 'planseu_sub_pod')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.planseu_sub_pod.stare_acoperis_poza"
              hint="Poza stare acoperis?"
              persistent-hint
              :disabled="user.dummy || entityObject.planseu_sub_pod.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>
        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('stare_acoperis_nereguli', 'planseu_sub_pod')">mdi-close</v-icon>

            Nereguli stare acoperis &nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('stare_acoperis_nereguli', 'planseu_sub_pod')" @click="undo('stare_acoperis_nereguli', 'planseu_sub_pod')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.planseu_sub_pod.stare_acoperis_nereguli"
              hint="Nereguli stare acoperis?"
              persistent-hint
              :disabled="user.dummy || entityObject.planseu_sub_pod.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>

        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('observatii', 'planseu_sub_pod')">mdi-close</v-icon>

            Observatii  &nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('observatii', 'planseu_sub_pod')" @click="undo('observatii', 'planseu_sub_pod')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-textarea
              @input="setField($event, 'observatii', 'planseu_sub_pod', null, false)"
              :value="entityObject.planseu_sub_pod.observatii"
              auto-grow
              :rows="1"
              hide-details
              hint="Observatii"
              persistent-hint
              solo flat
              :disabled="user.dummy || entityObject.planseu_sub_pod.disabled">
            </v-textarea>
          </v-card-text>
        </v-card>

        <v-card class="mb-3">
          <form ref="formplanseusubpod">
            <input type="file" ref="fileinputplanseusubpod" accept="image/*" multiple @change="filesAdded($event, 'planseusubpod')" style="display: none">
          </form>
          <v-system-bar window class="px-1">
            Poze planseu sub pod &nbsp;
            <div style="display: inline-flex; flex-grow: 1; flex-wrap: wrap; align-items: center">
              <template>
                <v-icon class="ml-1" color="primary" title="Poze incarcate">mdi-camera</v-icon>
                {{noOfPlanseusubpodPhotos}}
              </template>
              <template>
                <v-btn class="ma-0 ml-1 pa-0" icon flat @click.stop.prevent style="min-width: 0" :ripple="false">
                  <v-icon :color="planseusubpodFilesInQueue ? 'primary' : 'blue-grey'" class="mr-1" title="Poze in asteptare">mdi-cloud-upload</v-icon>
                  {{ planseusubpodFilesInQueue }}
                </v-btn>

                <v-spacer></v-spacer>
                <v-btn small class="ma-0" icon flat @click.stop.prevent="_cbAddPhoto('planseusubpod')" v-if="user && !user.dummy" color="primary" :ripple="false">
                  <v-icon class="mr-0">mdi-plus-circle</v-icon>
                </v-btn>

                <!-- mark bad photos -->
                <v-btn small class="ma-0" icon flat @click.stop.prevent="_cbToggleBadMode" v-if="!user.dummy" :ripple="false">
                  <v-icon :color="badEnabled ? 'warning' : 'blue-grey'" class="mr-0">mdi-alert</v-icon>
                </v-btn>
                <v-btn small class="ma-0" icon flat @click.stop.prevent="_cbConfirmBad" v-show="badEnabled && toBad.length" :ripple="false">
                  <v-icon color="warning" class="mr-0">mdi-check-circle</v-icon>
                </v-btn>

                <!-- delete photos -->
                <v-btn small class="ma-0" icon flat @click.stop.prevent="_cbToggleDeleteMode" v-if="!user.dummy" :ripple="false">
                  <v-icon :color="deleteEnabled ? 'error' : 'blue-grey'" class="mr-0">mdi-delete-circle</v-icon>
                </v-btn>
                <v-btn small class="ma-0" icon flat @click.stop.prevent="_cbConfirmDelete" v-show="deleteEnabled && toDelete.length" :ripple="false">
                  <v-icon color="error" class="mr-0">mdi-check-circle</v-icon>
                </v-btn>
                <span v-show="deleteEnabled && toDelete.length">
                  {{toDelete.length}}
                </span>

              </template>
            </div>
          </v-system-bar>
          <v-card-text class="pa-1">
            <template v-if="noOfPlanseusubpodPhotos">
              <viewer v-if="!deleteEnabled && !badEnabled" :options="{url: 'data-src', backdrop: 'static'}">
                <template>
                  <v-layout align-center justify-flex-start wrap>
                    <div style="display: flex; flex-wrap: wrap">
                      <template v-for="(photo, pIndex) in planseusubpodPhotos">
                        <div style="display: flex; flex-direction: column; align-items: center; width: 64px" :key="photo + pIndex">
                          <v-avatar
                            size="48"
                            class="ma-1 viewerPhoto"
                            style="box-sizing: border-box">
                            <img
                              :src="serverURL + photo.replace('photos', 'thumbs')"
                              :data-src="serverURL + photo"
                              class="pa-1">
                          </v-avatar>
                          <div style="display: flex; justify-content: space-around; width: 100%">
                            <a :href="serverURL + photo + '?buster=' + new Date().getTime()" download target="_blank" style="text-decoration: none" title="Descarca poza">
                              <v-icon small>mdi-download</v-icon>
                            </a>
                            <v-icon small color="warning" v-if="photo.includes('_badphoto')">mdi-alert</v-icon>
                            <a :href="serverURL + photo + '?buster=' + new Date().getTime()" target="_blank" style="text-decoration: none" title="Deschide poza intr-un tab nou">
                              <v-icon small>mdi-eye</v-icon>
                            </a>
                          </div>
                        </div>
                      </template>
                    </div>
                  </v-layout>
                </template>
              </viewer>
              <v-layout v-if="deleteEnabled" align-center justify-flex-start wrap>
                <!-- <v-scale-transition group> -->
                <template v-for="(photo, pIndex) in planseusubpodPhotos">
                  <div style="display: flex; flex-direction: column; align-items: center; width: 64px" :key="photo + pIndex">
                    <v-avatar
                      size="48"
                      class="ma-1"
                      :class="{ 'deletePhoto': toDelete.includes(photo), 'normalPhoto': !toDelete.includes(photo) }"
                      style="box-sizing: border-box"
                      @click="selectPhoto(photo)">
                      <img
                        :src="serverURL + photo.replace('photos', 'thumbs')"
                        :data-src="serverURL + photo"
                        class="pa-1">
                    </v-avatar>
                    <v-icon small color="warning" v-if="photo.includes('_badphoto')">mdi-alert</v-icon>
                  </div>
                </template>
                <!-- </v-scale-transition> -->
              </v-layout>
              <v-layout v-if="badEnabled" align-center justify-flex-start wrap>
                <!-- <v-scale-transition group> -->
                <template v-for="(photo, pIndex) in planseusubpodPhotos">
                  <div style="display: flex; flex-direction: column; align-items: center; width: 64px" :key="photo + pIndex">
                    <v-avatar
                      size="48"
                      class="ma-1"
                      :class="{ 'badPhoto': toBad.includes(photo), 'normalPhoto': !toBad.includes(photo) }"
                      style="box-sizing: border-box"
                      @click="selectBadPhoto(photo)">
                      <img
                        :src="serverURL + photo.replace('photos', 'thumbs')"
                        :data-src="serverURL + photo"
                        class="pa-1">
                    </v-avatar>
                    <v-icon small color="warning" v-if="photo.includes('_badphoto')">mdi-alert</v-icon>
                  </div>
                </template>
                <!-- </v-scale-transition> -->
              </v-layout>
            </template>
            <template v-else>
              Nu exista poze pentru planseu sub pod.
            </template>
          </v-card-text>
        </v-card>
      </v-card>

      <v-card class="mb-2" v-if="visibleFields.includes('planseu subsol')">
        <v-card-title class="accent--text title" style="justify-content: space-between">
          Planseu subsol
          <v-icon :color="entityObject.planseu_subsol.disabled ? 'grey' : 'primary'" @click="_cbToggleSectionDisabled('planseu_subsol')">
            {{ entityObject.planseu_subsol.disabled ? 'mdi-toggle-switch-off-outline' : 'mdi-toggle-switch' }}
          </v-icon>
        </v-card-title>
        <v-divider color="accent"></v-divider>

        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('grosime_izolatie', 'planseu_subsol')">mdi-close</v-icon>

            Grosime izolatie &nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('grosime_izolatie', 'planseu_subsol')" @click="undo('grosime_izolatie', 'planseu_subsol')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-text-field
              @input="setField($event, 'grosime_izolatie', 'planseu_subsol', null, true)"
              :value="entityObject.planseu_subsol.grosime_izolatie"
              hint="Grosime izolatie."
              type="number"
              @wheel="onWheel"
              persistent-hint
              :min="0"
              :max="150"
              validate-on-blur
              :rules="[val => val !== null || 'Camp obligatoriu!', val => (val >=0 && val <= 150) || 'Valoarea introdusa nu se incadreaza in intervalul [0, 150].']"
              solo flat
              suffix="cm"
              :disabled="user.dummy || entityObject.planseu_subsol.disabled">
            </v-text-field>
          </v-card-text>
        </v-card>
        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('grosime_izolatie_poza', 'planseu_subsol')">mdi-close</v-icon>

            Poza grosime izolatie&nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('grosime_izolatie_poza', 'planseu_subsol')" @click="undo('grosime_izolatie_poza', 'planseu_subsol')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.planseu_subsol.grosime_izolatie_poza"
              hint="Poza grosime izolatie?"
              persistent-hint
              :disabled="user.dummy || entityObject.planseu_subsol.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>
        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('grosime_izolatie_nereguli', 'planseu_subsol')">mdi-close</v-icon>

            Nereguli grosime izolatie &nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('grosime_izolatie_nereguli', 'planseu_subsol')" @click="undo('grosime_izolatie_nereguli', 'planseu_subsol')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.planseu_subsol.grosime_izolatie_nereguli"
              hint="Nereguli grosime izolatie?"
              persistent-hint
              :disabled="user.dummy || entityObject.planseu_subsol.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>

        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('corpuri_iluminat_scoase_la_ras', 'planseu_subsol')">mdi-close</v-icon>

            Corpuri iluminat scoase la ras&nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('corpuri_iluminat_scoase_la_ras', 'planseu_subsol')" @click="undo('corpuri_iluminat_scoase_la_ras', 'planseu_subsol')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.planseu_subsol.corpuri_iluminat_scoase_la_ras"
              hint="Corpuri iluminat scoase la ras?"
              persistent-hint
              :disabled="user.dummy || entityObject.planseu_subsol.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>
        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('corpuri_iluminat_scoase_la_ras_poza', 'planseu_subsol')">mdi-close</v-icon>

            Poza corpuri iluminat scoase la ras&nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('corpuri_iluminat_scoase_la_ras_poza', 'planseu_subsol')" @click="undo('corpuri_iluminat_scoase_la_ras_poza', 'planseu_subsol')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.planseu_subsol.corpuri_iluminat_scoase_la_ras_poza"
              hint="Poza corpuri iluminat scoase la ras?"
              persistent-hint
              :disabled="user.dummy || entityObject.planseu_subsol.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>
        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('corpuri_iluminat_scoase_la_ras_nereguli', 'planseu_subsol')">mdi-close</v-icon>

            Nereguli corpuri iluminat scoase la ras &nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('corpuri_iluminat_scoase_la_ras_nereguli', 'planseu_subsol')" @click="undo('corpuri_iluminat_scoase_la_ras_nereguli', 'planseu_subsol')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.planseu_subsol.corpuri_iluminat_scoase_la_ras_nereguli"
              hint="Nereguli corpuri iluminat scoase la ras?"
              persistent-hint
              :disabled="user.dummy || entityObject.planseu_subsol.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>

        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('conducte_distrib_scoase_la_ras', 'planseu_subsol')">mdi-close</v-icon>

            Conducte distrib scoase la ras&nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('conducte_distrib_scoase_la_ras', 'planseu_subsol')" @click="undo('conducte_distrib_scoase_la_ras', 'planseu_subsol')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.planseu_subsol.conducte_distrib_scoase_la_ras"
              hint="conducte distrib scoase la ras?"
              persistent-hint
              :disabled="user.dummy || entityObject.planseu_subsol.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>
        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('conducte_distrib_scoase_la_ras_poza', 'planseu_subsol')">mdi-close</v-icon>

            Poza conducte distrib scoase la ras&nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('conducte_distrib_scoase_la_ras_poza', 'planseu_subsol')" @click="undo('conducte_distrib_scoase_la_ras_poza', 'planseu_subsol')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.planseu_subsol.conducte_distrib_scoase_la_ras_poza"
              hint="Poza conducte distrib scoase la ras?"
              persistent-hint
              :disabled="user.dummy || entityObject.planseu_subsol.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>
        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('conducte_distrib_scoase_la_ras_nereguli', 'planseu_subsol')">mdi-close</v-icon>

            Nereguli conducte distrib scoase la ras &nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('conducte_distrib_scoase_la_ras_nereguli', 'planseu_subsol')" @click="undo('conducte_distrib_scoase_la_ras_nereguli', 'planseu_subsol')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.planseu_subsol.conducte_distrib_scoase_la_ras_nereguli"
              hint="Nereguli conducte distrib scoase la ras?"
              persistent-hint
              :disabled="user.dummy || entityObject.planseu_subsol.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>

        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('usa_subsol', 'planseu_subsol')">mdi-close</v-icon>

            Usa subsol &nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('usa_subsol', 'planseu_subsol')" @click="undo('usa_subsol', 'planseu_subsol')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.planseu_subsol.usa_subsol"
              hint="Usa subsol?"
              persistent-hint
              :disabled="user.dummy || entityObject.planseu_subsol.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>
        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('usa_subsol_poza', 'planseu_subsol')">mdi-close</v-icon>

            Poza usa subsol&nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('usa_subsol_poza', 'planseu_subsol')" @click="undo('usa_subsol_poza', 'planseu_subsol')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.planseu_subsol.usa_subsol_poza"
              hint="Poza usa subsol?"
              persistent-hint
              :disabled="user.dummy || entityObject.planseu_subsol.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>
        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('usa_subsol_nereguli', 'planseu_subsol')">mdi-close</v-icon>

            Nereguli usa subsol &nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('usa_subsol_nereguli', 'planseu_subsol')" @click="undo('usa_subsol_nereguli', 'planseu_subsol')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.planseu_subsol.usa_subsol_nereguli"
              hint="Nereguli usa subsol?"
              persistent-hint
              :disabled="user.dummy || entityObject.planseu_subsol.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>

        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('observatii', 'planseu_subsol')">mdi-close</v-icon>

            Observatii  &nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('observatii', 'planseu_subsol')" @click="undo('observatii', 'planseu_subsol')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-textarea
              @input="setField($event, 'observatii', 'planseu_subsol', null, false)"
              :value="entityObject.planseu_subsol.observatii"
              auto-grow
              :rows="1"
              hide-details
              hint="Observatii"
              persistent-hint
              solo flat
              :disabled="user.dummy || entityObject.planseu_subsol.disabled">
            </v-textarea>
          </v-card-text>
        </v-card>

        <v-card class="mb-3">
          <form ref="formplanseusubsol">
            <input type="file" ref="fileinputplanseusubsol" accept="image/*" multiple @change="filesAdded($event, 'planseusubsol')" style="display: none">
          </form>
          <v-system-bar window class="px-1">
            Poze planseu subsol &nbsp;
            <div style="display: inline-flex; flex-grow: 1; flex-wrap: wrap; align-items: center">
              <template>
                <v-icon class="ml-1" color="primary" title="Poze incarcate">mdi-camera</v-icon>
                {{noOfPlanseusubsolPhotos}}
              </template>
              <template>
                <v-btn class="ma-0 ml-1 pa-0" icon flat @click.stop.prevent style="min-width: 0" :ripple="false">
                  <v-icon :color="planseusubsolFilesInQueue ? 'primary' : 'blue-grey'" class="mr-1" title="Poze in asteptare">mdi-cloud-upload</v-icon>
                  {{ planseusubsolFilesInQueue }}
                </v-btn>

                <v-spacer></v-spacer>
                <v-btn small class="ma-0" icon flat @click.stop.prevent="_cbAddPhoto('planseusubsol')" v-if="user && !user.dummy" color="primary" :ripple="false">
                  <v-icon class="mr-0">mdi-plus-circle</v-icon>
                </v-btn>

                <!-- mark bad photos -->
                <v-btn small class="ma-0" icon flat @click.stop.prevent="_cbToggleBadMode" v-if="!user.dummy" :ripple="false">
                  <v-icon :color="badEnabled ? 'warning' : 'blue-grey'" class="mr-0">mdi-alert</v-icon>
                </v-btn>
                <v-btn small class="ma-0" icon flat @click.stop.prevent="_cbConfirmBad" v-show="badEnabled && toBad.length" :ripple="false">
                  <v-icon color="warning" class="mr-0">mdi-check-circle</v-icon>
                </v-btn>

                <!-- delete photos -->
                <v-btn small class="ma-0" icon flat @click.stop.prevent="_cbToggleDeleteMode" v-if="!user.dummy" :ripple="false">
                  <v-icon :color="deleteEnabled ? 'error' : 'blue-grey'" class="mr-0">mdi-delete-circle</v-icon>
                </v-btn>
                <v-btn small class="ma-0" icon flat @click.stop.prevent="_cbConfirmDelete" v-show="deleteEnabled && toDelete.length" :ripple="false">
                  <v-icon color="error" class="mr-0">mdi-check-circle</v-icon>
                </v-btn>
                <span v-show="deleteEnabled && toDelete.length">
                  {{toDelete.length}}
                </span>

              </template>
            </div>
          </v-system-bar>
          <v-card-text class="pa-1">
            <template v-if="noOfPlanseusubsolPhotos">
              <viewer v-if="!deleteEnabled && !badEnabled" :options="{url: 'data-src', backdrop: 'static'}">
                <template>
                  <v-layout align-center justify-flex-start wrap>
                    <div style="display: flex; flex-wrap: wrap">
                      <template v-for="(photo, pIndex) in planseusubsolPhotos">
                        <div style="display: flex; flex-direction: column; align-items: center; width: 64px" :key="photo + pIndex">
                          <v-avatar
                            size="48"
                            class="ma-1 viewerPhoto"
                            style="box-sizing: border-box">
                            <img
                              :src="serverURL + photo.replace('photos', 'thumbs')"
                              :data-src="serverURL + photo"
                              class="pa-1">
                          </v-avatar>
                          <div style="display: flex; justify-content: space-around; width: 100%">
                            <a :href="serverURL + photo + '?buster=' + new Date().getTime()" download target="_blank" style="text-decoration: none" title="Descarca poza">
                              <v-icon small>mdi-download</v-icon>
                            </a>
                            <v-icon small color="warning" v-if="photo.includes('_badphoto')">mdi-alert</v-icon>
                            <a :href="serverURL + photo + '?buster=' + new Date().getTime()" target="_blank" style="text-decoration: none" title="Deschide poza intr-un tab nou">
                              <v-icon small>mdi-eye</v-icon>
                            </a>
                          </div>
                        </div>
                      </template>
                    </div>
                  </v-layout>
                </template>
              </viewer>
              <v-layout v-if="deleteEnabled" align-center justify-flex-start wrap>
                <!-- <v-scale-transition group> -->
                <template v-for="(photo, pIndex) in planseusubsolPhotos">
                  <div style="display: flex; flex-direction: column; align-items: center; width: 64px" :key="photo + pIndex">
                    <v-avatar
                      size="48"
                      class="ma-1"
                      :class="{ 'deletePhoto': toDelete.includes(photo), 'normalPhoto': !toDelete.includes(photo) }"
                      style="box-sizing: border-box"
                      @click="selectPhoto(photo)">
                      <img
                        :src="serverURL + photo.replace('photos', 'thumbs')"
                        :data-src="serverURL + photo"
                        class="pa-1">
                    </v-avatar>
                    <v-icon small color="warning" v-if="photo.includes('_badphoto')">mdi-alert</v-icon>
                  </div>
                </template>
                <!-- </v-scale-transition> -->
              </v-layout>
              <v-layout v-if="badEnabled" align-center justify-flex-start wrap>
                <!-- <v-scale-transition group> -->
                <template v-for="(photo, pIndex) in planseusubsolPhotos">
                  <div style="display: flex; flex-direction: column; align-items: center; width: 64px" :key="photo + pIndex">
                    <v-avatar
                      size="48"
                      class="ma-1"
                      :class="{ 'badPhoto': toBad.includes(photo), 'normalPhoto': !toBad.includes(photo) }"
                      style="box-sizing: border-box"
                      @click="selectBadPhoto(photo)">
                      <img
                        :src="serverURL + photo.replace('photos', 'thumbs')"
                        :data-src="serverURL + photo"
                        class="pa-1">
                    </v-avatar>
                    <v-icon small color="warning" v-if="photo.includes('_badphoto')">mdi-alert</v-icon>
                  </div>
                </template>
                <!-- </v-scale-transition> -->
              </v-layout>
            </template>
            <template v-else>
              Nu exista poze pentru planseu subsol.
            </template>
          </v-card-text>
        </v-card>
      </v-card>

      <v-card class="mb-2" v-if="visibleFields.includes('instalatie incalzire')">
        <v-card-title class="accent--text title" style="justify-content: space-between">
          Instalatie incalzire
          <v-icon :color="entityObject.instalatie_incalzire.disabled ? 'grey' : 'primary'" @click="_cbToggleSectionDisabled('instalatie_incalzire')">
            {{ entityObject.instalatie_incalzire.disabled ? 'mdi-toggle-switch-off-outline' : 'mdi-toggle-switch' }}
          </v-icon>
        </v-card-title>
        <v-divider color="accent"></v-divider>

        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('inlocuire_conducte_distrib', 'instalatie_incalzire')">mdi-close</v-icon>

            Inlocuire conducte distrib&nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('inlocuire_conducte_distrib', 'instalatie_incalzire')" @click="undo('inlocuire_conducte_distrib', 'instalatie_incalzire')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.instalatie_incalzire.inlocuire_conducte_distrib"
              hint="Inlocuire conducte distrib?"
              persistent-hint
              :disabled="user.dummy || entityObject.instalatie_incalzire.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>
        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('inlocuire_conducte_distrib_plastic', 'instalatie_incalzire')">mdi-close</v-icon>

            Ol/Plastic inlocuire conducte distrib &nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('inlocuire_conducte_distrib_plastic', 'instalatie_incalzire')" @click="undo('inlocuire_conducte_distrib_plastic', 'instalatie_incalzire')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-container>
              <v-layout row>
                <v-flex xs6>
                  <v-checkbox :ripple="false" :disabled="user.dummy || entityObject.instalatie_incalzire.disabled"  hide-details class="mt-0" v-model="entityObject.instalatie_incalzire.inlocuire_conducte_distrib_plastic" label="Ol" value="Ol"></v-checkbox>
                </v-flex>
                <v-flex xs6>
                  <v-checkbox :ripple="false" :disabled="user.dummy || entityObject.instalatie_incalzire.disabled"  hide-details class="mt-0" v-model="entityObject.instalatie_incalzire.inlocuire_conducte_distrib_plastic" label="Plastic" value="Plastic"></v-checkbox>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('inlocuire_conducte_distrib_poza', 'instalatie_incalzire')">mdi-close</v-icon>

            Poza inlocuire conducte distrib&nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('inlocuire_conducte_distrib_poza', 'instalatie_incalzire')" @click="undo('inlocuire_conducte_distrib_poza', 'instalatie_incalzire')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.instalatie_incalzire.inlocuire_conducte_distrib_poza"
              hint="Poza inlocuire conducte distrib?"
              persistent-hint
              :disabled="user.dummy || entityObject.instalatie_incalzire.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>
        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('inlocuire_conducte_distrib_nereguli', 'instalatie_incalzire')">mdi-close</v-icon>

            Nereguli inlocuire conducte distrib &nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('inlocuire_conducte_distrib_nereguli', 'instalatie_incalzire')" @click="undo('inlocuire_conducte_distrib_nereguli', 'instalatie_incalzire')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.instalatie_incalzire.inlocuire_conducte_distrib_nereguli"
              hint="Nereguli inlocuire conducte distrib?"
              persistent-hint
              :disabled="user.dummy || entityObject.instalatie_incalzire.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>

        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('izolare_conducte_distrib', 'instalatie_incalzire')">mdi-close</v-icon>

            Izolare conducte distrib&nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('izolare_conducte_distrib', 'instalatie_incalzire')" @click="undo('izolare_conducte_distrib', 'instalatie_incalzire')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.instalatie_incalzire.izolare_conducte_distrib"
              hint="Corpuri izolare conducte distrib?"
              persistent-hint
              :disabled="user.dummy || entityObject.instalatie_incalzire.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>
        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('izolare_conducte_distrib_poza', 'instalatie_incalzire')">mdi-close</v-icon>

            Poza izolare conducte distrib&nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('izolare_conducte_distrib_poza', 'instalatie_incalzire')" @click="undo('izolare_conducte_distrib_poza', 'instalatie_incalzire')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.instalatie_incalzire.izolare_conducte_distrib_poza"
              hint="Poza izolare conducte distrib?"
              persistent-hint
              :disabled="user.dummy || entityObject.instalatie_incalzire.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>
        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('izolare_conducte_distrib_nereguli', 'instalatie_incalzire')">mdi-close</v-icon>

            Nereguli izolare conducte distrib &nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('izolare_conducte_distrib_nereguli', 'instalatie_incalzire')" @click="undo('izolare_conducte_distrib_nereguli', 'instalatie_incalzire')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.instalatie_incalzire.izolare_conducte_distrib_nereguli"
              hint="Nereguli izolare conducte distrib?"
              persistent-hint
              :disabled="user.dummy || entityObject.instalatie_incalzire.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>

        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('rpd', 'instalatie_incalzire')">mdi-close</v-icon>

            RPD&nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('rpd', 'instalatie_incalzire')" @click="undo('rpd', 'instalatie_incalzire')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.instalatie_incalzire.rpd"
              hint="RPD?"
              persistent-hint
              :disabled="user.dummy || entityObject.instalatie_incalzire.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>
        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('rpd_poza', 'instalatie_incalzire')">mdi-close</v-icon>

            Poza RPD&nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('rpd_poza', 'instalatie_incalzire')" @click="undo('rpd_poza', 'instalatie_incalzire')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.instalatie_incalzire.rpd_poza"
              hint="Poza RPD?"
              persistent-hint
              :disabled="user.dummy || entityObject.instalatie_incalzire.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>
        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('rpd_nereguli', 'instalatie_incalzire')">mdi-close</v-icon>

            Nereguli RPD &nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('rpd_nereguli', 'instalatie_incalzire')" @click="undo('rpd_nereguli', 'instalatie_incalzire')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.instalatie_incalzire.rpd_nereguli"
              hint="Nereguli RPD?"
              persistent-hint
              :disabled="user.dummy || entityObject.instalatie_incalzire.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>

        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('rob_golire_plus_izolare', 'instalatie_incalzire')">mdi-close</v-icon>

            Rob golire + izolare &nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('rob_golire_plus_izolare', 'instalatie_incalzire')" @click="undo('rob_golire_plus_izolare', 'instalatie_incalzire')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.instalatie_incalzire.rob_golire_plus_izolare"
              hint="Rob golire + izolare?"
              persistent-hint
              :disabled="user.dummy || entityObject.instalatie_incalzire.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>
        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('rob_golire_plus_izolare_poza', 'instalatie_incalzire')">mdi-close</v-icon>

            Poza rob golire + izolare&nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('rob_golire_plus_izolare_poza', 'instalatie_incalzire')" @click="undo('rob_golire_plus_izolare_poza', 'instalatie_incalzire')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.instalatie_incalzire.rob_golire_plus_izolare_poza"
              hint="Poza rob golire + izolare?"
              persistent-hint
              :disabled="user.dummy || entityObject.instalatie_incalzire.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>
        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('rob_golire_plus_izolare_nereguli', 'instalatie_incalzire')">mdi-close</v-icon>

            Nereguli rob golire + izolare &nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('rob_golire_plus_izolare_nereguli', 'instalatie_incalzire')" @click="undo('rob_golire_plus_izolare_nereguli', 'instalatie_incalzire')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.instalatie_incalzire.rob_golire_plus_izolare_nereguli"
              hint="Nereguli rob golire + izolare?"
              persistent-hint
              :disabled="user.dummy || entityObject.instalatie_incalzire.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>

        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('observatii', 'instalatie_incalzire')">mdi-close</v-icon>

            Observatii  &nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('observatii', 'instalatie_incalzire')" @click="undo('observatii', 'instalatie_incalzire')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-textarea
              @input="setField($event, 'observatii', 'instalatie_incalzire', null, false)"
              :value="entityObject.instalatie_incalzire.observatii"
              auto-grow
              :rows="1"
              hide-details
              hint="Observatii"
              persistent-hint
              solo flat
              :disabled="user.dummy || entityObject.instalatie_incalzire.disabled">
            </v-textarea>
          </v-card-text>
        </v-card>

        <v-card class="mb-3">
          <form ref="forminstalatieincalzire">
            <input type="file" ref="fileinputinstalatieincalzire" accept="image/*" multiple @change="filesAdded($event, 'instalatieincalzire')" style="display: none">
          </form>
          <v-system-bar window class="px-1">
            Poze planseu subsol &nbsp;
            <div style="display: inline-flex; flex-grow: 1; flex-wrap: wrap; align-items: center">
              <template>
                <v-icon class="ml-1" color="primary" title="Poze incarcate">mdi-camera</v-icon>
                {{noOfInstalatieincalzirePhotos}}
              </template>
              <template>
                <v-btn class="ma-0 ml-1 pa-0" icon flat @click.stop.prevent style="min-width: 0" :ripple="false">
                  <v-icon :color="instalatieincalzireFilesInQueue ? 'primary' : 'blue-grey'" class="mr-1" title="Poze in asteptare">mdi-cloud-upload</v-icon>
                  {{ instalatieincalzireFilesInQueue }}
                </v-btn>

                <v-spacer></v-spacer>
                <v-btn small class="ma-0" icon flat @click.stop.prevent="_cbAddPhoto('instalatieincalzire')" v-if="user && !user.dummy" color="primary" :ripple="false">
                  <v-icon class="mr-0">mdi-plus-circle</v-icon>
                </v-btn>

                <!-- mark bad photos -->
                <v-btn small class="ma-0" icon flat @click.stop.prevent="_cbToggleBadMode" v-if="!user.dummy" :ripple="false">
                  <v-icon :color="badEnabled ? 'warning' : 'blue-grey'" class="mr-0">mdi-alert</v-icon>
                </v-btn>
                <v-btn small class="ma-0" icon flat @click.stop.prevent="_cbConfirmBad" v-show="badEnabled && toBad.length" :ripple="false">
                  <v-icon color="warning" class="mr-0">mdi-check-circle</v-icon>
                </v-btn>

                <!-- delete photos -->
                <v-btn small class="ma-0" icon flat @click.stop.prevent="_cbToggleDeleteMode" v-if="!user.dummy" :ripple="false">
                  <v-icon :color="deleteEnabled ? 'error' : 'blue-grey'" class="mr-0">mdi-delete-circle</v-icon>
                </v-btn>
                <v-btn small class="ma-0" icon flat @click.stop.prevent="_cbConfirmDelete" v-show="deleteEnabled && toDelete.length" :ripple="false">
                  <v-icon color="error" class="mr-0">mdi-check-circle</v-icon>
                </v-btn>
                <span v-show="deleteEnabled && toDelete.length">
                  {{toDelete.length}}
                </span>

              </template>
            </div>
          </v-system-bar>
          <v-card-text class="pa-1">
            <template v-if="noOfInstalatieincalzirePhotos">
              <viewer v-if="!deleteEnabled && !badEnabled" :options="{url: 'data-src', backdrop: 'static'}">
                <template>
                  <v-layout align-center justify-flex-start wrap>
                    <div style="display: flex; flex-wrap: wrap">
                      <template v-for="(photo, pIndex) in instalatieincalzirePhotos">
                        <div style="display: flex; flex-direction: column; align-items: center; width: 64px" :key="photo + pIndex">
                          <v-avatar
                            size="48"
                            class="ma-1 viewerPhoto"
                            style="box-sizing: border-box">
                            <img
                              :src="serverURL + photo.replace('photos', 'thumbs')"
                              :data-src="serverURL + photo"
                              class="pa-1">
                          </v-avatar>
                          <div style="display: flex; justify-content: space-around; width: 100%">
                            <a :href="serverURL + photo + '?buster=' + new Date().getTime()" download target="_blank" style="text-decoration: none" title="Descarca poza">
                              <v-icon small>mdi-download</v-icon>
                            </a>
                            <v-icon small color="warning" v-if="photo.includes('_badphoto')">mdi-alert</v-icon>
                            <a :href="serverURL + photo + '?buster=' + new Date().getTime()" target="_blank" style="text-decoration: none" title="Deschide poza intr-un tab nou">
                              <v-icon small>mdi-eye</v-icon>
                            </a>
                          </div>
                        </div>
                      </template>
                    </div>
                  </v-layout>
                </template>
              </viewer>
              <v-layout v-if="deleteEnabled" align-center justify-flex-start wrap>
                <!-- <v-scale-transition group> -->
                <template v-for="(photo, pIndex) in instalatieincalzirePhotos">
                  <div style="display: flex; flex-direction: column; align-items: center; width: 64px" :key="photo + pIndex">
                    <v-avatar
                      size="48"
                      class="ma-1"
                      :class="{ 'deletePhoto': toDelete.includes(photo), 'normalPhoto': !toDelete.includes(photo) }"
                      style="box-sizing: border-box"
                      @click="selectPhoto(photo)">
                      <img
                        :src="serverURL + photo.replace('photos', 'thumbs')"
                        :data-src="serverURL + photo"
                        class="pa-1">
                    </v-avatar>
                    <v-icon small color="warning" v-if="photo.includes('_badphoto')">mdi-alert</v-icon>
                  </div>
                </template>
                <!-- </v-scale-transition> -->
              </v-layout>
              <v-layout v-if="badEnabled" align-center justify-flex-start wrap>
                <!-- <v-scale-transition group> -->
                <template v-for="(photo, pIndex) in instalatieincalzirePhotos">
                  <div style="display: flex; flex-direction: column; align-items: center; width: 64px" :key="photo + pIndex">
                    <v-avatar
                      size="48"
                      class="ma-1"
                      :class="{ 'badPhoto': toBad.includes(photo), 'normalPhoto': !toBad.includes(photo) }"
                      style="box-sizing: border-box"
                      @click="selectBadPhoto(photo)">
                      <img
                        :src="serverURL + photo.replace('photos', 'thumbs')"
                        :data-src="serverURL + photo"
                        class="pa-1">
                    </v-avatar>
                    <v-icon small color="warning" v-if="photo.includes('_badphoto')">mdi-alert</v-icon>
                  </div>
                </template>
                <!-- </v-scale-transition> -->
              </v-layout>
            </template>
            <template v-else>
              Nu exista poze pentru instalatie incalzire.
            </template>
          </v-card-text>
        </v-card>
      </v-card>

      <v-card class="mb-2" v-if="visibleFields.includes('instalatie acm')">
        <v-card-title class="accent--text title" style="justify-content: space-between">
          Instalatie acm
          <v-icon :color="entityObject.instalatie_acm.disabled ? 'grey' : 'primary'" @click="_cbToggleSectionDisabled('instalatie_acm')">
            {{ entityObject.instalatie_acm.disabled ? 'mdi-toggle-switch-off-outline' : 'mdi-toggle-switch' }}
          </v-icon>
        </v-card-title>
        <v-divider color="accent"></v-divider>

        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('inlocuire_conducte_distrib', 'instalatie_acm')">mdi-close</v-icon>

            Inlocuire conducte distrib&nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('inlocuire_conducte_distrib', 'instalatie_acm')" @click="undo('inlocuire_conducte_distrib', 'instalatie_acm')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.instalatie_acm.inlocuire_conducte_distrib"
              hint="Inlocuire conducte distrib?"
              persistent-hint
              :disabled="user.dummy || entityObject.instalatie_acm.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>
        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('inlocuire_conducte_distrib_plastic', 'instalatie_acm')">mdi-close</v-icon>

            Ol/Plastic inlocuire conducte distrib &nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('inlocuire_conducte_distrib_plastic', 'instalatie_acm')" @click="undo('inlocuire_conducte_distrib_plastic', 'instalatie_acm')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-container>
              <v-layout row>
                <v-flex xs6>
                  <v-checkbox :ripple="false" :disabled="user.dummy || entityObject.instalatie_acm.disabled" hide-details class="mt-0" v-model="entityObject.instalatie_acm.inlocuire_conducte_distrib_plastic" label="Ol" value="Ol"></v-checkbox>
                </v-flex>
                <v-flex xs6>
                  <v-checkbox :ripple="false" :disabled="user.dummy || entityObject.instalatie_acm.disabled" hide-details class="mt-0" v-model="entityObject.instalatie_acm.inlocuire_conducte_distrib_plastic" label="Plastic" value="Plastic"></v-checkbox>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('inlocuire_conducte_distrib_poza', 'instalatie_acm')">mdi-close</v-icon>

            Poza inlocuire conducte distrib&nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('inlocuire_conducte_distrib_poza', 'instalatie_acm')" @click="undo('inlocuire_conducte_distrib_poza', 'instalatie_acm')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.instalatie_acm.inlocuire_conducte_distrib_poza"
              hint="Poza inlocuire conducte distrib?"
              persistent-hint
              :disabled="user.dummy || entityObject.instalatie_acm.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>
        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('inlocuire_conducte_distrib_nereguli', 'instalatie_acm')">mdi-close</v-icon>

            Nereguli inlocuire conducte distrib &nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('inlocuire_conducte_distrib_nereguli', 'instalatie_acm')" @click="undo('inlocuire_conducte_distrib_nereguli', 'instalatie_acm')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.instalatie_acm.inlocuire_conducte_distrib_nereguli"
              hint="Nereguli inlocuire conducte distrib?"
              persistent-hint
              :disabled="user.dummy || entityObject.instalatie_acm.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>

        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('izolare_conducte_distrib', 'instalatie_acm')">mdi-close</v-icon>

            Izolare conducte distrib&nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('izolare_conducte_distrib', 'instalatie_acm')" @click="undo('izolare_conducte_distrib', 'instalatie_acm')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.instalatie_acm.izolare_conducte_distrib"
              hint="Corpuri izolare conducte distrib?"
              persistent-hint
              :disabled="user.dummy || entityObject.instalatie_acm.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>
        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('izolare_conducte_distrib_poza', 'instalatie_acm')">mdi-close</v-icon>

            Poza izolare conducte distrib&nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('izolare_conducte_distrib_poza', 'instalatie_acm')" @click="undo('izolare_conducte_distrib_poza', 'instalatie_acm')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.instalatie_acm.izolare_conducte_distrib_poza"
              hint="Poza izolare conducte distrib?"
              persistent-hint
              :disabled="user.dummy || entityObject.instalatie_acm.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>
        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('izolare_conducte_distrib_nereguli', 'instalatie_acm')">mdi-close</v-icon>

            Nereguli izolare conducte distrib &nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('izolare_conducte_distrib_nereguli', 'instalatie_acm')" @click="undo('izolare_conducte_distrib_nereguli', 'instalatie_acm')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.instalatie_acm.izolare_conducte_distrib_nereguli"
              hint="Nereguli izolare conducte distrib?"
              persistent-hint
              :disabled="user.dummy || entityObject.instalatie_acm.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>

        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('conducta_recirculare', 'instalatie_acm')">mdi-close</v-icon>

            Conducta recirculare&nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('conducta_recirculare', 'instalatie_acm')" @click="undo('conducta_recirculare', 'instalatie_acm')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.instalatie_acm.conducta_recirculare"
              hint="Conducta recirculare?"
              persistent-hint
              :disabled="user.dummy || entityObject.instalatie_acm.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>
        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('conducta_recirculare_plastic', 'instalatie_acm')">mdi-close</v-icon>

            Ol/Plastic conducta recirculare &nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('conducta_recirculare_plastic', 'instalatie_acm')" @click="undo('conducta_recirculare_plastic', 'instalatie_acm')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-container>
              <v-layout row>
                <v-flex xs6>
                  <v-checkbox :ripple="false" :disabled="user.dummy || entityObject.instalatie_acm.disabled" hide-details class="mt-0" v-model="entityObject.instalatie_acm.conducta_recirculare_plastic" label="Ol" value="Ol"></v-checkbox>
                </v-flex>
                <v-flex xs6>
                  <v-checkbox :ripple="false" :disabled="user.dummy || entityObject.instalatie_acm.disabled" hide-details class="mt-0" v-model="entityObject.instalatie_acm.conducta_recirculare_plastic" label="Plastic" value="Plastic"></v-checkbox>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('conducta_recirculare_poza', 'instalatie_acm')">mdi-close</v-icon>

            Poza conducta recirculare&nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('conducta_recirculare_poza', 'instalatie_acm')" @click="undo('conducta_recirculare_poza', 'instalatie_acm')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.instalatie_acm.conducta_recirculare_poza"
              hint="Poza conducta recirculare?"
              persistent-hint
              :disabled="user.dummy || entityObject.instalatie_acm.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>
        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('conducta_recirculare_nereguli', 'instalatie_acm')">mdi-close</v-icon>

            Nereguli conducta recirculare &nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('conducta_recirculare_nereguli', 'instalatie_acm')" @click="undo('conducta_recirculare_nereguli', 'instalatie_acm')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.instalatie_acm.conducta_recirculare_nereguli"
              hint="Nereguli conducta recirculare?"
              persistent-hint
              :disabled="user.dummy || entityObject.instalatie_acm.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>

        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('rob_golire_plus_izolare', 'instalatie_acm')">mdi-close</v-icon>

            Rob golire + izolare &nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('rob_golire_plus_izolare', 'instalatie_acm')" @click="undo('rob_golire_plus_izolare', 'instalatie_acm')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.instalatie_acm.rob_golire_plus_izolare"
              hint="Rob golire + izolare?"
              persistent-hint
              :disabled="user.dummy || entityObject.instalatie_acm.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>
        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('rob_golire_plus_izolare_poza', 'instalatie_acm')">mdi-close</v-icon>

            Poza rob golire + izolare&nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('rob_golire_plus_izolare_poza', 'instalatie_acm')" @click="undo('rob_golire_plus_izolare_poza', 'instalatie_acm')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.instalatie_acm.rob_golire_plus_izolare_poza"
              hint="Poza rob golire + izolare?"
              persistent-hint
              :disabled="user.dummy || entityObject.instalatie_acm.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>
        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('rob_golire_plus_izolare_nereguli', 'instalatie_acm')">mdi-close</v-icon>

            Nereguli rob golire + izolare &nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('rob_golire_plus_izolare_nereguli', 'instalatie_acm')" @click="undo('rob_golire_plus_izolare_nereguli', 'instalatie_acm')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-radio-group
              row
              v-model="entityObject.instalatie_acm.rob_golire_plus_izolare_nereguli"
              hint="Nereguli rob golire + izolare?"
              persistent-hint
              :disabled="user.dummy || entityObject.instalatie_acm.disabled">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>

        <v-card class="mb-3">
          <v-system-bar window class="px-1">
            <v-icon small color="error" style="margin-right: 0" @click="resetField('observatii', 'instalatie_acm')">mdi-close</v-icon>

            Observatii  &nbsp;
            <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('observatii', 'instalatie_acm')" @click="undo('observatii', 'instalatie_acm')" :ripple="false">
              <v-icon small>mdi-undo</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-text class="pa-1">
            <v-textarea
              @input="setField($event, 'observatii', 'instalatie_acm', null, false)"
              :value="entityObject.instalatie_acm.observatii"
              auto-grow
              :rows="1"
              hide-details
              hint="Observatii"
              persistent-hint
              solo flat
              :disabled="user.dummy || entityObject.instalatie_acm.disabled">
            </v-textarea>
          </v-card-text>
        </v-card>

        <v-card class="mb-3">
          <form ref="forminstalatieacm">
            <input type="file" ref="fileinputinstalatieacm" accept="image/*" multiple @change="filesAdded($event, 'instalatieacm')" style="display: none">
          </form>
          <v-system-bar window class="px-1">
            Poze planseu subsol &nbsp;
            <div style="display: inline-flex; flex-grow: 1; flex-wrap: wrap; align-items: center">
              <template>
                <v-icon class="ml-1" color="primary" title="Poze incarcate">mdi-camera</v-icon>
                {{noOfInstalatieacmPhotos}}
              </template>
              <template>
                <v-btn class="ma-0 ml-1 pa-0" icon flat @click.stop.prevent style="min-width: 0" :ripple="false">
                  <v-icon :color="instalatieacmFilesInQueue ? 'primary' : 'blue-grey'" class="mr-1" title="Poze in asteptare">mdi-cloud-upload</v-icon>
                  {{ instalatieacmFilesInQueue }}
                </v-btn>

                <v-spacer></v-spacer>
                <v-btn small class="ma-0" icon flat @click.stop.prevent="_cbAddPhoto('instalatieacm')" v-if="user && !user.dummy" color="primary" :ripple="false">
                  <v-icon class="mr-0">mdi-plus-circle</v-icon>
                </v-btn>

                <!-- mark bad photos -->
                <v-btn small class="ma-0" icon flat @click.stop.prevent="_cbToggleBadMode" v-if="!user.dummy" :ripple="false">
                  <v-icon :color="badEnabled ? 'warning' : 'blue-grey'" class="mr-0">mdi-alert</v-icon>
                </v-btn>
                <v-btn small class="ma-0" icon flat @click.stop.prevent="_cbConfirmBad" v-show="badEnabled && toBad.length" :ripple="false">
                  <v-icon color="warning" class="mr-0">mdi-check-circle</v-icon>
                </v-btn>

                <!-- delete photos -->
                <v-btn small class="ma-0" icon flat @click.stop.prevent="_cbToggleDeleteMode" v-if="!user.dummy" :ripple="false">
                  <v-icon :color="deleteEnabled ? 'error' : 'blue-grey'" class="mr-0">mdi-delete-circle</v-icon>
                </v-btn>
                <v-btn small class="ma-0" icon flat @click.stop.prevent="_cbConfirmDelete" v-show="deleteEnabled && toDelete.length" :ripple="false">
                  <v-icon color="error" class="mr-0">mdi-check-circle</v-icon>
                </v-btn>
                <span v-show="deleteEnabled && toDelete.length">
                  {{toDelete.length}}
                </span>

              </template>
            </div>
          </v-system-bar>
          <v-card-text class="pa-1">
            <template v-if="noOfInstalatieacmPhotos">
              <viewer v-if="!deleteEnabled && !badEnabled" :options="{url: 'data-src', backdrop: 'static'}">
                <template>
                  <v-layout align-center justify-flex-start wrap>
                    <div style="display: flex; flex-wrap: wrap">
                      <template v-for="(photo, pIndex) in instalatieacmPhotos">
                        <div style="display: flex; flex-direction: column; align-items: center; width: 64px" :key="photo + pIndex">
                          <v-avatar
                            size="48"
                            class="ma-1 viewerPhoto"
                            style="box-sizing: border-box">
                            <img
                              :src="serverURL + photo.replace('photos', 'thumbs')"
                              :data-src="serverURL + photo"
                              class="pa-1">
                          </v-avatar>
                          <div style="display: flex; justify-content: space-around; width: 100%">
                            <a :href="serverURL + photo + '?buster=' + new Date().getTime()" download target="_blank" style="text-decoration: none" title="Descarca poza">
                              <v-icon small>mdi-download</v-icon>
                            </a>
                            <v-icon small color="warning" v-if="photo.includes('_badphoto')">mdi-alert</v-icon>
                            <a :href="serverURL + photo + '?buster=' + new Date().getTime()" target="_blank" style="text-decoration: none" title="Deschide poza intr-un tab nou">
                              <v-icon small>mdi-eye</v-icon>
                            </a>
                          </div>
                        </div>
                      </template>
                    </div>
                  </v-layout>
                </template>
              </viewer>
              <v-layout v-if="deleteEnabled" align-center justify-flex-start wrap>
                <!-- <v-scale-transition group> -->
                <template v-for="(photo, pIndex) in instalatieacmPhotos">
                  <div style="display: flex; flex-direction: column; align-items: center; width: 64px" :key="photo + pIndex">
                    <v-avatar
                      size="48"
                      class="ma-1"
                      :class="{ 'deletePhoto': toDelete.includes(photo), 'normalPhoto': !toDelete.includes(photo) }"
                      style="box-sizing: border-box"
                      @click="selectPhoto(photo)">
                      <img
                        :src="serverURL + photo.replace('photos', 'thumbs')"
                        :data-src="serverURL + photo"
                        class="pa-1">
                    </v-avatar>
                    <v-icon small color="warning" v-if="photo.includes('_badphoto')">mdi-alert</v-icon>
                  </div>
                </template>
                <!-- </v-scale-transition> -->
              </v-layout>
              <v-layout v-if="badEnabled" align-center justify-flex-start wrap>
                <!-- <v-scale-transition group> -->
                <template v-for="(photo, pIndex) in instalatieacmPhotos">
                  <div style="display: flex; flex-direction: column; align-items: center; width: 64px" :key="photo + pIndex">
                    <v-avatar
                      size="48"
                      class="ma-1"
                      :class="{ 'badPhoto': toBad.includes(photo), 'normalPhoto': !toBad.includes(photo) }"
                      style="box-sizing: border-box"
                      @click="selectBadPhoto(photo)">
                      <img
                        :src="serverURL + photo.replace('photos', 'thumbs')"
                        :data-src="serverURL + photo"
                        class="pa-1">
                    </v-avatar>
                    <v-icon small color="warning" v-if="photo.includes('_badphoto')">mdi-alert</v-icon>
                  </div>
                </template>
                <!-- </v-scale-transition> -->
              </v-layout>
            </template>
            <template v-else>
              Nu exista poze pentru instalatie acm.
            </template>
          </v-card-text>
        </v-card>
      </v-card>

      <v-dialog v-model="dialog" scrollable :transition="false" no-click-animation hide-overlay>
        <v-card>
          <v-card-title class="headline primary">
            Setari vizibilitate campuri
          </v-card-title>

          <v-card-text>
            <v-switch
              v-model="visibleFields"
              v-for="field in fields"
              :key="field"
              :label="field"
              :value="field"
              :ripple="false">
            </v-switch>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" flat @click="_cbCloseSettings(0)" :ripple="false">
              Inchide
            </v-btn>
            <v-btn color="primary" flat @click="_cbCloseSettings(1)" :ripple="false">
              Salveaza
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card-text>

    <v-speed-dial v-model="fab" bottom right direction="top" style="position: fixed; bottom: 57px;" v-show="dataLoaded">
      <template v-slot:activator>
        <v-btn v-model="fab" color="primary" fab small>
          <v-icon>mdi-menu</v-icon>
          <v-icon>mdi-minus</v-icon>
        </v-btn>
      </template>
      <v-btn fab small color="blue-grey" @click="_cbResetAll" :ripple="false" :disabled="user.dummy" dark>
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-btn fab small color="blue-grey" v-show="isEdited" @click="_cbUndoAll" :ripple="false" :disabled="user.dummy" dark>
          <v-icon>mdi-undo</v-icon>
        </v-btn>
      <v-btn fab small color="blue-grey" v-show="isEdited" @click="save" :ripple="false" :disabled="user.dummy" dark>
          <v-icon>mdi-content-save</v-icon>
        </v-btn>
      <v-btn fab small color="blue-grey" @click.stop="_cbRefresh" :ripple="false" dark>
        <v-icon>mdi-refresh</v-icon>
      </v-btn>
      <v-btn fab small color="blue-grey" @click.stop="_cbOpenSettings" :ripple="false" dark>
        <v-icon>mdi-settings</v-icon>
      </v-btn>
    </v-speed-dial>

    <div style="text-align: center">
      <div class="pt-5 data-loading" style="text-align: center" v-if="!dataLoaded">
        <img src="/logo.svg" alt="loader-logo" style="width:25vw">
      </div>
      <v-btn fab flat large @click="_cbRefresh" :ripple="false" v-if="!dataLoaded">
        <v-icon color="primary">mdi-refresh</v-icon>
      </v-btn>
    </div>

  </v-card>
</template>

<script>
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer/src/component.vue'
// import { gmapApi } from 'vue2-google-maps'
import debounce from 'lodash.debounce'
import cloneDeep from 'lodash.clonedeep'
import uniqid from 'uniqid'

export default {
  components: {
    Viewer
  },
  name: 'entity-details',
  props: {
    entity: {
      type: String,
      required: true
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.$store.dispatch('entities/setActiveEntity', to.params.entity)
    })
  },
  beforeRouteLeave (to, from, next) {
    if (this.isEdited) {
      this.$dialog
        .confirm({
          title: 'Atentie!',
          body: 'Exista modificari nesalvate! Esti sigur(a) ca vrei sa parasesti pagina?'
        }, {
          okText: 'DA',
          cancelText: 'Nu, vreau sa raman!',
          animation: 'zoom'
        })
        .then(dialog => {
          this.$store.commit('entities/setActiveEntity', null)
          this.$store.commit('setIsDetailsEdited', false)
          next()
        })
        .catch(() => {
          next(false)
        })
    } else {
      this.$store.commit('entities/setActiveEntity', null)
      next()
    }
  },
  data: () => ({
    dataLoaded: false,
    fab: false,
    collapsed: false,
    fields: ['info adresa', 'info scara blocului', 'perete exterior', 'tamplarie', 'soclu', 'terasa', 'planseu sub pod', 'planseu subsol', 'instalatie incalzire', 'instalatie acm'],
    entityObject: {
      __v: null,
      _id: null,
      addedBy: null,
      adresa: null,
      centru_geometric: { lat: 44.446086, lng: 26.063843 },
      createdAt: null,
      done: 'Nu',
      eticheta: null,
      zona: null,
      id_scara: null,
      info_consum: {
        exista_info: null,
        consum_curent_lift_avizier: null,
        consum_curent_lift_avizier_unitate_masura: null,
        consum_curent_spatii_comune_avizier: null,
        consum_curent_spatii_comune_avizier_unitate_masura: null
      },
      info_lift: [

      ],
      info_scara_blocului: {
        comert_servicii: null,
        etaj_tehnic_vizibil: null,
        nr_apartamente_pe_scara: null,
        nr_niveluri_comert_servicii: null,
        nr_niveluri_vizibile: null,
        reabilitat: null,
        regim_inaltime: 'P'
      },
      nr_lift_scara: null,
      observatii: null,
      observatii_adresa: null,
      pdfs: [],
      photos: [],
      updatedAt: null,
      user: null,
      perete_exterior: {
        disabled: null,
        observatii: null,
        grosime_izolatie: null,
        grosime_izolatie_poza: null,
        grosime_izolatie_nereguli: null,

        tencuiala_cazuta: null,
        tencuiala_cazuta_poza: null,
        tencuiala_cazuta_nereguli: null,

        infiltratii: null,
        infiltratii_poza: null,
        infiltratii_nereguli: null,

        rost_dilatatie: null,
        rost_dilatatie_poza: null,
        rost_dilatatie_nereguli: null,

        interfon_montat_la_fata_iz: null,
        interfon_montat_la_fata_iz_poza: null,
        interfon_montat_la_fata_iz_nereguli: null,

        splituri_in_ext_izolatiei: null,
        splituri_in_ext_izolatiei_poza: null,
        splituri_in_ext_izolatiei_nereguli: null
      },
      tamplarie: {
        disabled: null,
        observatii: null,
        pvc: null,
        pvc_poza: null,
        pvc_nereguli: null,

        grile: null,
        grile_poza: null,
        grile_nereguli: null,

        glafuri_exterioare: null,
        glafuri_exterioare_poza: null,
        glafuri_exterioare_nereguli: null,

        grila_casa_scarii: null,
        grila_casa_scarii_poza: null,
        grila_casa_scarii_nereguli: null,

        folie_producator_indepartata: null,
        folie_producator_indepartata_poza: null,
        folie_producator_indepartata_nereguli: null,

        inchidere_balcoane: null,
        inchidere_balcoane_poza: null,
        inchidere_balcoane_nereguli: null,

        termoizolare_parapet_balc: null,
        termoizolare_parapet_balc_poza: null,
        termoizolare_parapet_balc_nereguli: null,

        placa_acoperire_balcon_ue: null,
        placa_acoperire_balcon_ue_poza: null,
        placa_acoperire_balcon_ue_nereguli: null
      },
      soclu: {
        disabled: null,
        observatii: null,
        grosime_izolatie: null,
        grosime_izolatie_poza: null,
        grosime_izolatie_nereguli: null,

        imbinare_trotuar: null,
        imbinare_trotuar_poza: null,
        imbinare_trotuar_nereguli: null,

        grile_aerisire_subsol: null,
        grile_aerisire_subsol_poza: null,
        grile_aerisire_subsol_nereguli: null,

        profil_lacrimar: null,
        profil_lacrimar_poza: null,
        profil_lacrimar_nereguli: null
      },
      terasa: {
        disabled: null,
        observatii: null,
        balustrada_protectie: null,
        balustrada_protectie_poza: null,
        balustrada_protectie_nereguli: null,

        parafrunzare: null,
        parafrunzare_poza: null,
        parafrunzare_nereguli: null,

        coloane_ventilatie_capace: null,
        coloane_ventilatie_capace_poza: null,
        coloane_ventilatie_capace_nereguli: null,

        inaltare_coloane_ventilatie: null,
        inaltare_coloane_ventilatie_poza: null,
        inaltare_coloane_ventilatie_nereguli: null,

        aeratoare: null,
        aeratoare_poza: null,
        aeratoare_nereguli: null,

        acumulare_apa: null,
        acumulare_apa_poza: null,
        acumulare_apa_nereguli: null,

        strat_carton_bitum_dezlipit: null,
        strat_carton_bitum_dezlipit_poza: null,
        strat_carton_bitum_dezlipit_nereguli: null,

        usa_acces_terasa_pvc: null,
        usa_acces_terasa_pvc_poza: null,
        usa_acces_terasa_pvc_nereguli: null,

        chepeng_terasa_pvc: null,
        chepeng_terasa_pvc_poza: null,
        chepeng_terasa_pvc_nereguli: null,

        jgheab_montat_corect: null,
        jgheab_montat_corect_poza: null,
        jgheab_montat_corect_nereguli: null,

        sort_tabla_atic: null,
        sort_tabla_atic_poza: null,
        sort_tabla_atic_nereguli: null,

        imbinare_carton_bit_perete: null,
        imbinare_carton_bit_perete_poza: null,
        imbinare_carton_bit_perete_nereguli: null,

        rosturi_intre_tronsoane: null,
        rosturi_intre_tronsoane_poza: null,
        rosturi_intre_tronsoane_nereguli: null
      },
      planseu_sub_pod: {
        disabled: null,
        observatii: null,
        grosime_izolatie: null,
        grosime_izolatie_poza: null,
        grosime_izolatie_nereguli: null,

        stare_acoperis_poza: null,
        stare_acoperis_nereguli: null
      },
      planseu_subsol: {
        disabled: null,
        observatii: null,
        grosime_izolatie: null,
        grosime_izolatie_poza: null,
        grosime_izolatie_nereguli: null,

        corpuri_iluminat_scoase_la_ras: null,
        corpuri_iluminat_scoase_la_ras_poza: null,
        corpuri_iluminat_scoase_la_ras_nereguli: null,

        conducte_distrib_scoase_la_ras: null,
        conducte_distrib_scoase_la_ras_poza: null,
        conducte_distrib_scoase_la_ras_nereguli: null,

        usa_subsol: null,
        usa_subsol_poza: null,
        usa_subsol_nereguli: null
      },
      instalatie_incalzire: {
        disabled: null,
        observatii: null,
        inlocuire_conducte_distrib: null,
        inlocuire_conducte_distrib_plastic: [],
        inlocuire_conducte_distrib_poza: null,
        inlocuire_conducte_distrib_nereguli: null,

        izolare_conducte_distrib: null,
        izolare_conducte_distrib_poza: null,
        izolare_conducte_distrib_nereguli: null,

        rpd: null,
        rpd_poza: null,
        rpd_nereguli: null,

        rob_golire_plus_izolare: null,
        rob_golire_plus_izolare_poza: null,
        rob_golire_plus_izolare_nereguli: null
      },
      instalatie_acm: {
        disabled: null,
        observatii: null,
        inlocuire_conducte_distrib: null,
        inlocuire_conducte_distrib_plastic: [],
        inlocuire_conducte_distrib_poza: null,
        inlocuire_conducte_distrib_nereguli: null,

        izolare_conducte_distrib: null,
        izolare_conducte_distrib_poza: null,
        izolare_conducte_distrib_nereguli: null,

        conducta_recirculare: null,
        conducta_recirculare_plastic: [],
        conducta_recirculare_poza: null,
        conducta_recirculare_nereguli: null,

        rob_golire_plus_izolare: null,
        rob_golire_plus_izolare_poza: null,
        rob_golire_plus_izolare_nereguli: null
      }
    },
    deleteEnabled: false,
    toDelete: [],
    options: {
      width: '100%',
      height: '100%'
    },
    dialog: false,
    visibleFields: [],
    toDeletePdfs: [],
    deletePdfsEnabled: false,
    pdfDialog: false,
    pdfFrameSrc: '',
    pdfFrameTitle: '',
    badEnabled: false,
    toBad: []
  }),
  computed: {
    serverURL () {
      return this.$store.getters.serverURL
    },
    activeEntity () {
      return this.$store.getters['entities/activeEntity']
    },
    isEdited () {
      // return false
      return JSON.stringify(this.activeEntity) !== JSON.stringify(this.entityObject)
    },
    editedFields () {
      // return []
      // will have to refactor
      return this.fields.filter(field => {
        return JSON.stringify(this.activeEntity[field.value]) !== JSON.stringify(this.entityObject[field.value])
      }).map(field => field.value)
    },
    user () {
      return this.$store.getters.user
    },
    loading () {
      return this.$store.getters.loading
    },
    files () {
      return this.$store.getters['entities/files']
    },
    entityFilesInQueue () {
      return !this.activeEntity ? 0 : this.files.filter(file => file.entity === this.activeEntity._id && !file.uploaded && file.tip === 'photo' && file.parent === 'scara').length
    },

    pereteexteriorFilesInQueue () {
      return !this.activeEntity ? 0 : this.files.filter(file => file.entity === this.activeEntity._id && !file.uploaded && file.tip === 'photo' && file.parent === 'pereteexterior').length
    },
    noOfPereteexteriorPhotos () {
      return !this.activeEntity ? 0 : this.activeEntity.photos.reduce((acc, photo) => {
        if (photo.includes('_pereteexterior_')) acc = acc + 1
        return acc
      }, 0)
    },
    pereteexteriorPhotos () {
      return !this.activeEntity ? [] : this.activeEntity.photos.filter(photo => photo.includes('pereteexterior'))
    },

    tamplarieFilesInQueue () {
      return !this.activeEntity ? 0 : this.files.filter(file => file.entity === this.activeEntity._id && !file.uploaded && file.tip === 'photo' && file.parent === 'tamplarie').length
    },
    noOfTamplariePhotos () {
      return !this.activeEntity ? 0 : this.activeEntity.photos.reduce((acc, photo) => {
        if (photo.includes('_tamplarie_')) acc = acc + 1
        return acc
      }, 0)
    },
    tamplariePhotos () {
      return !this.activeEntity ? [] : this.activeEntity.photos.filter(photo => photo.includes('tamplarie'))
    },

    socluFilesInQueue () {
      return !this.activeEntity ? 0 : this.files.filter(file => file.entity === this.activeEntity._id && !file.uploaded && file.tip === 'photo' && file.parent === 'soclu').length
    },
    noOfSocluPhotos () {
      return !this.activeEntity ? 0 : this.activeEntity.photos.reduce((acc, photo) => {
        if (photo.includes('_soclu_')) acc = acc + 1
        return acc
      }, 0)
    },
    socluPhotos () {
      return !this.activeEntity ? [] : this.activeEntity.photos.filter(photo => photo.includes('soclu'))
    },

    terasaFilesInQueue () {
      return !this.activeEntity ? 0 : this.files.filter(file => file.entity === this.activeEntity._id && !file.uploaded && file.tip === 'photo' && file.parent === 'terasa').length
    },
    noOfTerasaPhotos () {
      return !this.activeEntity ? 0 : this.activeEntity.photos.reduce((acc, photo) => {
        if (photo.includes('_terasa_')) acc = acc + 1
        return acc
      }, 0)
    },
    terasaPhotos () {
      return !this.activeEntity ? [] : this.activeEntity.photos.filter(photo => photo.includes('terasa'))
    },

    planseusubpodFilesInQueue () {
      return !this.activeEntity ? 0 : this.files.filter(file => file.entity === this.activeEntity._id && !file.uploaded && file.tip === 'photo' && file.parent === 'planseusubpod').length
    },
    noOfPlanseusubpodPhotos () {
      return !this.activeEntity ? 0 : this.activeEntity.photos.reduce((acc, photo) => {
        if (photo.includes('_planseusubpod_')) acc = acc + 1
        return acc
      }, 0)
    },
    planseusubpodPhotos () {
      return !this.activeEntity ? [] : this.activeEntity.photos.filter(photo => photo.includes('planseusubpod'))
    },

    planseusubsolFilesInQueue () {
      return !this.activeEntity ? 0 : this.files.filter(file => file.entity === this.activeEntity._id && !file.uploaded && file.tip === 'photo' && file.parent === 'planseusubsol').length
    },
    noOfPlanseusubsolPhotos () {
      return !this.activeEntity ? 0 : this.activeEntity.photos.reduce((acc, photo) => {
        if (photo.includes('_planseusubsol_')) acc = acc + 1
        return acc
      }, 0)
    },
    planseusubsolPhotos () {
      return !this.activeEntity ? [] : this.activeEntity.photos.filter(photo => photo.includes('planseusubsol'))
    },

    instalatieincalzireFilesInQueue () {
      return !this.activeEntity ? 0 : this.files.filter(file => file.entity === this.activeEntity._id && !file.uploaded && file.tip === 'photo' && file.parent === 'instalatieincalzire').length
    },
    noOfInstalatieincalzirePhotos () {
      return !this.activeEntity ? 0 : this.activeEntity.photos.reduce((acc, photo) => {
        if (photo.includes('_instalatieincalzire_')) acc = acc + 1
        return acc
      }, 0)
    },
    instalatieincalzirePhotos () {
      return !this.activeEntity ? [] : this.activeEntity.photos.filter(photo => photo.includes('instalatieincalzire'))
    },

    instalatieacmFilesInQueue () {
      return !this.activeEntity ? 0 : this.files.filter(file => file.entity === this.activeEntity._id && !file.uploaded && file.tip === 'photo' && file.parent === 'instalatieacm').length
    },
    noOfInstalatieacmPhotos () {
      return !this.activeEntity ? 0 : this.activeEntity.photos.reduce((acc, photo) => {
        if (photo.includes('_instalatieacm_')) acc = acc + 1
        return acc
      }, 0)
    },
    instalatieacmPhotos () {
      return !this.activeEntity ? [] : this.activeEntity.photos.filter(photo => photo.includes('instalatieacm'))
    },

    entityPdfsInQueue () {
      return !this.activeEntity ? 0 : this.files.filter(file => file.entity === this.activeEntity._id && !file.uploaded && file.tip === 'pdf' && file.parent === 'scara').length
    },
    liftFilesInQueue () {
      return n => {
        return !this.activeEntity ? 0 : this.files.filter(file => file.entity === this.activeEntity._id && !file.uploaded && file.tip === 'photo' && file.parent === `lift${n}`).length
      }
    },
    liftPdfsInQueue () {
      return n => {
        return !this.activeEntity ? 0 : this.files.filter(file => file.entity === this.activeEntity._id && !file.uploaded && file.tip === 'pdf' && file.parent === `lift${n}`).length
      }
    },
    zoom () {
      return this.$store.getters.zoomDetailsPage
    },
    mapType () {
      return this.$store.getters.mapTypeDetailsPage
    },
    settings () {
      return this.$store.getters.settingsDetailsPage
    },
    labels () {
      return this.$store.getters['entities/labels']
    },
    zones () {
      return this.$store.getters['entities/zones']
    },
    noOfEntityPhotos () {
      return !this.activeEntity ? 0 : this.activeEntity.photos.reduce((acc, photo) => {
        if (photo.includes('_scara_')) acc = acc + 1
        return acc
      }, 0)
    },
    noOfEntityPdfs () {
      return !this.activeEntity ? 0 : this.activeEntity.pdfs.reduce((acc, pdf) => {
        if (pdf.includes('_scara_')) acc = acc + 1
        return acc
      }, 0)
    },
    scaraPhotos () {
      return !this.activeEntity ? [] : this.activeEntity.photos.filter(photo => photo.includes('scara'))
    },
    scaraPdfs () {
      return !this.activeEntity ? [] : this.activeEntity.pdfs.filter(pdf => pdf.includes('scara'))
    },
    noOfLiftPhotos () {
      return n => {
        return !this.activeEntity ? 0 : this.activeEntity.photos.reduce((acc, photo) => {
          if (photo.includes(`_lift${n}_`)) acc = acc + 1
          return acc
        }, 0)
      }
    },
    noOfLiftPdfs () {
      return n => {
        return !this.activeEntity ? 0 : this.activeEntity.pdfs.reduce((acc, pdf) => {
          if (pdf.includes(`_lift${n}_`)) acc = acc + 1
          return acc
        }, 0)
      }
    },
    liftPhotos () {
      return n => {
        return !this.activeEntity ? [] : this.activeEntity.photos.filter(photo => photo.includes(`lift${n}`))
      }
    },
    liftPdfs () {
      return n => {
        return !this.activeEntity ? [] : this.activeEntity.pdfs.filter(pdf => pdf.includes(`lift${n}`))
      }
    }
  },
  watch: {
    activeEntity: {
      deep: true,
      immediate: true,
      handler (obj) {
        // will have to refactor
        if (obj) {
          this.entityObject = Object.assign({}, cloneDeep(obj))
          this.$nextTick(() => {
            this.dataLoaded = true
          })
        } else {
          this.dataLoaded = false
          this.entityObject = Object.assign({}, {
            __v: null,
            _id: null,
            addedBy: null,
            adresa: null,
            centru_geometric: { lat: 44.446086, lng: 26.063843 },
            createdAt: null,
            done: 'Nu',
            eticheta: null,
            zona: null,
            id_scara: null,
            info_consum: {
              exista_info: null,
              consum_curent_lift_avizier: null,
              consum_curent_lift_avizier_unitate_masura: null,
              consum_curent_spatii_comune_avizier: null,
              consum_curent_spatii_comune_avizier_unitate_masura: null
            },
            info_lift: [

            ],
            info_scara_blocului: {
              comert_servicii: null,
              etaj_tehnic_vizibil: null,
              nr_apartamente_pe_scara: null,
              nr_niveluri_comert_servicii: null,
              nr_niveluri_vizibile: null,
              reabilitat: null,
              regim_inaltime: 'P'
            },
            nr_lift_scara: null,
            observatii: null,
            observatii_adresa: null,
            pdfs: [],
            photos: [],
            updatedAt: null,
            user: null,
            perete_exterior: {
              disabled: null,
              observatii: null,
              grosime_izolatie: null,
              grosime_izolatie_poza: null,
              grosime_izolatie_nereguli: null,

              tencuiala_cazuta: null,
              tencuiala_cazuta_poza: null,
              tencuiala_cazuta_nereguli: null,

              infiltratii: null,
              infiltratii_poza: null,
              infiltratii_nereguli: null,

              rost_dilatatie: null,
              rost_dilatatie_poza: null,
              rost_dilatatie_nereguli: null,

              interfon_montat_la_fata_iz: null,
              interfon_montat_la_fata_iz_poza: null,
              interfon_montat_la_fata_iz_nereguli: null,

              splituri_in_ext_izolatiei: null,
              splituri_in_ext_izolatiei_poza: null,
              splituri_in_ext_izolatiei_nereguli: null
            },
            tamplarie: {
              disabled: null,
              observatii: null,
              pvc: null,
              pvc_poza: null,
              pvc_nereguli: null,

              grile: null,
              grile_poza: null,
              grile_nereguli: null,

              glafuri_exterioare: null,
              glafuri_exterioare_poza: null,
              glafuri_exterioare_nereguli: null,

              grila_casa_scarii: null,
              grila_casa_scarii_poza: null,
              grila_casa_scarii_nereguli: null,

              folie_producator_indepartata: null,
              folie_producator_indepartata_poza: null,
              folie_producator_indepartata_nereguli: null,

              inchidere_balcoane: null,
              inchidere_balcoane_poza: null,
              inchidere_balcoane_nereguli: null,

              termoizolare_parapet_balc: null,
              termoizolare_parapet_balc_poza: null,
              termoizolare_parapet_balc_nereguli: null,

              placa_acoperire_balcon_ue: null,
              placa_acoperire_balcon_ue_poza: null,
              placa_acoperire_balcon_ue_nereguli: null
            },
            soclu: {
              disabled: null,
              observatii: null,
              grosime_izolatie: null,
              grosime_izolatie_poza: null,
              grosime_izolatie_nereguli: null,

              imbinare_trotuar: null,
              imbinare_trotuar_poza: null,
              imbinare_trotuar_nereguli: null,

              grile_aerisire_subsol: null,
              grile_aerisire_subsol_poza: null,
              grile_aerisire_subsol_nereguli: null,

              profil_lacrimar: null,
              profil_lacrimar_poza: null,
              profil_lacrimar_nereguli: null
            },
            terasa: {
              disabled: null,
              observatii: null,
              balustrada_protectie: null,
              balustrada_protectie_poza: null,
              balustrada_protectie_nereguli: null,

              parafrunzare: null,
              parafrunzare_poza: null,
              parafrunzare_nereguli: null,

              coloane_ventilatie_capace: null,
              coloane_ventilatie_capace_poza: null,
              coloane_ventilatie_capace_nereguli: null,

              inaltare_coloane_ventilatie: null,
              inaltare_coloane_ventilatie_poza: null,
              inaltare_coloane_ventilatie_nereguli: null,

              aeratoare: null,
              aeratoare_poza: null,
              aeratoare_nereguli: null,

              acumulare_apa: null,
              acumulare_apa_poza: null,
              acumulare_apa_nereguli: null,

              strat_carton_bitum_dezlipit: null,
              strat_carton_bitum_dezlipit_poza: null,
              strat_carton_bitum_dezlipit_nereguli: null,

              usa_acces_terasa_pvc: null,
              usa_acces_terasa_pvc_poza: null,
              usa_acces_terasa_pvc_nereguli: null,

              chepeng_terasa_pvc: null,
              chepeng_terasa_pvc_poza: null,
              chepeng_terasa_pvc_nereguli: null,

              jgheab_montat_corect: null,
              jgheab_montat_corect_poza: null,
              jgheab_montat_corect_nereguli: null,

              sort_tabla_atic: null,
              sort_tabla_atic_poza: null,
              sort_tabla_atic_nereguli: null,

              imbinare_carton_bit_perete: null,
              imbinare_carton_bit_perete_poza: null,
              imbinare_carton_bit_perete_nereguli: null,

              rosturi_intre_tronsoane: null,
              rosturi_intre_tronsoane_poza: null,
              rosturi_intre_tronsoane_nereguli: null
            },
            planseu_sub_pod: {
              disabled: null,
              observatii: null,
              grosime_izolatie: null,
              grosime_izolatie_poza: null,
              grosime_izolatie_nereguli: null,

              stare_acoperis_poza: null,
              stare_acoperis_nereguli: null
            },
            planseu_subsol: {
              disabled: null,
              observatii: null,
              grosime_izolatie: null,
              grosime_izolatie_poza: null,
              grosime_izolatie_nereguli: null,

              corpuri_iluminat_scoase_la_ras: null,
              corpuri_iluminat_scoase_la_ras_poza: null,
              corpuri_iluminat_scoase_la_ras_nereguli: null,

              conducte_distrib_scoase_la_ras: null,
              conducte_distrib_scoase_la_ras_poza: null,
              conducte_distrib_scoase_la_ras_nereguli: null,

              usa_subsol: null,
              usa_subsol_poza: null,
              usa_subsol_nereguli: null
            },
            instalatie_incalzire: {
              disabled: null,
              observatii: null,
              inlocuire_conducte_distrib: null,
              inlocuire_conducte_distrib_plastic: [],
              inlocuire_conducte_distrib_poza: null,
              inlocuire_conducte_distrib_nereguli: null,

              izolare_conducte_distrib: null,
              izolare_conducte_distrib_poza: null,
              izolare_conducte_distrib_nereguli: null,

              rpd: null,
              rpd_poza: null,
              rpd_nereguli: null,

              rob_golire_plus_izolare: null,
              rob_golire_plus_izolare_poza: null,
              rob_golire_plus_izolare_nereguli: null
            },
            instalatie_acm: {
              disabled: null,
              observatii: null,
              inlocuire_conducte_distrib: null,
              inlocuire_conducte_distrib_plastic: [],
              inlocuire_conducte_distrib_poza: null,
              inlocuire_conducte_distrib_nereguli: null,

              izolare_conducte_distrib: null,
              izolare_conducte_distrib_poza: null,
              izolare_conducte_distrib_nereguli: null,

              conducta_recirculare: null,
              conducta_recirculare_plastic: [],
              conducta_recirculare_poza: null,
              conducta_recirculare_nereguli: null,

              rob_golire_plus_izolare: null,
              rob_golire_plus_izolare_poza: null,
              rob_golire_plus_izolare_nereguli: null
            }
          })
        }
      }
    },
    settings: {
      immediate: true,
      deep: true,
      handler (val) {
        if (val) {
          if (typeof val === 'string') this.visibleFields = val.split(',')
          else if (Array.isArray(val)) this.visibleFields = val.slice()
        }
      }
    },
    // 'entityObject.info_scara_blocului.nr_niveluri_vizibile' (v) {
    //   this.computeRegimInaltime()
    // },
    // 'entityObject.info_scara_blocului.etaj_tehnic_vizibil' (v) {
    //   this.computeRegimInaltime()
    // },
    // 'entityObject.info_scara_blocului.comert_servicii' (v) {
    //   if (v === 'Nu') this.$set(this.entityObject.info_scara_blocului, 'nr_niveluri_comert_servicii', null)
    //   this.computeRegimInaltime()
    // },
    // 'entityObject.info_scara_blocului.nr_niveluri_comert_servicii' (v) {
    //   this.computeRegimInaltime()
    // },
    isEdited (v) {
      this.$store.commit('setIsDetailsEdited', v)
    }
    // 'entityObject.nr_lift_scara' (nv, ov) {
    //   this.updateInfoLift(nv, ov)
    // }
  },
  methods: {
    selectPhoto (photo) {
      const index = this.toDelete.findIndex(p => p === photo)
      if (index > -1) {
        this.toDelete.splice(index, 1)
      } else {
        this.toDelete.push(photo)
      }
    },
    selectPdf (pdf) {
      const index = this.toDeletePdfs.findIndex(p => p === pdf)
      if (index > -1) {
        this.toDeletePdfs.splice(index, 1)
      } else {
        this.toDeletePdfs.push(pdf)
      }
    },
    _cbAddPhoto (type) {
      const ref = `fileinput${type}`
      if (Array.isArray(this.$refs[ref])) {
        this.$refs[ref][0].click()
      } else {
        this.$refs[ref].click()
      }
    },
    _cbConfirmDelete () {
      this.$dialog
        .confirm({
          title: 'Atentie!',
          body: 'Aceasta operatiune este definitiva!'
        }, {
          okText: 'OK',
          cancelText: 'Mmm, ma mai gandesc',
          animation: 'zoom'
        })
        .then(dialog => {
          this.$store.dispatch('entities/deletePhotos', { entity: this.activeEntity._id, photos: this.toDelete })
          this.toDelete = []
        })
        .catch(() => {
        })
    },
    _cbToggleDeleteMode () {
      this.deleteEnabled = !this.deleteEnabled
      this.toDelete = []

      this.badEnabled = false
      this.toBad = []
    },
    async filesAdded (e, parent) {
      let filesArray = Array.from(e.target.files)
      const ref = `form${parent}`

      this.$store.dispatch('entities/addFiles', { files: filesArray, entity: this.activeEntity._id, tip: 'photo', parent })
      if (Array.isArray(this.$refs[ref])) {
        this.$refs[ref][0].reset()
      } else {
        this.$refs[ref].reset()
      }
    },
    async pdfsAdded (e, parent) {
      let filesArray = Array.from(e.target.files)
      const ref = `pdfform${parent}`

      this.$store.dispatch('entities/addFiles', { files: filesArray, entity: this.activeEntity._id, tip: 'pdf', parent })
      if (Array.isArray(this.$refs[ref])) {
        this.$refs[ref][0].reset()
      } else {
        this.$refs[ref].reset()
      }
    },
    toggle () {
      this.collapsed = !this.collapsed
    },
    getType (fieldValue) {
      switch (fieldValue) {
        case 'eticheta': return 'select'
        case 'zona': return 'select'
        case 'done': return 'boolean'
        case 'id_scara': return 'text'
        case 'adresa': return 'textarea'
        case 'observatii_adresa': return 'textarea'
        case 'centru_geometric': return 'map'
        case 'regim_inaltime': return 'text' // special
        case 'nr_niveluri_vizibile': return 'number' // 3-18
        case 'etaj_tehnic_vizibil': return 'boolean' // da sau nu
        case 'comert_servicii': return 'boolean' // da sau nu
        case 'nr_niveluri_comert_servicii': return 'radio' // 1-3
        case 'reabilitat': return 'boolean' // da sau nu
        case 'nr_apartamente_pe_scara': return 'number' // min 1
        case 'consum_curent_lift_avizier': return 'number'
        case 'consum_curent_lift_avizier_unitate_masura': return 'radio'
        case 'consum_curent_spatii_comune_avizier': return 'number'
        case 'consum_curent_spatii_comune_avizier_unitate_masura': return 'radio'
        case 'nr_lift_scara': return 'radio' // 0, 1, 2, 3
        case 'tip_put': return 'radio' // beton sau metal
        case 'tip_deschidere_usa_put': return 'radio' // manuala, semiautomata, automata
        case 'capacitate_cabina_persoane': return 'number'
        case 'capacitate_cabina_masa': return 'number'
        case 'stare_cabina': return 'radio' // veche sau placata/schimbata
        case 'nr_statii_butoniera': return 'number'
        case 'an_revizie': return 'radio' // <2016, 2017, 2018 sau 2019
        case 'lift_functional': return 'boolean' // da sau nu
        case 'observatii': return 'textarea'
        default: return false
      }
    },
    getMin (fieldValue) {
      switch (fieldValue) {
        case 'nr_niveluri_vizibile': return 3
        // case 'nr_niveluri_comert_servicii': return 1
        case 'nr_apartamente_pe_scara': return 1
        // case 'nr_lift_scara': return 0
      }
    },
    getMax (fieldValue) {
      switch (fieldValue) {
        case 'nr_niveluri_vizibile': return 18
        // case 'nr_niveluri_comert_servicii': return 3
        case 'nr_apartamente_pe_scara': return 999
        // case 'nr_lift_scara': return 3
      }
    },
    getOptions (fieldValue) {
      switch (fieldValue) {
        case 'consum_curent_lift_avizier_unitate_masura': return ['lei', 'kWh/luna']
        case 'consum_curent_spatii_comune_avizier_unitate_masura': return ['lei', 'kWh/luna']
        case 'tip_put': return ['beton', 'metal']
        case 'tip_deschidere_usa_put': return ['manuala', 'semiautomata', 'automata']
        case 'stare_cabina': return ['veche', 'placata/schimbata']
        case 'an_revizie': return ['<2016', '2017', '2018', '2019']
        case 'done': return ['Da', 'Nu']
        case 'etaj_tehnic_vizibil': return ['Da', 'Nu']
        case 'comert_servicii': return ['Da', 'Nu']
        case 'reabilitat': return ['Da', 'Nu']
        case 'lift_functional': return ['Da', 'Nu']
        case 'nr_niveluri_comert_servicii': return [1, 2, 3]
        case 'nr_lift_scara': return [0, 1, 2, 3]
      }
    },
    getRules (fieldValue) {
      switch (fieldValue) {
        case 'id_scara':
        case 'adresa':
        case 'centru_geometric':
        case 'regim_inaltime':
        case 'nr_niveluri_vizibile':
        case 'etaj_tehnic_vizibil':
        case 'comert_servicii':
        case 'reabilitat':
        case 'nr_apartamente_pe_scara':
        case 'consum_curent_lift_spatii_comune_avizier':
        case 'consum_curent_lift_spatii_comune_avizier_unitate_masura':
        case 'consum_curent_lift_spatii_comune_avizier_aplicabilitate':
        case 'nr_lift_scara':
        case 'tip_put':
        case 'tip_deschidere_usa_put':
        case 'capacitate_cabina_persoane':
        case 'capacitate_cabina_masa':
        case 'stare_cabina':
        case 'nr_statii_butoniera':
        case 'an_revizie':
        case 'lift_functional':
        case 'eticheta': return [val => val === null ? 'Camp obligatoriu' : true]
        case 'zona': return [val => val === null ? 'Camp obligatoriu' : true]
        case 'nr_niveluri_comert_servicii': return this.entityObject.comert_servicii ? [val => val === null ? 'Camp obligatoriu' : true] : []
        default: return []
      }
    },
    computeRegimInaltime: debounce(function () {
      let str = 'P'
      if (this.entityObject.info_scara_blocului.comert_servicii) {
        if (this.entityObject.info_scara_blocului.nr_niveluri_comert_servicii > 1) { // 1-3
          if (this.entityObject.info_scara_blocului.nr_niveluri_comert_servicii === 2) { // 1-3
            str += '+M'
          } else {
            str += '+2M'
          }
        }
      }

      if (this.entityObject.info_scara_blocului.nr_niveluri_vizibile) {
        str += `+${this.entityObject.info_scara_blocului.nr_niveluri_vizibile}E`
      }

      if (this.entityObject.info_scara_blocului.etaj_tehnic_vizibil === 'Da') {
        str += '+Eth'
      }

      this.$set(this.entityObject.info_scara_blocului, 'regim_inaltime', str)
    }, 1000),
    save () {
      this.entityObject.user = this.user.username
      this.$store.dispatch('entities/save', this.entityObject)
    },

    zoomChanged: debounce(function ($event) {
      this.$store.commit('setZoomDetailsPage', $event)
    }, 1000),
    mapTypeChanged ($event) {
      this.$store.commit('setMapTypeDetailsPage', $event)
    },

    _cbDragEnd: debounce(function ($event) {
      if (!this.user.dummy) {
        this.$dialog
          .confirm({
            title: 'Atentie!',
            body: 'Ai miscat pin-ul pe harta. Esti sigur ca vrei sa modifici coordonatele?'
          }, {
            okText: 'DA, modific!',
            cancelText: 'Nu, nu modific.',
            animation: 'zoom'
          })
          .then(dialog => {
            this.$set(this.entityObject, 'centru_geometric', { lat: $event.latLng.lat(), lng: $event.latLng.lng() })
          })
          .catch(() => {
            this.$set(this.entityObject, 'centru_geometric', { lat: this.entityObject.centru_geometric.lat, lng: this.entityObject.centru_geometric.lng })
          })
      }
    }, 1000),

    undo (field, parent = null, index = null) {
      if (this.user.dummy) return
      if (field === 'nr_lift_scara') {
        this.entityObject.info_lift = this.activeEntity.info_lift.map(lift => cloneDeep(lift))
      }

      if (field === 'centru_geometric') {
        this.entityObject.centru_geometric.lat = this.activeEntity.centru_geometric.lat
        this.entityObject.centru_geometric.lng = this.activeEntity.centru_geometric.lng
      } else {
        if (!parent) {
          this.$set(this.entityObject, field, this.activeEntity[field])
        } else {
          if (this.entityObject[parent].disabled) return
          if (index !== null) {
            if (this.activeEntity[parent][index]) {
              this.$set(this.entityObject[parent][index], field, this.activeEntity[parent][index][field])
            } else {
              this.$set(this.entityObject[parent][index], field, null)
            }
          } else {
            this.$set(this.entityObject[parent], field, this.activeEntity[parent][field])
          }
        }
      }
    },

    _cbUndoAll () {
      if (this.user.dummy) return
      this.entityObject = Object.assign({}, cloneDeep(this.activeEntity))
    },

    _cbOpenSettings () {
      this.dialog = true
    },
    _cbCloseSettings (mode) {
      if (mode) {
        this.dialog = false
        this.$store.commit('setSettingsDetailsPage', this.visibleFields)
      } else {
        this.dialog = false
      }
    },

    _cbAddPdf (type) {
      const ref = `pdffileinput${type}`
      if (Array.isArray(this.$refs[ref])) {
        this.$refs[ref][0].click()
      } else {
        this.$refs[ref].click()
      }
    },
    _cbToggleDeletePdfsMode () {
      this.deletePdfsEnabled = !this.deletePdfsEnabled
      this.toDeletePdfs = []
    },
    _cbConfirmDeletePdfs () {
      this.$dialog
        .confirm({
          title: 'Atentie!',
          body: 'Aceasta operatiune este definitiva?'
        }, {
          okText: 'OK',
          cancelText: 'Mmm, ma mai gandesc',
          animation: 'zoom'
        })
        .then(dialog => {
          this.$store.dispatch('entities/deletePdfs', { entity: this.activeEntity._id, pdfs: this.toDeletePdfs })
          this.toDeletePdfs = []
        })
        .catch(() => {
        })
    },
    viewPdf (pdf, src) {
      this.pdfFrameSrc = src
      this.pdfFrameTitle = pdf.replace('/pdfs/', '')
      this.pdfDialog = true
    },
    onWheel ($event) {
      if ($event.target.type === 'number') {
        $event.target.blur()
      }
    },
    refreshIdScara () {
      if (this.user.admin) {
        this.entityObject.id_scara = uniqid()
      }
    },
    isFieldEdited (field, parent = null, index = null) {
      // return false
      if (this.activeEntity) {
        if (parent) {
          // if (this.activeEntity[parent] === undefined) return false

          if (index !== null) {
            // eslint-disable-next-line
            if (!this.activeEntity[parent][index]) {
              if (field.includes('plastic')) {
                return Array.isArray(this.entityObject[parent][index][field]) && this.entityObject[parent][index][field].length === 0
              }
              return this.entityObject[parent][index][field] === null
            }
            return this.activeEntity[parent][index][field] !== this.entityObject[parent][index][field]
          } else {
            if (field.includes('plastic')) {
              return JSON.stringify(this.activeEntity[parent][field]) !== JSON.stringify(this.entityObject[parent][field])
            }
            return this.activeEntity[parent][field] !== this.entityObject[parent][field]
          }
        } else {
          if (field === 'centru_geometric') {
            return this.activeEntity[field].lat !== this.entityObject[field].lat || this.activeEntity[field].lng !== this.entityObject[field].lng
          } else {
            return this.activeEntity[field] !== this.entityObject[field]
          }
        }
      }
      return false
    },
    etichetaText (item) {
      return `${item.label} - ${item.data}`
    },
    zonaText (item) {
      return `${item.zona}`
    },
    updateInfoLift (newVal, oldVal) {
      if (newVal === 0 || newVal === null) {
        this.$set(this.entityObject, 'info_lift', [
          {
            tip_put: null,
            tip_deschidere_usa_put: null,
            exista_info_capacitate: null,
            capacitate_cabina_persoane: null,
            capacitate_cabina_kg: null,
            stare_cabina: null,
            nr_statii_butoniera: null,
            an_revizie: null,
            an_next_revizie: null,
            luna_next_revizie: null,
            lift_functional: null
          },
          {
            tip_put: null,
            tip_deschidere_usa_put: null,
            exista_info_capacitate: null,
            capacitate_cabina_persoane: null,
            capacitate_cabina_kg: null,
            stare_cabina: null,
            nr_statii_butoniera: null,
            an_revizie: null,
            an_next_revizie: null,
            luna_next_revizie: null,
            lift_functional: null
          },
          {
            tip_put: null,
            tip_deschidere_usa_put: null,
            exista_info_capacitate: null,
            capacitate_cabina_persoane: null,
            capacitate_cabina_kg: null,
            stare_cabina: null,
            nr_statii_butoniera: null,
            an_revizie: null,
            an_next_revizie: null,
            luna_next_revizie: null,
            lift_functional: null
          }
        ])
      } else {
        // 1 -> 0 -> 0
        // 2 -> 0 -> 0, 1
        // 3 -> 0 -> 0, 1, 2
        // 2 -> 1 -> 1
        // 3 -> 1 -> 1, 2
        // 3 -> 2 -> 2

        // console.log(newVal, oldVal)

        for (let i = newVal; i < oldVal; i++) {
          Object.keys(this.entityObject.info_lift[i]).forEach(key => {
            this.$set(this.entityObject.info_lift[i], key, null)
          })
        }
      }

      this.$set(this.entityObject, 'nr_lift_scara', newVal)
    },
    setField ($value, field, parent = null, index = null, number = false) {
      if (this.user.dummy) return
      if (parent) {
        if (index === null) {
          this[`set_${field}_${parent}`](number ? (isNaN($value) ? null : +$value) : $value)
        } else {
          this[`set_${field}_${parent}_${index}`](number ? (isNaN($value) ? null : +$value) : $value)
        }
      } else {
        this[`set_${field}`](number ? (isNaN($value) ? null : +$value) : $value)
      }
    },

    set_id_scara: debounce(function (value) {
      this.$set(this.entityObject, 'id_scara', value)
    }, 1000),
    set_adresa: debounce(function (value) {
      this.$set(this.entityObject, 'adresa', value)
    }, 1000),
    set_observatii_adresa: debounce(function (value) {
      this.$set(this.entityObject, 'observatii_adresa', value)
    }, 1000),
    set_observatii: debounce(function (value) {
      this.$set(this.entityObject, 'observatii', value)
    }, 1000),
    set_nr_apartamente_pe_scara_info_scara_blocului: debounce(function (value) {
      this.$set(this.entityObject.info_scara_blocului, 'nr_apartamente_pe_scara', value)
    }, 1000),
    set_nr_niveluri_vizibile_info_scara_blocului: debounce(function (value) {
      this.$set(this.entityObject.info_scara_blocului, 'nr_niveluri_vizibile', value)
    }, 1000),
    set_consum_curent_lift_avizier_info_consum: debounce(function (value) {
      this.$set(this.entityObject.info_consum, 'consum_curent_lift_avizier', value)
    }, 1000),
    set_consum_curent_spatii_comune_avizier_info_consum: debounce(function (value) {
      this.$set(this.entityObject.info_consum, 'consum_curent_spatii_comune_avizier', value)
    }, 1000),
    set_capacitate_cabina_persoane_info_lift_0: debounce(function (value) {
      this.$set(this.entityObject.info_lift[0], 'capacitate_cabina_persoane', value)
    }, 1000),
    set_capacitate_cabina_kg_info_lift_0: debounce(function (value) {
      this.$set(this.entityObject.info_lift[0], 'capacitate_cabina_kg', value)
    }, 1000),
    set_nr_statii_butoniera_info_lift_0: debounce(function (value) {
      this.$set(this.entityObject.info_lift[0], 'nr_statii_butoniera', value)
    }, 1000),
    set_capacitate_cabina_persoane_info_lift_1: debounce(function (value) {
      this.$set(this.entityObject.info_lift[1], 'capacitate_cabina_persoane', value)
    }, 1000),
    set_capacitate_cabina_kg_info_lift_1: debounce(function (value) {
      this.$set(this.entityObject.info_lift[1], 'capacitate_cabina_kg', value)
    }, 1000),
    set_nr_statii_butoniera_info_lift_1: debounce(function (value) {
      this.$set(this.entityObject.info_lift[1], 'nr_statii_butoniera', value)
    }, 1000),
    set_capacitate_cabina_persoane_info_lift_2: debounce(function (value) {
      this.$set(this.entityObject.info_lift[2], 'capacitate_cabina_persoane', value)
    }, 1000),
    set_capacitate_cabina_kg_info_lift_2: debounce(function (value) {
      this.$set(this.entityObject.info_lift[2], 'capacitate_cabina_kg', value)
    }, 1000),
    set_nr_statii_butoniera_info_lift_2: debounce(function (value) {
      this.$set(this.entityObject.info_lift[2], 'nr_statii_butoniera', value)
    }, 1000),

    set_grosime_izolatie_perete_exterior: debounce(function (value) {
      this.$set(this.entityObject.perete_exterior, 'grosime_izolatie', value)
    }, 1000),
    set_grosime_izolatie_soclu: debounce(function (value) {
      this.$set(this.entityObject.soclu, 'grosime_izolatie', value)
    }, 1000),
    set_grosime_izolatie_planseu_sub_pod: debounce(function (value) {
      this.$set(this.entityObject.planseu_sub_pod, 'grosime_izolatie', value)
    }, 1000),
    set_grosime_izolatie_planseu_subsol: debounce(function (value) {
      this.$set(this.entityObject.planseu_subsol, 'grosime_izolatie', value)
    }, 1000),

    set_observatii_perete_exterior: debounce(function (value) {
      this.$set(this.entityObject.perete_exterior, 'observatii', value)
    }, 1000),
    set_observatii_tamplarie: debounce(function (value) {
      this.$set(this.entityObject.tamplarie, 'observatii', value)
    }, 1000),
    set_observatii_soclu: debounce(function (value) {
      this.$set(this.entityObject.soclu, 'observatii', value)
    }, 1000),
    set_observatii_terasa: debounce(function (value) {
      this.$set(this.entityObject.terasa, 'observatii', value)
    }, 1000),
    set_observatii_planseu_sub_pod: debounce(function (value) {
      this.$set(this.entityObject.planseu_sub_pod, 'observatii', value)
    }, 1000),
    set_observatii_planseu_subsol: debounce(function (value) {
      this.$set(this.entityObject.planseu_subsol, 'observatii', value)
    }, 1000),
    set_observatii_instalatie_incalzire: debounce(function (value) {
      this.$set(this.entityObject.instalatie_incalzire, 'observatii', value)
    }, 1000),
    set_observatii_instalatie_acm: debounce(function (value) {
      this.$set(this.entityObject.instalatie_acm, 'observatii', value)
    }, 1000),

    copyInfo (field, index) {
      this.$set(this.entityObject.info_lift[index], field, this.entityObject.info_lift[index - 1][field])
    },

    resetField (field, parent = null, index = null) {
      if (this.user.dummy) return
      if (parent) {
        if (this.entityObject[parent].disabled) return
        if (index !== null) {
          this.$set(this.entityObject[parent][index], field, null)
        } else {
          if (field.includes('plastic')) {
            this.$set(this.entityObject[parent], field, [])
          } else {
            this.$set(this.entityObject[parent], field, null)
          }
        }
      } else {
        if (field !== 'centru_geometric') {
          this.$set(this.entityObject, field, field === 'done' ? false : null)
        }
      }
    },

    _cbResetAll () {
      if (this.user.dummy) return
      const fields = [
        { field: 'observatii_adresa', parent: null, index: null },
        { field: 'observatii', parent: null, index: null },
        { field: 'done', parent: null, index: null },
        // { field: 'nr_lift_scara', parent: null, index: null },

        // { field: 'comert_servicii', parent: 'info_scara_blocului', index: null },
        // { field: 'etaj_tehnic_vizibil', parent: 'info_scara_blocului', index: null },
        // { field: 'nr_apartamente_pe_scara', parent: 'info_scara_blocului', index: null },
        // { field: 'nr_niveluri_comert_servicii', parent: 'info_scara_blocului', index: null },
        // { field: 'nr_niveluri_vizibile', parent: 'info_scara_blocului', index: null },
        // { field: 'reabilitat', parent: 'info_scara_blocului', index: null },

        // { field: 'consum_curent_lift_avizier', parent: 'info_consum', index: null },
        // { field: 'consum_curent_lift_avizier_unitate_masura', parent: 'info_consum', index: null },
        // { field: 'consum_curent_spatii_comune_avizier', parent: 'info_consum', index: null },
        // { field: 'consum_curent_spatii_comune_avizier_unitate_masura', parent: 'info_consum', index: null },
        // { field: 'exista_info', parent: 'info_consum', index: null },

        // { field: 'an_next_revizie', parent: 'info_lift', index: 0 },
        // { field: 'an_revizie', parent: 'info_lift', index: 0 },
        // { field: 'capacitate_cabina_kg', parent: 'info_lift', index: 0 },
        // { field: 'capacitate_cabina_persoane', parent: 'info_lift', index: 0 },
        // { field: 'exista_info_capacitate', parent: 'info_lift', index: 0 },
        // { field: 'lift_functional', parent: 'info_lift', index: 0 },
        // { field: 'luna_next_revizie', parent: 'info_lift', index: 0 },
        // { field: 'nr_statii_butoniera', parent: 'info_lift', index: 0 },
        // { field: 'stare_cabina', parent: 'info_lift', index: 0 },
        // { field: 'tip_deschidere_usa_put', parent: 'info_lift', index: 0 },
        // { field: 'tip_put', parent: 'info_lift', index: 0 },

        // { field: 'an_next_revizie', parent: 'info_lift', index: 1 },
        // { field: 'an_revizie', parent: 'info_lift', index: 1 },
        // { field: 'capacitate_cabina_kg', parent: 'info_lift', index: 1 },
        // { field: 'capacitate_cabina_persoane', parent: 'info_lift', index: 1 },
        // { field: 'exista_info_capacitate', parent: 'info_lift', index: 1 },
        // { field: 'lift_functional', parent: 'info_lift', index: 1 },
        // { field: 'luna_next_revizie', parent: 'info_lift', index: 1 },
        // { field: 'nr_statii_butoniera', parent: 'info_lift', index: 1 },
        // { field: 'stare_cabina', parent: 'info_lift', index: 1 },
        // { field: 'tip_deschidere_usa_put', parent: 'info_lift', index: 1 },
        // { field: 'tip_put', parent: 'info_lift', index: 1 },

        // { field: 'an_next_revizie', parent: 'info_lift', index: 2 },
        // { field: 'an_revizie', parent: 'info_lift', index: 2 },
        // { field: 'capacitate_cabina_kg', parent: 'info_lift', index: 2 },
        // { field: 'capacitate_cabina_persoane', parent: 'info_lift', index: 2 },
        // { field: 'exista_info_capacitate', parent: 'info_lift', index: 2 },
        // { field: 'lift_functional', parent: 'info_lift', index: 2 },
        // { field: 'luna_next_revizie', parent: 'info_lift', index: 2 },
        // { field: 'nr_statii_butoniera', parent: 'info_lift', index: 2 },
        // { field: 'stare_cabina', parent: 'info_lift', index: 2 },
        // { field: 'tip_deschidere_usa_put', parent: 'info_lift', index: 2 },
        // { field: 'tip_put', parent: 'info_lift', index: 2 },

        { field: 'disabled', parent: 'perete_exterior', index: null },
        { field: 'observatii', parent: 'perete_exterior', index: null },
        { field: 'grosime_izolatie', parent: 'perete_exterior', index: null },
        { field: 'grosime_izolatie_poza', parent: 'perete_exterior', index: null },
        { field: 'grosime_izolatie_nereguli', parent: 'perete_exterior', index: null },
        { field: 'tencuiala_cazuta', parent: 'perete_exterior', index: null },
        { field: 'tencuiala_cazuta_poza', parent: 'perete_exterior', index: null },
        { field: 'tencuiala_cazuta_nereguli', parent: 'perete_exterior', index: null },
        { field: 'infiltratii', parent: 'perete_exterior', index: null },
        { field: 'infiltratii_poza', parent: 'perete_exterior', index: null },
        { field: 'infiltratii_nereguli', parent: 'perete_exterior', index: null },
        { field: 'rost_dilatatie', parent: 'perete_exterior', index: null },
        { field: 'rost_dilatatie_poza', parent: 'perete_exterior', index: null },
        { field: 'rost_dilatatie_nereguli', parent: 'perete_exterior', index: null },
        { field: 'interfon_montat_la_fata_iz', parent: 'perete_exterior', index: null },
        { field: 'interfon_montat_la_fata_iz_poza', parent: 'perete_exterior', index: null },
        { field: 'interfon_montat_la_fata_iz_nereguli', parent: 'perete_exterior', index: null },
        { field: 'splituri_in_ext_izolatiei', parent: 'perete_exterior', index: null },
        { field: 'splituri_in_ext_izolatiei_poza', parent: 'perete_exterior', index: null },
        { field: 'splituri_in_ext_izolatiei_nereguli', parent: 'perete_exterior', index: null },

        { field: 'pvc', parent: 'tamplarie', index: null },
        { field: 'pvc_poza', parent: 'tamplarie', index: null },
        { field: 'pvc_nereguli', parent: 'tamplarie', index: null },
        { field: 'grile', parent: 'tamplarie', index: null },
        { field: 'grile_poza', parent: 'tamplarie', index: null },
        { field: 'grile_nereguli', parent: 'tamplarie', index: null },
        { field: 'glafuri_exterioare', parent: 'tamplarie', index: null },
        { field: 'glafuri_exterioare_poza', parent: 'tamplarie', index: null },
        { field: 'glafuri_exterioare_nereguli', parent: 'tamplarie', index: null },
        { field: 'grila_casa_scarii', parent: 'tamplarie', index: null },
        { field: 'grila_casa_scarii_poza', parent: 'tamplarie', index: null },
        { field: 'grila_casa_scarii_nereguli', parent: 'tamplarie', index: null },
        { field: 'folie_producator_indepartata', parent: 'tamplarie', index: null },
        { field: 'folie_producator_indepartata_poza', parent: 'tamplarie', index: null },
        { field: 'folie_producator_indepartata_nereguli', parent: 'tamplarie', index: null },
        { field: 'inchidere_balcoane', parent: 'tamplarie', index: null },
        { field: 'inchidere_balcoane_poza', parent: 'tamplarie', index: null },
        { field: 'inchidere_balcoane_nereguli', parent: 'tamplarie', index: null },
        { field: 'termoizolare_parapet_balc', parent: 'tamplarie', index: null },
        { field: 'termoizolare_parapet_balc_poza', parent: 'tamplarie', index: null },
        { field: 'termoizolare_parapet_balc_nereguli', parent: 'tamplarie', index: null },
        { field: 'placa_acoperire_balcon_ue', parent: 'tamplarie', index: null },
        { field: 'placa_acoperire_balcon_ue_poza', parent: 'tamplarie', index: null },
        { field: 'placa_acoperire_balcon_ue_nereguli', parent: 'tamplarie', index: null },

        { field: 'grosime_izolatie', parent: 'soclu', index: null },
        { field: 'grosime_izolatie_poza', parent: 'soclu', index: null },
        { field: 'grosime_izolatie_nereguli', parent: 'soclu', index: null },
        { field: 'imbinare_trotuar', parent: 'soclu', index: null },
        { field: 'imbinare_trotuar_poza', parent: 'soclu', index: null },
        { field: 'imbinare_trotuar_nereguli', parent: 'soclu', index: null },
        { field: 'grile_aerisire_subsol', parent: 'soclu', index: null },
        { field: 'grile_aerisire_subsol_poza', parent: 'soclu', index: null },
        { field: 'grile_aerisire_subsol_nereguli', parent: 'soclu', index: null },
        { field: 'profil_lacrimar', parent: 'soclu', index: null },
        { field: 'profil_lacrimar_poza', parent: 'soclu', index: null },
        { field: 'profil_lacrimar_nereguli', parent: 'soclu', index: null },

        { field: 'balustrada_protectie', parent: 'terasa', index: null },
        { field: 'balustrada_protectie_poza', parent: 'terasa', index: null },
        { field: 'balustrada_protectie_nereguli', parent: 'terasa', index: null },
        { field: 'parafrunzare', parent: 'terasa', index: null },
        { field: 'parafrunzare_poza', parent: 'terasa', index: null },
        { field: 'parafrunzare_nereguli', parent: 'terasa', index: null },
        { field: 'coloane_ventilatie_capace', parent: 'terasa', index: null },
        { field: 'coloane_ventilatie_capace_poza', parent: 'terasa', index: null },
        { field: 'coloane_ventilatie_capace_nereguli', parent: 'terasa', index: null },
        { field: 'inaltare_coloane_ventilatie', parent: 'terasa', index: null },
        { field: 'inaltare_coloane_ventilatie_poza', parent: 'terasa', index: null },
        { field: 'inaltare_coloane_ventilatie_nereguli', parent: 'terasa', index: null },
        { field: 'aeratoare', parent: 'terasa', index: null },
        { field: 'aeratoare_poza', parent: 'terasa', index: null },
        { field: 'aeratoare_nereguli', parent: 'terasa', index: null },
        { field: 'acumulare_apa', parent: 'terasa', index: null },
        { field: 'acumulare_apa_poza', parent: 'terasa', index: null },
        { field: 'acumulare_apa_nereguli', parent: 'terasa', index: null },
        { field: 'strat_carton_bitum_dezlipit', parent: 'terasa', index: null },
        { field: 'strat_carton_bitum_dezlipit_poza', parent: 'terasa', index: null },
        { field: 'strat_carton_bitum_dezlipit_nereguli', parent: 'terasa', index: null },
        { field: 'usa_acces_terasa_pvc', parent: 'terasa', index: null },
        { field: 'usa_acces_terasa_pvc_poza', parent: 'terasa', index: null },
        { field: 'usa_acces_terasa_pvc_nereguli', parent: 'terasa', index: null },
        { field: 'chepeng_terasa_pvc', parent: 'terasa', index: null },
        { field: 'chepeng_terasa_pvc_poza', parent: 'terasa', index: null },
        { field: 'chepeng_terasa_pvc_nereguli', parent: 'terasa', index: null },
        { field: 'jgheab_montat_corect', parent: 'terasa', index: null },
        { field: 'jgheab_montat_corect_poza', parent: 'terasa', index: null },
        { field: 'jgheab_montat_corect_nereguli', parent: 'terasa', index: null },
        { field: 'sort_tabla_atic', parent: 'terasa', index: null },
        { field: 'sort_tabla_atic_poza', parent: 'terasa', index: null },
        { field: 'sort_tabla_atic_nereguli', parent: 'terasa', index: null },
        { field: 'imbinare_carton_bit_perete', parent: 'terasa', index: null },
        { field: 'imbinare_carton_bit_perete_poza', parent: 'terasa', index: null },
        { field: 'imbinare_carton_bit_perete_nereguli', parent: 'terasa', index: null },
        { field: 'rosturi_intre_tronsoane', parent: 'terasa', index: null },
        { field: 'rosturi_intre_tronsoane_poza', parent: 'terasa', index: null },
        { field: 'rosturi_intre_tronsoane_nereguli', parent: 'terasa', index: null },

        { field: 'grosime_izolatie', parent: 'planseu_sub_pod', index: null },
        { field: 'grosime_izolatie_poza', parent: 'planseu_sub_pod', index: null },
        { field: 'grosime_izolatie_nereguli', parent: 'planseu_sub_pod', index: null },
        { field: 'stare_acoperis_poza', parent: 'planseu_sub_pod', index: null },
        { field: 'stare_acoperis_nereguli', parent: 'planseu_sub_pod', index: null },

        { field: 'grosime_izolatie', parent: 'planseu_subsol', index: null },
        { field: 'grosime_izolatie_poza', parent: 'planseu_subsol', index: null },
        { field: 'grosime_izolatie_nereguli', parent: 'planseu_subsol', index: null },
        { field: 'corpuri_iluminat_scoase_la_ras', parent: 'planseu_subsol', index: null },
        { field: 'corpuri_iluminat_scoase_la_ras_poza', parent: 'planseu_subsol', index: null },
        { field: 'corpuri_iluminat_scoase_la_ras_nereguli', parent: 'planseu_subsol', index: null },
        { field: 'conducte_distrib_scoase_la_ras', parent: 'planseu_subsol', index: null },
        { field: 'conducte_distrib_scoase_la_ras_poza', parent: 'planseu_subsol', index: null },
        { field: 'conducte_distrib_scoase_la_ras_nereguli', parent: 'planseu_subsol', index: null },
        { field: 'usa_subsol', parent: 'planseu_subsol', index: null },
        { field: 'usa_subsol_poza', parent: 'planseu_subsol', index: null },
        { field: 'usa_subsol_nereguli', parent: 'planseu_subsol', index: null },

        { field: 'inlocuire_conducte_distrib', parent: 'instalatie_incalzire', index: null },
        { field: 'inlocuire_conducte_distrib_plastic', parent: 'instalatie_incalzire', index: null },
        { field: 'inlocuire_conducte_distrib_poza', parent: 'instalatie_incalzire', index: null },
        { field: 'inlocuire_conducte_distrib_nereguli', parent: 'instalatie_incalzire', index: null },
        { field: 'izolare_conducte_distrib', parent: 'instalatie_incalzire', index: null },
        { field: 'izolare_conducte_distrib_poza', parent: 'instalatie_incalzire', index: null },
        { field: 'izolare_conducte_distrib_nereguli', parent: 'instalatie_incalzire', index: null },
        { field: 'rpd', parent: 'instalatie_incalzire', index: null },
        { field: 'rpd_poza', parent: 'instalatie_incalzire', index: null },
        { field: 'rpd_nereguli', parent: 'instalatie_incalzire', index: null },
        { field: 'rob_golire_plus_izolare', parent: 'instalatie_incalzire', index: null },
        { field: 'rob_golire_plus_izolare_poza', parent: 'instalatie_incalzire', index: null },
        { field: 'rob_golire_plus_izolare_nereguli', parent: 'instalatie_incalzire', index: null },

        { field: 'inlocuire_conducte_distrib', parent: 'instalatie_acm', index: null },
        { field: 'inlocuire_conducte_distrib_plastic', parent: 'instalatie_acm', index: null },
        { field: 'inlocuire_conducte_distrib_poza', parent: 'instalatie_acm', index: null },
        { field: 'inlocuire_conducte_distrib_nereguli', parent: 'instalatie_acm', index: null },
        { field: 'izolare_conducte_distrib', parent: 'instalatie_acm', index: null },
        { field: 'izolare_conducte_distrib_poza', parent: 'instalatie_acm', index: null },
        { field: 'izolare_conducte_distrib_nereguli', parent: 'instalatie_acm', index: null },
        { field: 'conducta_recirculare', parent: 'instalatie_acm', index: null },
        { field: 'conducta_recirculare_plastic', parent: 'instalatie_acm', index: null },
        { field: 'conducta_recirculare_poza', parent: 'instalatie_acm', index: null },
        { field: 'conducta_recirculare_nereguli', parent: 'instalatie_acm', index: null },
        { field: 'rob_golire_plus_izolare', parent: 'instalatie_acm', index: null },
        { field: 'rob_golire_plus_izolare_poza', parent: 'instalatie_acm', index: null },
        { field: 'rob_golire_plus_izolare_nereguli', parent: 'instalatie_acm', index: null }
      ]

      this.$dialog
        .confirm({
          title: 'Atentie!',
          body: 'Esti pe cale sa stergi toate informatiile editabile ale simbolului! Esti sigur ca doresti sa faci asta?'
        }, {
          okText: 'DA',
          cancelText: 'Nu',
          animation: 'zoom'
        })
        .then(dialog => {
          fields.forEach(field => {
            this.resetField(field.field, field.parent, field.index)
          })
        })
        .catch(() => {
        })
    },

    _cbConfirmBad () {
      this.$dialog
        .confirm({
          title: 'Atentie!',
          body: 'Aceasta operatiune este reversibila!'
        }, {
          okText: 'OK',
          cancelText: 'Mmm, ma mai gandesc',
          animation: 'zoom'
        })
        .then(dialog => {
          this.$store.dispatch('entities/badPhotos', { entity: this.activeEntity._id, photos: this.toBad })
          this.toBad = []
          this.badEnabled = false
        })
        .catch(() => {
        })
    },
    _cbToggleBadMode () {
      this.badEnabled = !this.badEnabled
      this.toBad = []
      this.deleteEnabled = false
      this.toDelete = []
    },
    selectBadPhoto (photo) {
      const index = this.toBad.findIndex(p => p === photo)
      if (index > -1) {
        this.toBad.splice(index, 1)
      } else {
        this.toBad.push(photo)
      }
    },

    _cbToggleSectionDisabled (section) {
      if (!this.user.dummy) {
        this.$set(this.entityObject[section], 'disabled', !this.entityObject[section].disabled)
      }
    },

    _cbRefresh () {
      this.dataLoaded = false
      this.$nextTick(() => {
        this.$store.dispatch('entities/setActiveEntity', this.$route.params.entity)
      })
    }
  }
}
</script>

<style lang="stylus">

</style>
